import {NgxsOnChanges, NgxsOnInit, NgxsSimpleChange, Selector, State, StateContext} from "@ngxs/store";
import {Injectable} from "@angular/core";
import {PlansModel} from "../_models/plans.model";


export const _PlansDefault: PlansModel = {
 /* list: [
    {
      "exam": "k12",
      "featured": true,
      "period": "month",
      "trial_period_days": 0,
      "premium_material_id": ["5f684953980c2653d22d2d4a", "5f6849a391cfc10f36227898", "5f6849b0bd264b76844004c8", "5f6849bc980c2653d22d2d67", "5f6849ccbd264b76844004e5", "5f6849d891cfc10f362278b5", "5f6849e6980c2653d22d2d84", "5f6849f491cfc10f362278d2", "5f684a04bd264b7684400502", "5f684953980c2653d22d2d4b", "5f6849a391cfc10f36227899", "5f6849b0bd264b76844004c9", "5f6849bc980c2653d22d2d68", "5f6849ccbd264b76844004e6", "5f6849d891cfc10f362278b6", "5f6849e6980c2653d22d2d85", "5f6849f591cfc10f362278d3", "5f684a04bd264b7684400503", "5f684954980c2653d22d2d4e", "5f6849a491cfc10f3622789c", "5f6849b1bd264b76844004cc", "5f6849bd980c2653d22d2d6b", "5f6849cdbd264b76844004e9", "5f6849d891cfc10f362278b9", "5f6849e7980c2653d22d2d88", "5f6849f591cfc10f362278d6", "5f684a05bd264b7684400506", "5f684954980c2653d22d2d4f", "5f6849a491cfc10f3622789d", "5f6849b1bd264b76844004cd", "5f6849bd980c2653d22d2d6c", "5f6849cdbd264b76844004ea", "5f6849d891cfc10f362278ba", "5f6849e7980c2653d22d2d89", "5f6849f591cfc10f362278d7", "5f684a05bd264b7684400507", "5f684953980c2653d22d2d46", "5f69e6d86811e903a451a555", "5f6849afbd264b76844004c4", "5f6849bb980c2653d22d2d63", "5f6849ccbd264b76844004e1", "5f6849d791cfc10f362278b1", "5f6849e6980c2653d22d2d80", "5f6849f491cfc10f362278ce", "5f684a03bd264b76844004fe", "5f684953980c2653d22d2d47", "5f69e6d86811e903a451a556", "5f6849b0bd264b76844004c5", "5f6849bc980c2653d22d2d64", "5f6849ccbd264b76844004e2", "5f6849d791cfc10f362278b2", "5f6849e6980c2653d22d2d81", "5f6849f491cfc10f362278cf", "5f684a04bd264b76844004ff", "5f684956980c2653d22d2d5e", "5f6849b3bd264b76844004dd", "5f6849bf980c2653d22d2d7b", "5f6849cfbd264b76844004fa", "5f6849da91cfc10f362278c9", "5f6849e9980c2653d22d2d98", "6308ef7c9429464202c30b93", "5f684a07bd264b7684400517", "5f6849a691cfc10f362278ac", "5f6849cfbd264b76844004f9", "5f6849da91cfc10f362278ca", "5f6849e9980c2653d22d2d99", "5f6849f791cfc10f362278e7", "5f684a07bd264b7684400516", "5f684956980c2653d22d2d5f", "5f6849a691cfc10f362278ad", "5f6849b3bd264b76844004dc", "5f6849bf980c2653d22d2d7c", "6308ec4c5ce69d50819ff079", "6308ed2bcf1542c52f78b583", "6308eda8af33d200283532b9", "6308edde8ca283c07f2de18b", "6308ee93bfa3323159c376ca", "6308ef02980d3ebbe3c76439", "6308ef3dc2244ca8d3514aed", "5f6849f791cfc10f362278e6", "6308ec4c5ce69d50819ff076", "6308ed2bcf1542c52f78b580", "6308eda8af33d200283532b6", "6308edde8ca283c07f2de188"],
      "stripe": "price_1QKvOMEy2I3xqILUiLP6CvXx",
      "children": 1,
      "subject": "math_ela",
      "cost": {
        "per_month": 12.99,
        "total": 40,
        "sale": 12.99
      },
      "options": {
        "trial": true,
        "updates": false,
        "money_back": false
      },
      "title": "K12 Premium Math & ELA",
      "description": "Perfect for flexible learning - access expert-led lessons, practice questions, and printable workbooks instantly, with no long-term commitment.",
      "button_text": "TRY 3 DAYS FOR FREE"
    },
    {
      "exam": "k12",
      "featured": false,
      "period": "year",
      "trial_period_days": 0,
      "premium_material_id": ["5f684953980c2653d22d2d4a", "5f6849a391cfc10f36227898", "5f6849b0bd264b76844004c8", "5f6849bc980c2653d22d2d67", "5f6849ccbd264b76844004e5", "5f6849d891cfc10f362278b5", "5f6849e6980c2653d22d2d84", "5f6849f491cfc10f362278d2", "5f684a04bd264b7684400502", "5f684953980c2653d22d2d4b", "5f6849a391cfc10f36227899", "5f6849b0bd264b76844004c9", "5f6849bc980c2653d22d2d68", "5f6849ccbd264b76844004e6", "5f6849d891cfc10f362278b6", "5f6849e6980c2653d22d2d85", "5f6849f591cfc10f362278d3", "5f684a04bd264b7684400503", "5f684954980c2653d22d2d4e", "5f6849a491cfc10f3622789c", "5f6849b1bd264b76844004cc", "5f6849bd980c2653d22d2d6b", "5f6849cdbd264b76844004e9", "5f6849d891cfc10f362278b9", "5f6849e7980c2653d22d2d88", "5f6849f591cfc10f362278d6", "5f684a05bd264b7684400506", "5f684954980c2653d22d2d4f", "5f6849a491cfc10f3622789d", "5f6849b1bd264b76844004cd", "5f6849bd980c2653d22d2d6c", "5f6849cdbd264b76844004ea", "5f6849d891cfc10f362278ba", "5f6849e7980c2653d22d2d89", "5f6849f591cfc10f362278d7", "5f684a05bd264b7684400507", "5f684953980c2653d22d2d46", "5f69e6d86811e903a451a555", "5f6849afbd264b76844004c4", "5f6849bb980c2653d22d2d63", "5f6849ccbd264b76844004e1", "5f6849d791cfc10f362278b1", "5f6849e6980c2653d22d2d80", "5f6849f491cfc10f362278ce", "5f684a03bd264b76844004fe", "5f684953980c2653d22d2d47", "5f69e6d86811e903a451a556", "5f6849b0bd264b76844004c5", "5f6849bc980c2653d22d2d64", "5f6849ccbd264b76844004e2", "5f6849d791cfc10f362278b2", "5f6849e6980c2653d22d2d81", "5f6849f491cfc10f362278cf", "5f684a04bd264b76844004ff", "5f684956980c2653d22d2d5e", "5f6849b3bd264b76844004dd", "5f6849bf980c2653d22d2d7b", "5f6849cfbd264b76844004fa", "5f6849da91cfc10f362278c9", "5f6849e9980c2653d22d2d98", "6308ef7c9429464202c30b93", "5f684a07bd264b7684400517", "5f6849a691cfc10f362278ac", "5f6849cfbd264b76844004f9", "5f6849da91cfc10f362278ca", "5f6849e9980c2653d22d2d99", "5f6849f791cfc10f362278e7", "5f684a07bd264b7684400516", "5f684956980c2653d22d2d5f", "5f6849a691cfc10f362278ad", "5f6849b3bd264b76844004dc", "5f6849bf980c2653d22d2d7c", "6308ec4c5ce69d50819ff079", "6308ed2bcf1542c52f78b583", "6308eda8af33d200283532b9", "6308edde8ca283c07f2de18b", "6308ee93bfa3323159c376ca", "6308ef02980d3ebbe3c76439", "6308ef3dc2244ca8d3514aed", "5f6849f791cfc10f362278e6", "6308ec4c5ce69d50819ff076", "6308ed2bcf1542c52f78b580", "6308eda8af33d200283532b6", "6308edde8ca283c07f2de188"],
      "stripe": "price_1QKvOMEy2I3xqILU6SdguffM",
      "children": 1,
      "subject": "math_ela",
      "cost": {
        "per_month": 9.99,
        "total": 240,
        "sale": 119.99
      },
      "options": {
        "trial": true,
        "updates": true,
        "money_back": false
      },
      "title": "K12 Premium Math & ELA",
      "description": "Most Popular! Save 50% while getting a full year of comprehensive learning. Perfect balance of value and flexibility - complete access to all premium features at our best annual rate.",
      "button_text": "TRY 3 DAYS FOR FREE"
    },
    {
      "exam": "k12",
      "featured": false,
      "period": "lifetime",
      "trial_period_days": 0,
      "premium_material_id": ["5f684953980c2653d22d2d4a", "5f6849a391cfc10f36227898", "5f6849b0bd264b76844004c8", "5f6849bc980c2653d22d2d67", "5f6849ccbd264b76844004e5", "5f6849d891cfc10f362278b5", "5f6849e6980c2653d22d2d84", "5f6849f491cfc10f362278d2", "5f684a04bd264b7684400502", "5f684953980c2653d22d2d4b", "5f6849a391cfc10f36227899", "5f6849b0bd264b76844004c9", "5f6849bc980c2653d22d2d68", "5f6849ccbd264b76844004e6", "5f6849d891cfc10f362278b6", "5f6849e6980c2653d22d2d85", "5f6849f591cfc10f362278d3", "5f684a04bd264b7684400503", "5f684954980c2653d22d2d4e", "5f6849a491cfc10f3622789c", "5f6849b1bd264b76844004cc", "5f6849bd980c2653d22d2d6b", "5f6849cdbd264b76844004e9", "5f6849d891cfc10f362278b9", "5f6849e7980c2653d22d2d88", "5f6849f591cfc10f362278d6", "5f684a05bd264b7684400506", "5f684954980c2653d22d2d4f", "5f6849a491cfc10f3622789d", "5f6849b1bd264b76844004cd", "5f6849bd980c2653d22d2d6c", "5f6849cdbd264b76844004ea", "5f6849d891cfc10f362278ba", "5f6849e7980c2653d22d2d89", "5f6849f591cfc10f362278d7", "5f684a05bd264b7684400507", "5f684953980c2653d22d2d46", "5f69e6d86811e903a451a555", "5f6849afbd264b76844004c4", "5f6849bb980c2653d22d2d63", "5f6849ccbd264b76844004e1", "5f6849d791cfc10f362278b1", "5f6849e6980c2653d22d2d80", "5f6849f491cfc10f362278ce", "5f684a03bd264b76844004fe", "5f684953980c2653d22d2d47", "5f69e6d86811e903a451a556", "5f6849b0bd264b76844004c5", "5f6849bc980c2653d22d2d64", "5f6849ccbd264b76844004e2", "5f6849d791cfc10f362278b2", "5f6849e6980c2653d22d2d81", "5f6849f491cfc10f362278cf", "5f684a04bd264b76844004ff", "5f684956980c2653d22d2d5e", "5f6849b3bd264b76844004dd", "5f6849bf980c2653d22d2d7b", "5f6849cfbd264b76844004fa", "5f6849da91cfc10f362278c9", "5f6849e9980c2653d22d2d98", "6308ef7c9429464202c30b93", "5f684a07bd264b7684400517", "5f6849a691cfc10f362278ac", "5f6849cfbd264b76844004f9", "5f6849da91cfc10f362278ca", "5f6849e9980c2653d22d2d99", "5f6849f791cfc10f362278e7", "5f684a07bd264b7684400516", "5f684956980c2653d22d2d5f", "5f6849a691cfc10f362278ad", "5f6849b3bd264b76844004dc", "5f6849bf980c2653d22d2d7c", "6308ec4c5ce69d50819ff079", "6308ed2bcf1542c52f78b583", "6308eda8af33d200283532b9", "6308edde8ca283c07f2de18b", "6308ee93bfa3323159c376ca", "6308ef02980d3ebbe3c76439", "6308ef3dc2244ca8d3514aed", "5f6849f791cfc10f362278e6", "6308ec4c5ce69d50819ff076", "6308ed2bcf1542c52f78b580", "6308eda8af33d200283532b6", "6308edde8ca283c07f2de188"],
      "stripe": "price_1QKvOMEy2I3xqILUQGwPl6h6",
      "children": 1,
      "subject": "math_ela",
      "cost": {
        "per_month": 3.99,
        "total": 900,
        "sale": 499.99
      },
      "options": {
        "trial": false,
        "updates": true,
        "money_back": true
      },
      "title": "K12 Premium Math & ELA",
      "description": "One-time payment unlocks lifetime access for all your children. Includes every future update and premium feature - invest once, benefit forever. ",
      "button_text": "TRY"
    },

    {
      "exam": "k12",
      "featured": true,
      "period": "month",
      "trial_period_days": 0,
      "premium_material_id": ["5f684953980c2653d22d2d4a", "5f6849a391cfc10f36227898", "5f6849b0bd264b76844004c8", "5f6849bc980c2653d22d2d67", "5f6849ccbd264b76844004e5", "5f6849d891cfc10f362278b5", "5f6849e6980c2653d22d2d84", "5f6849f491cfc10f362278d2", "5f684a04bd264b7684400502", "5f684953980c2653d22d2d4b", "5f6849a391cfc10f36227899", "5f6849b0bd264b76844004c9", "5f6849bc980c2653d22d2d68", "5f6849ccbd264b76844004e6", "5f6849d891cfc10f362278b6", "5f6849e6980c2653d22d2d85", "5f6849f591cfc10f362278d3", "5f684a04bd264b7684400503", "5f684954980c2653d22d2d4e", "5f6849a491cfc10f3622789c", "5f6849b1bd264b76844004cc", "5f6849bd980c2653d22d2d6b", "5f6849cdbd264b76844004e9", "5f6849d891cfc10f362278b9", "5f6849e7980c2653d22d2d88", "5f6849f591cfc10f362278d6", "5f684a05bd264b7684400506", "5f684954980c2653d22d2d4f", "5f6849a491cfc10f3622789d", "5f6849b1bd264b76844004cd", "5f6849bd980c2653d22d2d6c", "5f6849cdbd264b76844004ea", "5f6849d891cfc10f362278ba", "5f6849e7980c2653d22d2d89", "5f6849f591cfc10f362278d7", "5f684a05bd264b7684400507", "5f684953980c2653d22d2d46", "5f69e6d86811e903a451a555", "5f6849afbd264b76844004c4", "5f6849bb980c2653d22d2d63", "5f6849ccbd264b76844004e1", "5f6849d791cfc10f362278b1", "5f6849e6980c2653d22d2d80", "5f6849f491cfc10f362278ce", "5f684a03bd264b76844004fe", "5f684953980c2653d22d2d47", "5f69e6d86811e903a451a556", "5f6849b0bd264b76844004c5", "5f6849bc980c2653d22d2d64", "5f6849ccbd264b76844004e2", "5f6849d791cfc10f362278b2", "5f6849e6980c2653d22d2d81", "5f6849f491cfc10f362278cf", "5f684a04bd264b76844004ff", "5f684956980c2653d22d2d5e", "5f6849b3bd264b76844004dd", "5f6849bf980c2653d22d2d7b", "5f6849cfbd264b76844004fa", "5f6849da91cfc10f362278c9", "5f6849e9980c2653d22d2d98", "6308ef7c9429464202c30b93", "5f684a07bd264b7684400517", "5f6849a691cfc10f362278ac", "5f6849cfbd264b76844004f9", "5f6849da91cfc10f362278ca", "5f6849e9980c2653d22d2d99", "5f6849f791cfc10f362278e7", "5f684a07bd264b7684400516", "5f684956980c2653d22d2d5f", "5f6849a691cfc10f362278ad", "5f6849b3bd264b76844004dc", "5f6849bf980c2653d22d2d7c", "6308ec4c5ce69d50819ff079", "6308ed2bcf1542c52f78b583", "6308eda8af33d200283532b9", "6308edde8ca283c07f2de18b", "6308ee93bfa3323159c376ca", "6308ef02980d3ebbe3c76439", "6308ef3dc2244ca8d3514aed", "5f6849f791cfc10f362278e6", "6308ec4c5ce69d50819ff076", "6308ed2bcf1542c52f78b580", "6308eda8af33d200283532b6", "6308edde8ca283c07f2de188"],
      "stripe": "price_1QKvONEy2I3xqILUsIz6OqVq",
      "children": 2,
      "subject": "math_ela",
      "cost": {
        "per_month": 15.588,
        "total": 48,
        "sale": 15.588
      },
      "options": {
        "trial": true,
        "updates": false,
        "money_back": false
      },
      "title": "K12 Premium Math & ELA",
      "description": "Perfect for flexible learning - access expert-led lessons, practice questions, and printable workbooks instantly, with no long-term commitment.",
      "button_text": "TRY 3 DAYS FOR FREE"
    },
    {
      "exam": "k12",
      "featured": false,
      "period": "year",
      "trial_period_days": 0,
      "premium_material_id": ["5f684953980c2653d22d2d4a", "5f6849a391cfc10f36227898", "5f6849b0bd264b76844004c8", "5f6849bc980c2653d22d2d67", "5f6849ccbd264b76844004e5", "5f6849d891cfc10f362278b5", "5f6849e6980c2653d22d2d84", "5f6849f491cfc10f362278d2", "5f684a04bd264b7684400502", "5f684953980c2653d22d2d4b", "5f6849a391cfc10f36227899", "5f6849b0bd264b76844004c9", "5f6849bc980c2653d22d2d68", "5f6849ccbd264b76844004e6", "5f6849d891cfc10f362278b6", "5f6849e6980c2653d22d2d85", "5f6849f591cfc10f362278d3", "5f684a04bd264b7684400503", "5f684954980c2653d22d2d4e", "5f6849a491cfc10f3622789c", "5f6849b1bd264b76844004cc", "5f6849bd980c2653d22d2d6b", "5f6849cdbd264b76844004e9", "5f6849d891cfc10f362278b9", "5f6849e7980c2653d22d2d88", "5f6849f591cfc10f362278d6", "5f684a05bd264b7684400506", "5f684954980c2653d22d2d4f", "5f6849a491cfc10f3622789d", "5f6849b1bd264b76844004cd", "5f6849bd980c2653d22d2d6c", "5f6849cdbd264b76844004ea", "5f6849d891cfc10f362278ba", "5f6849e7980c2653d22d2d89", "5f6849f591cfc10f362278d7", "5f684a05bd264b7684400507", "5f684953980c2653d22d2d46", "5f69e6d86811e903a451a555", "5f6849afbd264b76844004c4", "5f6849bb980c2653d22d2d63", "5f6849ccbd264b76844004e1", "5f6849d791cfc10f362278b1", "5f6849e6980c2653d22d2d80", "5f6849f491cfc10f362278ce", "5f684a03bd264b76844004fe", "5f684953980c2653d22d2d47", "5f69e6d86811e903a451a556", "5f6849b0bd264b76844004c5", "5f6849bc980c2653d22d2d64", "5f6849ccbd264b76844004e2", "5f6849d791cfc10f362278b2", "5f6849e6980c2653d22d2d81", "5f6849f491cfc10f362278cf", "5f684a04bd264b76844004ff", "5f684956980c2653d22d2d5e", "5f6849b3bd264b76844004dd", "5f6849bf980c2653d22d2d7b", "5f6849cfbd264b76844004fa", "5f6849da91cfc10f362278c9", "5f6849e9980c2653d22d2d98", "6308ef7c9429464202c30b93", "5f684a07bd264b7684400517", "5f6849a691cfc10f362278ac", "5f6849cfbd264b76844004f9", "5f6849da91cfc10f362278ca", "5f6849e9980c2653d22d2d99", "5f6849f791cfc10f362278e7", "5f684a07bd264b7684400516", "5f684956980c2653d22d2d5f", "5f6849a691cfc10f362278ad", "5f6849b3bd264b76844004dc", "5f6849bf980c2653d22d2d7c", "6308ec4c5ce69d50819ff079", "6308ed2bcf1542c52f78b583", "6308eda8af33d200283532b9", "6308edde8ca283c07f2de18b", "6308ee93bfa3323159c376ca", "6308ef02980d3ebbe3c76439", "6308ef3dc2244ca8d3514aed", "5f6849f791cfc10f362278e6", "6308ec4c5ce69d50819ff076", "6308ed2bcf1542c52f78b580", "6308eda8af33d200283532b6", "6308edde8ca283c07f2de188"],
      "stripe": "price_1QKvONEy2I3xqILUAFOErIsX",
      "children": 2,
      "subject": "math_ela",
      "cost": {
        "per_month": 11.988,
        "total": 288,
        "sale": 143.988
      },
      "options": {
        "trial": true,
        "updates": true,
        "money_back": false
      },
      "title": "K12 Premium Math & ELA",
      "description": "Most Popular! Save 50% while getting a full year of comprehensive learning. Perfect balance of value and flexibility - complete access to all premium features at our best annual rate.",
      "button_text": "TRY 3 DAYS FOR FREE"
    },
    {
      "exam": "k12",
      "featured": false,
      "period": "lifetime",
      "trial_period_days": 0,
      "premium_material_id": ["5f684953980c2653d22d2d4a", "5f6849a391cfc10f36227898", "5f6849b0bd264b76844004c8", "5f6849bc980c2653d22d2d67", "5f6849ccbd264b76844004e5", "5f6849d891cfc10f362278b5", "5f6849e6980c2653d22d2d84", "5f6849f491cfc10f362278d2", "5f684a04bd264b7684400502", "5f684953980c2653d22d2d4b", "5f6849a391cfc10f36227899", "5f6849b0bd264b76844004c9", "5f6849bc980c2653d22d2d68", "5f6849ccbd264b76844004e6", "5f6849d891cfc10f362278b6", "5f6849e6980c2653d22d2d85", "5f6849f591cfc10f362278d3", "5f684a04bd264b7684400503", "5f684954980c2653d22d2d4e", "5f6849a491cfc10f3622789c", "5f6849b1bd264b76844004cc", "5f6849bd980c2653d22d2d6b", "5f6849cdbd264b76844004e9", "5f6849d891cfc10f362278b9", "5f6849e7980c2653d22d2d88", "5f6849f591cfc10f362278d6", "5f684a05bd264b7684400506", "5f684954980c2653d22d2d4f", "5f6849a491cfc10f3622789d", "5f6849b1bd264b76844004cd", "5f6849bd980c2653d22d2d6c", "5f6849cdbd264b76844004ea", "5f6849d891cfc10f362278ba", "5f6849e7980c2653d22d2d89", "5f6849f591cfc10f362278d7", "5f684a05bd264b7684400507", "5f684953980c2653d22d2d46", "5f69e6d86811e903a451a555", "5f6849afbd264b76844004c4", "5f6849bb980c2653d22d2d63", "5f6849ccbd264b76844004e1", "5f6849d791cfc10f362278b1", "5f6849e6980c2653d22d2d80", "5f6849f491cfc10f362278ce", "5f684a03bd264b76844004fe", "5f684953980c2653d22d2d47", "5f69e6d86811e903a451a556", "5f6849b0bd264b76844004c5", "5f6849bc980c2653d22d2d64", "5f6849ccbd264b76844004e2", "5f6849d791cfc10f362278b2", "5f6849e6980c2653d22d2d81", "5f6849f491cfc10f362278cf", "5f684a04bd264b76844004ff", "5f684956980c2653d22d2d5e", "5f6849b3bd264b76844004dd", "5f6849bf980c2653d22d2d7b", "5f6849cfbd264b76844004fa", "5f6849da91cfc10f362278c9", "5f6849e9980c2653d22d2d98", "6308ef7c9429464202c30b93", "5f684a07bd264b7684400517", "5f6849a691cfc10f362278ac", "5f6849cfbd264b76844004f9", "5f6849da91cfc10f362278ca", "5f6849e9980c2653d22d2d99", "5f6849f791cfc10f362278e7", "5f684a07bd264b7684400516", "5f684956980c2653d22d2d5f", "5f6849a691cfc10f362278ad", "5f6849b3bd264b76844004dc", "5f6849bf980c2653d22d2d7c", "6308ec4c5ce69d50819ff079", "6308ed2bcf1542c52f78b583", "6308eda8af33d200283532b9", "6308edde8ca283c07f2de18b", "6308ee93bfa3323159c376ca", "6308ef02980d3ebbe3c76439", "6308ef3dc2244ca8d3514aed", "5f6849f791cfc10f362278e6", "6308ec4c5ce69d50819ff076", "6308ed2bcf1542c52f78b580", "6308eda8af33d200283532b6", "6308edde8ca283c07f2de188"],
      "stripe": "price_1QKvONEy2I3xqILUoGdnoZBN",
      "children": 2,
      "subject": "math_ela",
      "cost": {
        "per_month": 4.788,
        "total": 1080,
        "sale": 599.9879999999999
      },
      "options": {
        "trial": false,
        "updates": true,
        "money_back": true
      },
      "title": "K12 Premium Math & ELA",
      "description": "One-time payment unlocks lifetime access for all your children. Includes every future update and premium feature - invest once, benefit forever. ",
      "button_text": "TRY"
    },

    {
      "exam": "k12",
      "featured": true,
      "period": "month",
      "trial_period_days": 0,
      "premium_material_id": ["5f684953980c2653d22d2d4a", "5f6849a391cfc10f36227898", "5f6849b0bd264b76844004c8", "5f6849bc980c2653d22d2d67", "5f6849ccbd264b76844004e5", "5f6849d891cfc10f362278b5", "5f6849e6980c2653d22d2d84", "5f6849f491cfc10f362278d2", "5f684a04bd264b7684400502", "5f684953980c2653d22d2d4b", "5f6849a391cfc10f36227899", "5f6849b0bd264b76844004c9", "5f6849bc980c2653d22d2d68", "5f6849ccbd264b76844004e6", "5f6849d891cfc10f362278b6", "5f6849e6980c2653d22d2d85", "5f6849f591cfc10f362278d3", "5f684a04bd264b7684400503", "5f684954980c2653d22d2d4e", "5f6849a491cfc10f3622789c", "5f6849b1bd264b76844004cc", "5f6849bd980c2653d22d2d6b", "5f6849cdbd264b76844004e9", "5f6849d891cfc10f362278b9", "5f6849e7980c2653d22d2d88", "5f6849f591cfc10f362278d6", "5f684a05bd264b7684400506", "5f684954980c2653d22d2d4f", "5f6849a491cfc10f3622789d", "5f6849b1bd264b76844004cd", "5f6849bd980c2653d22d2d6c", "5f6849cdbd264b76844004ea", "5f6849d891cfc10f362278ba", "5f6849e7980c2653d22d2d89", "5f6849f591cfc10f362278d7", "5f684a05bd264b7684400507", "5f684953980c2653d22d2d46", "5f69e6d86811e903a451a555", "5f6849afbd264b76844004c4", "5f6849bb980c2653d22d2d63", "5f6849ccbd264b76844004e1", "5f6849d791cfc10f362278b1", "5f6849e6980c2653d22d2d80", "5f6849f491cfc10f362278ce", "5f684a03bd264b76844004fe", "5f684953980c2653d22d2d47", "5f69e6d86811e903a451a556", "5f6849b0bd264b76844004c5", "5f6849bc980c2653d22d2d64", "5f6849ccbd264b76844004e2", "5f6849d791cfc10f362278b2", "5f6849e6980c2653d22d2d81", "5f6849f491cfc10f362278cf", "5f684a04bd264b76844004ff", "5f684956980c2653d22d2d5e", "5f6849b3bd264b76844004dd", "5f6849bf980c2653d22d2d7b", "5f6849cfbd264b76844004fa", "5f6849da91cfc10f362278c9", "5f6849e9980c2653d22d2d98", "6308ef7c9429464202c30b93", "5f684a07bd264b7684400517", "5f6849a691cfc10f362278ac", "5f6849cfbd264b76844004f9", "5f6849da91cfc10f362278ca", "5f6849e9980c2653d22d2d99", "5f6849f791cfc10f362278e7", "5f684a07bd264b7684400516", "5f684956980c2653d22d2d5f", "5f6849a691cfc10f362278ad", "5f6849b3bd264b76844004dc", "5f6849bf980c2653d22d2d7c", "6308ec4c5ce69d50819ff079", "6308ed2bcf1542c52f78b583", "6308eda8af33d200283532b9", "6308edde8ca283c07f2de18b", "6308ee93bfa3323159c376ca", "6308ef02980d3ebbe3c76439", "6308ef3dc2244ca8d3514aed", "5f6849f791cfc10f362278e6", "6308ec4c5ce69d50819ff076", "6308ed2bcf1542c52f78b580", "6308eda8af33d200283532b6", "6308edde8ca283c07f2de188"],
      "stripe": "price_1QKvOOEy2I3xqILULD4JUvAy",
      "children": 3,
      "subject": "math_ela",
      "cost": {
        "per_month": 18.186,
        "total": 56,
        "sale": 18.186
      },
      "options": {
        "trial": true,
        "updates": false,
        "money_back": false
      },
      "title": "K12 Premium Math & ELA",
      "description": "Perfect for flexible learning - access expert-led lessons, practice questions, and printable workbooks instantly, with no long-term commitment.",
      "button_text": "TRY 3 DAYS FOR FREE"
    },
    {
      "exam": "k12",
      "featured": false,
      "period": "year",
      "trial_period_days": 0,
      "premium_material_id": ["5f684953980c2653d22d2d4a", "5f6849a391cfc10f36227898", "5f6849b0bd264b76844004c8", "5f6849bc980c2653d22d2d67", "5f6849ccbd264b76844004e5", "5f6849d891cfc10f362278b5", "5f6849e6980c2653d22d2d84", "5f6849f491cfc10f362278d2", "5f684a04bd264b7684400502", "5f684953980c2653d22d2d4b", "5f6849a391cfc10f36227899", "5f6849b0bd264b76844004c9", "5f6849bc980c2653d22d2d68", "5f6849ccbd264b76844004e6", "5f6849d891cfc10f362278b6", "5f6849e6980c2653d22d2d85", "5f6849f591cfc10f362278d3", "5f684a04bd264b7684400503", "5f684954980c2653d22d2d4e", "5f6849a491cfc10f3622789c", "5f6849b1bd264b76844004cc", "5f6849bd980c2653d22d2d6b", "5f6849cdbd264b76844004e9", "5f6849d891cfc10f362278b9", "5f6849e7980c2653d22d2d88", "5f6849f591cfc10f362278d6", "5f684a05bd264b7684400506", "5f684954980c2653d22d2d4f", "5f6849a491cfc10f3622789d", "5f6849b1bd264b76844004cd", "5f6849bd980c2653d22d2d6c", "5f6849cdbd264b76844004ea", "5f6849d891cfc10f362278ba", "5f6849e7980c2653d22d2d89", "5f6849f591cfc10f362278d7", "5f684a05bd264b7684400507", "5f684953980c2653d22d2d46", "5f69e6d86811e903a451a555", "5f6849afbd264b76844004c4", "5f6849bb980c2653d22d2d63", "5f6849ccbd264b76844004e1", "5f6849d791cfc10f362278b1", "5f6849e6980c2653d22d2d80", "5f6849f491cfc10f362278ce", "5f684a03bd264b76844004fe", "5f684953980c2653d22d2d47", "5f69e6d86811e903a451a556", "5f6849b0bd264b76844004c5", "5f6849bc980c2653d22d2d64", "5f6849ccbd264b76844004e2", "5f6849d791cfc10f362278b2", "5f6849e6980c2653d22d2d81", "5f6849f491cfc10f362278cf", "5f684a04bd264b76844004ff", "5f684956980c2653d22d2d5e", "5f6849b3bd264b76844004dd", "5f6849bf980c2653d22d2d7b", "5f6849cfbd264b76844004fa", "5f6849da91cfc10f362278c9", "5f6849e9980c2653d22d2d98", "6308ef7c9429464202c30b93", "5f684a07bd264b7684400517", "5f6849a691cfc10f362278ac", "5f6849cfbd264b76844004f9", "5f6849da91cfc10f362278ca", "5f6849e9980c2653d22d2d99", "5f6849f791cfc10f362278e7", "5f684a07bd264b7684400516", "5f684956980c2653d22d2d5f", "5f6849a691cfc10f362278ad", "5f6849b3bd264b76844004dc", "5f6849bf980c2653d22d2d7c", "6308ec4c5ce69d50819ff079", "6308ed2bcf1542c52f78b583", "6308eda8af33d200283532b9", "6308edde8ca283c07f2de18b", "6308ee93bfa3323159c376ca", "6308ef02980d3ebbe3c76439", "6308ef3dc2244ca8d3514aed", "5f6849f791cfc10f362278e6", "6308ec4c5ce69d50819ff076", "6308ed2bcf1542c52f78b580", "6308eda8af33d200283532b6", "6308edde8ca283c07f2de188"],
      "stripe": "price_1QKvOOEy2I3xqILUQGskUNJX",
      "children": 3,
      "subject": "math_ela",
      "cost": {
        "per_month": 13.985999999999999,
        "total": 336,
        "sale": 167.986
      },
      "options": {
        "trial": true,
        "updates": true,
        "money_back": false
      },
      "title": "K12 Premium Math & ELA",
      "description": "Most Popular! Save 50% while getting a full year of comprehensive learning. Perfect balance of value and flexibility - complete access to all premium features at our best annual rate.",
      "button_text": "TRY 3 DAYS FOR FREE"
    },
    {
      "exam": "k12",
      "featured": false,
      "period": "lifetime",
      "trial_period_days": 0,
      "premium_material_id": ["5f684953980c2653d22d2d4a", "5f6849a391cfc10f36227898", "5f6849b0bd264b76844004c8", "5f6849bc980c2653d22d2d67", "5f6849ccbd264b76844004e5", "5f6849d891cfc10f362278b5", "5f6849e6980c2653d22d2d84", "5f6849f491cfc10f362278d2", "5f684a04bd264b7684400502", "5f684953980c2653d22d2d4b", "5f6849a391cfc10f36227899", "5f6849b0bd264b76844004c9", "5f6849bc980c2653d22d2d68", "5f6849ccbd264b76844004e6", "5f6849d891cfc10f362278b6", "5f6849e6980c2653d22d2d85", "5f6849f591cfc10f362278d3", "5f684a04bd264b7684400503", "5f684954980c2653d22d2d4e", "5f6849a491cfc10f3622789c", "5f6849b1bd264b76844004cc", "5f6849bd980c2653d22d2d6b", "5f6849cdbd264b76844004e9", "5f6849d891cfc10f362278b9", "5f6849e7980c2653d22d2d88", "5f6849f591cfc10f362278d6", "5f684a05bd264b7684400506", "5f684954980c2653d22d2d4f", "5f6849a491cfc10f3622789d", "5f6849b1bd264b76844004cd", "5f6849bd980c2653d22d2d6c", "5f6849cdbd264b76844004ea", "5f6849d891cfc10f362278ba", "5f6849e7980c2653d22d2d89", "5f6849f591cfc10f362278d7", "5f684a05bd264b7684400507", "5f684953980c2653d22d2d46", "5f69e6d86811e903a451a555", "5f6849afbd264b76844004c4", "5f6849bb980c2653d22d2d63", "5f6849ccbd264b76844004e1", "5f6849d791cfc10f362278b1", "5f6849e6980c2653d22d2d80", "5f6849f491cfc10f362278ce", "5f684a03bd264b76844004fe", "5f684953980c2653d22d2d47", "5f69e6d86811e903a451a556", "5f6849b0bd264b76844004c5", "5f6849bc980c2653d22d2d64", "5f6849ccbd264b76844004e2", "5f6849d791cfc10f362278b2", "5f6849e6980c2653d22d2d81", "5f6849f491cfc10f362278cf", "5f684a04bd264b76844004ff", "5f684956980c2653d22d2d5e", "5f6849b3bd264b76844004dd", "5f6849bf980c2653d22d2d7b", "5f6849cfbd264b76844004fa", "5f6849da91cfc10f362278c9", "5f6849e9980c2653d22d2d98", "6308ef7c9429464202c30b93", "5f684a07bd264b7684400517", "5f6849a691cfc10f362278ac", "5f6849cfbd264b76844004f9", "5f6849da91cfc10f362278ca", "5f6849e9980c2653d22d2d99", "5f6849f791cfc10f362278e7", "5f684a07bd264b7684400516", "5f684956980c2653d22d2d5f", "5f6849a691cfc10f362278ad", "5f6849b3bd264b76844004dc", "5f6849bf980c2653d22d2d7c", "6308ec4c5ce69d50819ff079", "6308ed2bcf1542c52f78b583", "6308eda8af33d200283532b9", "6308edde8ca283c07f2de18b", "6308ee93bfa3323159c376ca", "6308ef02980d3ebbe3c76439", "6308ef3dc2244ca8d3514aed", "5f6849f791cfc10f362278e6", "6308ec4c5ce69d50819ff076", "6308ed2bcf1542c52f78b580", "6308eda8af33d200283532b6", "6308edde8ca283c07f2de188"],
      "stripe": "price_1QKvOOEy2I3xqILUCfPwuOtY",
      "children": 3,
      "subject": "math_ela",
      "cost": {
        "per_month": 5.586,
        "total": 1260,
        "sale": 699.986
      },
      "options": {
        "trial": false,
        "updates": true,
        "money_back": true
      },
      "title": "K12 Premium Math & ELA",
      "description": "One-time payment unlocks lifetime access for all your children. Includes every future update and premium feature - invest once, benefit forever. ",
      "button_text": "TRY"
    },

    {
      "exam": "k12",
      "featured": true,
      "period": "month",
      "trial_period_days": 0,
      "premium_material_id": ["5f684953980c2653d22d2d4a", "5f6849a391cfc10f36227898", "5f6849b0bd264b76844004c8", "5f6849bc980c2653d22d2d67", "5f6849ccbd264b76844004e5", "5f6849d891cfc10f362278b5", "5f6849e6980c2653d22d2d84", "5f6849f491cfc10f362278d2", "5f684a04bd264b7684400502", "5f684953980c2653d22d2d4b", "5f6849a391cfc10f36227899", "5f6849b0bd264b76844004c9", "5f6849bc980c2653d22d2d68", "5f6849ccbd264b76844004e6", "5f6849d891cfc10f362278b6", "5f6849e6980c2653d22d2d85", "5f6849f591cfc10f362278d3", "5f684a04bd264b7684400503", "5f684954980c2653d22d2d4e", "5f6849a491cfc10f3622789c", "5f6849b1bd264b76844004cc", "5f6849bd980c2653d22d2d6b", "5f6849cdbd264b76844004e9", "5f6849d891cfc10f362278b9", "5f6849e7980c2653d22d2d88", "5f6849f591cfc10f362278d6", "5f684a05bd264b7684400506", "5f684954980c2653d22d2d4f", "5f6849a491cfc10f3622789d", "5f6849b1bd264b76844004cd", "5f6849bd980c2653d22d2d6c", "5f6849cdbd264b76844004ea", "5f6849d891cfc10f362278ba", "5f6849e7980c2653d22d2d89", "5f6849f591cfc10f362278d7", "5f684a05bd264b7684400507", "5f684953980c2653d22d2d46", "5f69e6d86811e903a451a555", "5f6849afbd264b76844004c4", "5f6849bb980c2653d22d2d63", "5f6849ccbd264b76844004e1", "5f6849d791cfc10f362278b1", "5f6849e6980c2653d22d2d80", "5f6849f491cfc10f362278ce", "5f684a03bd264b76844004fe", "5f684953980c2653d22d2d47", "5f69e6d86811e903a451a556", "5f6849b0bd264b76844004c5", "5f6849bc980c2653d22d2d64", "5f6849ccbd264b76844004e2", "5f6849d791cfc10f362278b2", "5f6849e6980c2653d22d2d81", "5f6849f491cfc10f362278cf", "5f684a04bd264b76844004ff", "5f684956980c2653d22d2d5e", "5f6849b3bd264b76844004dd", "5f6849bf980c2653d22d2d7b", "5f6849cfbd264b76844004fa", "5f6849da91cfc10f362278c9", "5f6849e9980c2653d22d2d98", "6308ef7c9429464202c30b93", "5f684a07bd264b7684400517", "5f6849a691cfc10f362278ac", "5f6849cfbd264b76844004f9", "5f6849da91cfc10f362278ca", "5f6849e9980c2653d22d2d99", "5f6849f791cfc10f362278e7", "5f684a07bd264b7684400516", "5f684956980c2653d22d2d5f", "5f6849a691cfc10f362278ad", "5f6849b3bd264b76844004dc", "5f6849bf980c2653d22d2d7c", "6308ec4c5ce69d50819ff079", "6308ed2bcf1542c52f78b583", "6308eda8af33d200283532b9", "6308edde8ca283c07f2de18b", "6308ee93bfa3323159c376ca", "6308ef02980d3ebbe3c76439", "6308ef3dc2244ca8d3514aed", "5f6849f791cfc10f362278e6", "6308ec4c5ce69d50819ff076", "6308ed2bcf1542c52f78b580", "6308eda8af33d200283532b6", "6308edde8ca283c07f2de188"],
      "stripe": "price_1QKvOPEy2I3xqILUMDXo6t20",
      "children": 4,
      "subject": "math_ela",
      "cost": {
        "per_month": 20.784000000000002,
        "total": 64,
        "sale": 20.784000000000002
      },
      "options": {
        "trial": true,
        "updates": false,
        "money_back": false
      },
      "title": "K12 Premium Math & ELA",
      "description": "Perfect for flexible learning - access expert-led lessons, practice questions, and printable workbooks instantly, with no long-term commitment.",
      "button_text": "TRY 3 DAYS FOR FREE"
    },
    {
      "exam": "k12",
      "featured": false,
      "period": "year",
      "trial_period_days": 0,
      "premium_material_id": ["5f684953980c2653d22d2d4a", "5f6849a391cfc10f36227898", "5f6849b0bd264b76844004c8", "5f6849bc980c2653d22d2d67", "5f6849ccbd264b76844004e5", "5f6849d891cfc10f362278b5", "5f6849e6980c2653d22d2d84", "5f6849f491cfc10f362278d2", "5f684a04bd264b7684400502", "5f684953980c2653d22d2d4b", "5f6849a391cfc10f36227899", "5f6849b0bd264b76844004c9", "5f6849bc980c2653d22d2d68", "5f6849ccbd264b76844004e6", "5f6849d891cfc10f362278b6", "5f6849e6980c2653d22d2d85", "5f6849f591cfc10f362278d3", "5f684a04bd264b7684400503", "5f684954980c2653d22d2d4e", "5f6849a491cfc10f3622789c", "5f6849b1bd264b76844004cc", "5f6849bd980c2653d22d2d6b", "5f6849cdbd264b76844004e9", "5f6849d891cfc10f362278b9", "5f6849e7980c2653d22d2d88", "5f6849f591cfc10f362278d6", "5f684a05bd264b7684400506", "5f684954980c2653d22d2d4f", "5f6849a491cfc10f3622789d", "5f6849b1bd264b76844004cd", "5f6849bd980c2653d22d2d6c", "5f6849cdbd264b76844004ea", "5f6849d891cfc10f362278ba", "5f6849e7980c2653d22d2d89", "5f6849f591cfc10f362278d7", "5f684a05bd264b7684400507", "5f684953980c2653d22d2d46", "5f69e6d86811e903a451a555", "5f6849afbd264b76844004c4", "5f6849bb980c2653d22d2d63", "5f6849ccbd264b76844004e1", "5f6849d791cfc10f362278b1", "5f6849e6980c2653d22d2d80", "5f6849f491cfc10f362278ce", "5f684a03bd264b76844004fe", "5f684953980c2653d22d2d47", "5f69e6d86811e903a451a556", "5f6849b0bd264b76844004c5", "5f6849bc980c2653d22d2d64", "5f6849ccbd264b76844004e2", "5f6849d791cfc10f362278b2", "5f6849e6980c2653d22d2d81", "5f6849f491cfc10f362278cf", "5f684a04bd264b76844004ff", "5f684956980c2653d22d2d5e", "5f6849b3bd264b76844004dd", "5f6849bf980c2653d22d2d7b", "5f6849cfbd264b76844004fa", "5f6849da91cfc10f362278c9", "5f6849e9980c2653d22d2d98", "6308ef7c9429464202c30b93", "5f684a07bd264b7684400517", "5f6849a691cfc10f362278ac", "5f6849cfbd264b76844004f9", "5f6849da91cfc10f362278ca", "5f6849e9980c2653d22d2d99", "5f6849f791cfc10f362278e7", "5f684a07bd264b7684400516", "5f684956980c2653d22d2d5f", "5f6849a691cfc10f362278ad", "5f6849b3bd264b76844004dc", "5f6849bf980c2653d22d2d7c", "6308ec4c5ce69d50819ff079", "6308ed2bcf1542c52f78b583", "6308eda8af33d200283532b9", "6308edde8ca283c07f2de18b", "6308ee93bfa3323159c376ca", "6308ef02980d3ebbe3c76439", "6308ef3dc2244ca8d3514aed", "5f6849f791cfc10f362278e6", "6308ec4c5ce69d50819ff076", "6308ed2bcf1542c52f78b580", "6308eda8af33d200283532b6", "6308edde8ca283c07f2de188"],
      "stripe": "price_1QKvOPEy2I3xqILUkgANkEZ7",
      "children": 4,
      "subject": "math_ela",
      "cost": {
        "per_month": 15.984000000000002,
        "total": 384,
        "sale": 191.984
      },
      "options": {
        "trial": true,
        "updates": true,
        "money_back": false
      },
      "title": "K12 Premium Math & ELA",
      "description": "Most Popular! Save 50% while getting a full year of comprehensive learning. Perfect balance of value and flexibility - complete access to all premium features at our best annual rate.",
      "button_text": "TRY 3 DAYS FOR FREE"
    },
    {
      "exam": "k12",
      "featured": false,
      "period": "lifetime",
      "trial_period_days": 0,
      "premium_material_id": ["5f684953980c2653d22d2d4a", "5f6849a391cfc10f36227898", "5f6849b0bd264b76844004c8", "5f6849bc980c2653d22d2d67", "5f6849ccbd264b76844004e5", "5f6849d891cfc10f362278b5", "5f6849e6980c2653d22d2d84", "5f6849f491cfc10f362278d2", "5f684a04bd264b7684400502", "5f684953980c2653d22d2d4b", "5f6849a391cfc10f36227899", "5f6849b0bd264b76844004c9", "5f6849bc980c2653d22d2d68", "5f6849ccbd264b76844004e6", "5f6849d891cfc10f362278b6", "5f6849e6980c2653d22d2d85", "5f6849f591cfc10f362278d3", "5f684a04bd264b7684400503", "5f684954980c2653d22d2d4e", "5f6849a491cfc10f3622789c", "5f6849b1bd264b76844004cc", "5f6849bd980c2653d22d2d6b", "5f6849cdbd264b76844004e9", "5f6849d891cfc10f362278b9", "5f6849e7980c2653d22d2d88", "5f6849f591cfc10f362278d6", "5f684a05bd264b7684400506", "5f684954980c2653d22d2d4f", "5f6849a491cfc10f3622789d", "5f6849b1bd264b76844004cd", "5f6849bd980c2653d22d2d6c", "5f6849cdbd264b76844004ea", "5f6849d891cfc10f362278ba", "5f6849e7980c2653d22d2d89", "5f6849f591cfc10f362278d7", "5f684a05bd264b7684400507", "5f684953980c2653d22d2d46", "5f69e6d86811e903a451a555", "5f6849afbd264b76844004c4", "5f6849bb980c2653d22d2d63", "5f6849ccbd264b76844004e1", "5f6849d791cfc10f362278b1", "5f6849e6980c2653d22d2d80", "5f6849f491cfc10f362278ce", "5f684a03bd264b76844004fe", "5f684953980c2653d22d2d47", "5f69e6d86811e903a451a556", "5f6849b0bd264b76844004c5", "5f6849bc980c2653d22d2d64", "5f6849ccbd264b76844004e2", "5f6849d791cfc10f362278b2", "5f6849e6980c2653d22d2d81", "5f6849f491cfc10f362278cf", "5f684a04bd264b76844004ff", "5f684956980c2653d22d2d5e", "5f6849b3bd264b76844004dd", "5f6849bf980c2653d22d2d7b", "5f6849cfbd264b76844004fa", "5f6849da91cfc10f362278c9", "5f6849e9980c2653d22d2d98", "6308ef7c9429464202c30b93", "5f684a07bd264b7684400517", "5f6849a691cfc10f362278ac", "5f6849cfbd264b76844004f9", "5f6849da91cfc10f362278ca", "5f6849e9980c2653d22d2d99", "5f6849f791cfc10f362278e7", "5f684a07bd264b7684400516", "5f684956980c2653d22d2d5f", "5f6849a691cfc10f362278ad", "5f6849b3bd264b76844004dc", "5f6849bf980c2653d22d2d7c", "6308ec4c5ce69d50819ff079", "6308ed2bcf1542c52f78b583", "6308eda8af33d200283532b9", "6308edde8ca283c07f2de18b", "6308ee93bfa3323159c376ca", "6308ef02980d3ebbe3c76439", "6308ef3dc2244ca8d3514aed", "5f6849f791cfc10f362278e6", "6308ec4c5ce69d50819ff076", "6308ed2bcf1542c52f78b580", "6308eda8af33d200283532b6", "6308edde8ca283c07f2de188"],
      "stripe": "price_1QKvOPEy2I3xqILUC2z7TVZx",
      "children": 4,
      "subject": "math_ela",
      "cost": {
        "per_month": 6.384,
        "total": 1440,
        "sale": 799.984
      },
      "options": {
        "trial": false,
        "updates": true,
        "money_back": true
      },
      "title": "K12 Premium Math & ELA",
      "description": "One-time payment unlocks lifetime access for all your children. Includes every future update and premium feature - invest once, benefit forever. ",
      "button_text": "TRY"
    },


    {
      "exam": "k12",
      "featured": true,
      "period": "month",
      "trial_period_days": 0,
      "premium_material_id": ["5f684953980c2653d22d2d4a", "5f6849a391cfc10f36227898", "5f6849b0bd264b76844004c8", "5f6849bc980c2653d22d2d67", "5f6849ccbd264b76844004e5", "5f6849d891cfc10f362278b5", "5f6849e6980c2653d22d2d84", "5f6849f491cfc10f362278d2", "5f684a04bd264b7684400502", "5f684953980c2653d22d2d4b", "5f6849a391cfc10f36227899", "5f6849b0bd264b76844004c9", "5f6849bc980c2653d22d2d68", "5f6849ccbd264b76844004e6", "5f6849d891cfc10f362278b6", "5f6849e6980c2653d22d2d85", "5f6849f591cfc10f362278d3", "5f684a04bd264b7684400503", "5f684954980c2653d22d2d50", "5f6849a491cfc10f3622789e", "5f6849b1bd264b76844004ce", "5f6849bc980c2653d22d2d69", "5f6849cdbd264b76844004e7", "5f6849d891cfc10f362278b7", "5f6849e6980c2653d22d2d86", "5f6849f591cfc10f362278d4", "5f684a04bd264b7684400504", "5f684954980c2653d22d2d4e", "5f6849a491cfc10f3622789c", "5f6849b1bd264b76844004cc", "5f6849bd980c2653d22d2d6b", "5f6849cdbd264b76844004e9", "5f6849d891cfc10f362278b9", "5f6849e7980c2653d22d2d88", "5f6849f591cfc10f362278d6", "5f684a05bd264b7684400506", "5f684954980c2653d22d2d4f", "5f6849a491cfc10f3622789d", "5f6849b1bd264b76844004cd", "5f6849bd980c2653d22d2d6c", "5f6849cdbd264b76844004ea", "5f6849d891cfc10f362278ba", "5f6849e7980c2653d22d2d89", "5f6849f591cfc10f362278d7", "5f684a05bd264b7684400507", "5f684954980c2653d22d2d4c", "5f6849a491cfc10f3622789a", "5f6849b0bd264b76844004ca", "5f6849bd980c2653d22d2d6d", "5f6849cdbd264b76844004eb", "5f6849d891cfc10f362278bb", "5f6849e7980c2653d22d2d8a", "5f6849f591cfc10f362278d8", "5f684a05bd264b7684400508", "5f684953980c2653d22d2d46", "5f69e6d86811e903a451a555", "5f6849afbd264b76844004c4", "5f6849bb980c2653d22d2d63", "5f6849ccbd264b76844004e1", "5f6849d791cfc10f362278b1", "5f6849e6980c2653d22d2d80", "5f6849f491cfc10f362278ce", "5f684a03bd264b76844004fe", "5f684953980c2653d22d2d47", "5f69e6d86811e903a451a556", "5f6849b0bd264b76844004c5", "5f6849bc980c2653d22d2d64", "5f6849ccbd264b76844004e2", "5f6849d791cfc10f362278b2", "5f6849e6980c2653d22d2d81", "5f6849f491cfc10f362278cf", "5f684a04bd264b76844004ff", "5f684953980c2653d22d2d48", "5f6849a391cfc10f36227896", "5f6849b0bd264b76844004c6", "5f6849bc980c2653d22d2d65", "5f6849ccbd264b76844004e3", "5f6849d791cfc10f362278b3", "5f6849e6980c2653d22d2d82", "5f6849f491cfc10f362278d0", "5f684a04bd264b7684400500", "5f684956980c2653d22d2d5e", "5f6849a691cfc10f362278ae", "5f6849b3bd264b76844004dd", "5f6849bf980c2653d22d2d7b", "5f6849cfbd264b76844004fa", "5f6849da91cfc10f362278c9", "5f6849e9980c2653d22d2d98", "6308ef7c9429464202c30b93", "5f684a07bd264b7684400517", "5f684956980c2653d22d2d60", "5f6849a691cfc10f362278ac", "5f6849b3bd264b76844004de", "5f6849bf980c2653d22d2d7d", "5f6849cfbd264b76844004f9", "5f6849da91cfc10f362278ca", "5f6849e9980c2653d22d2d99", "5f6849f791cfc10f362278e7", "5f684a07bd264b7684400516", "5f684956980c2653d22d2d5f", "5f6849a691cfc10f362278ad", "5f6849b3bd264b76844004dc", "5f6849bf980c2653d22d2d7c", "5f6849cfbd264b76844004fb", "5f6849db91cfc10f362278cb", "5f6849e9980c2653d22d2d9a", "5f6849f791cfc10f362278e8", "5f684a07bd264b7684400518", "6308ec4c5ce69d50819ff079", "6308ed2bcf1542c52f78b583", "6308eda8af33d200283532b9", "6308edde8ca283c07f2de18b", "6308ee93bfa3323159c376ca", "6308ef02980d3ebbe3c76439", "6308ef3dc2244ca8d3514aed", "5f6849f791cfc10f362278e6", "6308ec4c5ce69d50819ff076", "6308ed2bcf1542c52f78b580", "6308eda8af33d200283532b6", "6308edde8ca283c07f2de188"],
      "stripe": "price_1QKvOQEy2I3xqILUbnQiubRI",
      "children": 1,
      "subject": "math_ela_science",
      "cost": {
        "per_month": 12.99,
        "science_per_month": 4.99,
        "total": 50,
        "sale": 16.98
      },
      "options": {
        "trial": true,
        "updates": false,
        "money_back": false
      },
      "title": "K12 Premium Math & ELA & Science",
      "description": "Perfect for flexible learning - access expert-led lessons, practice questions, and printable workbooks instantly, with no long-term commitment.",
      "button_text": "TRY 3 DAYS FOR FREE"
    },
    {
      "exam": "k12",
      "featured": false,
      "period": "year",
      "trial_period_days": 0,
      "premium_material_id": ["5f684953980c2653d22d2d4a", "5f6849a391cfc10f36227898", "5f6849b0bd264b76844004c8", "5f6849bc980c2653d22d2d67", "5f6849ccbd264b76844004e5", "5f6849d891cfc10f362278b5", "5f6849e6980c2653d22d2d84", "5f6849f491cfc10f362278d2", "5f684a04bd264b7684400502", "5f684953980c2653d22d2d4b", "5f6849a391cfc10f36227899", "5f6849b0bd264b76844004c9", "5f6849bc980c2653d22d2d68", "5f6849ccbd264b76844004e6", "5f6849d891cfc10f362278b6", "5f6849e6980c2653d22d2d85", "5f6849f591cfc10f362278d3", "5f684a04bd264b7684400503", "5f684954980c2653d22d2d50", "5f6849a491cfc10f3622789e", "5f6849b1bd264b76844004ce", "5f6849bc980c2653d22d2d69", "5f6849cdbd264b76844004e7", "5f6849d891cfc10f362278b7", "5f6849e6980c2653d22d2d86", "5f6849f591cfc10f362278d4", "5f684a04bd264b7684400504", "5f684954980c2653d22d2d4e", "5f6849a491cfc10f3622789c", "5f6849b1bd264b76844004cc", "5f6849bd980c2653d22d2d6b", "5f6849cdbd264b76844004e9", "5f6849d891cfc10f362278b9", "5f6849e7980c2653d22d2d88", "5f6849f591cfc10f362278d6", "5f684a05bd264b7684400506", "5f684954980c2653d22d2d4f", "5f6849a491cfc10f3622789d", "5f6849b1bd264b76844004cd", "5f6849bd980c2653d22d2d6c", "5f6849cdbd264b76844004ea", "5f6849d891cfc10f362278ba", "5f6849e7980c2653d22d2d89", "5f6849f591cfc10f362278d7", "5f684a05bd264b7684400507", "5f684954980c2653d22d2d4c", "5f6849a491cfc10f3622789a", "5f6849b0bd264b76844004ca", "5f6849bd980c2653d22d2d6d", "5f6849cdbd264b76844004eb", "5f6849d891cfc10f362278bb", "5f6849e7980c2653d22d2d8a", "5f6849f591cfc10f362278d8", "5f684a05bd264b7684400508", "5f684953980c2653d22d2d46", "5f69e6d86811e903a451a555", "5f6849afbd264b76844004c4", "5f6849bb980c2653d22d2d63", "5f6849ccbd264b76844004e1", "5f6849d791cfc10f362278b1", "5f6849e6980c2653d22d2d80", "5f6849f491cfc10f362278ce", "5f684a03bd264b76844004fe", "5f684953980c2653d22d2d47", "5f69e6d86811e903a451a556", "5f6849b0bd264b76844004c5", "5f6849bc980c2653d22d2d64", "5f6849ccbd264b76844004e2", "5f6849d791cfc10f362278b2", "5f6849e6980c2653d22d2d81", "5f6849f491cfc10f362278cf", "5f684a04bd264b76844004ff", "5f684953980c2653d22d2d48", "5f6849a391cfc10f36227896", "5f6849b0bd264b76844004c6", "5f6849bc980c2653d22d2d65", "5f6849ccbd264b76844004e3", "5f6849d791cfc10f362278b3", "5f6849e6980c2653d22d2d82", "5f6849f491cfc10f362278d0", "5f684a04bd264b7684400500", "5f684956980c2653d22d2d5e", "5f6849a691cfc10f362278ae", "5f6849b3bd264b76844004dd", "5f6849bf980c2653d22d2d7b", "5f6849cfbd264b76844004fa", "5f6849da91cfc10f362278c9", "5f6849e9980c2653d22d2d98", "6308ef7c9429464202c30b93", "5f684a07bd264b7684400517", "5f684956980c2653d22d2d60", "5f6849a691cfc10f362278ac", "5f6849b3bd264b76844004de", "5f6849bf980c2653d22d2d7d", "5f6849cfbd264b76844004f9", "5f6849da91cfc10f362278ca", "5f6849e9980c2653d22d2d99", "5f6849f791cfc10f362278e7", "5f684a07bd264b7684400516", "5f684956980c2653d22d2d5f", "5f6849a691cfc10f362278ad", "5f6849b3bd264b76844004dc", "5f6849bf980c2653d22d2d7c", "5f6849cfbd264b76844004fb", "5f6849db91cfc10f362278cb", "5f6849e9980c2653d22d2d9a", "5f6849f791cfc10f362278e8", "5f684a07bd264b7684400518", "6308ec4c5ce69d50819ff079", "6308ed2bcf1542c52f78b583", "6308eda8af33d200283532b9", "6308edde8ca283c07f2de18b", "6308ee93bfa3323159c376ca", "6308ef02980d3ebbe3c76439", "6308ef3dc2244ca8d3514aed", "5f6849f791cfc10f362278e6", "6308ec4c5ce69d50819ff076", "6308ed2bcf1542c52f78b580", "6308eda8af33d200283532b6", "6308edde8ca283c07f2de188"],
      "stripe": "price_1QKvOQEy2I3xqILUTrAd0nqY",
      "children": 1,
      "subject": "math_ela_science",
      "cost": {
        "per_month": 9.99,
        "science_per_month": 4.99,
        "total": 340,
        "sale": 179.76
      },
      "options": {
        "trial": true,
        "updates": true,
        "money_back": false
      },
      "title": "K12 Premium Math & ELA & Science",
      "description": "Most Popular! Save 50% while getting a full year of comprehensive learning. Perfect balance of value and flexibility - complete access to all premium features at our best annual rate.",
      "button_text": "TRY 3 DAYS FOR FREE"
    },
    {
      "exam": "k12",
      "featured": false,
      "period": "lifetime",
      "trial_period_days": 0,
      "premium_material_id": ["5f684953980c2653d22d2d4a", "5f6849a391cfc10f36227898", "5f6849b0bd264b76844004c8", "5f6849bc980c2653d22d2d67", "5f6849ccbd264b76844004e5", "5f6849d891cfc10f362278b5", "5f6849e6980c2653d22d2d84", "5f6849f491cfc10f362278d2", "5f684a04bd264b7684400502", "5f684953980c2653d22d2d4b", "5f6849a391cfc10f36227899", "5f6849b0bd264b76844004c9", "5f6849bc980c2653d22d2d68", "5f6849ccbd264b76844004e6", "5f6849d891cfc10f362278b6", "5f6849e6980c2653d22d2d85", "5f6849f591cfc10f362278d3", "5f684a04bd264b7684400503", "5f684954980c2653d22d2d50", "5f6849a491cfc10f3622789e", "5f6849b1bd264b76844004ce", "5f6849bc980c2653d22d2d69", "5f6849cdbd264b76844004e7", "5f6849d891cfc10f362278b7", "5f6849e6980c2653d22d2d86", "5f6849f591cfc10f362278d4", "5f684a04bd264b7684400504", "5f684954980c2653d22d2d4e", "5f6849a491cfc10f3622789c", "5f6849b1bd264b76844004cc", "5f6849bd980c2653d22d2d6b", "5f6849cdbd264b76844004e9", "5f6849d891cfc10f362278b9", "5f6849e7980c2653d22d2d88", "5f6849f591cfc10f362278d6", "5f684a05bd264b7684400506", "5f684954980c2653d22d2d4f", "5f6849a491cfc10f3622789d", "5f6849b1bd264b76844004cd", "5f6849bd980c2653d22d2d6c", "5f6849cdbd264b76844004ea", "5f6849d891cfc10f362278ba", "5f6849e7980c2653d22d2d89", "5f6849f591cfc10f362278d7", "5f684a05bd264b7684400507", "5f684954980c2653d22d2d4c", "5f6849a491cfc10f3622789a", "5f6849b0bd264b76844004ca", "5f6849bd980c2653d22d2d6d", "5f6849cdbd264b76844004eb", "5f6849d891cfc10f362278bb", "5f6849e7980c2653d22d2d8a", "5f6849f591cfc10f362278d8", "5f684a05bd264b7684400508", "5f684953980c2653d22d2d46", "5f69e6d86811e903a451a555", "5f6849afbd264b76844004c4", "5f6849bb980c2653d22d2d63", "5f6849ccbd264b76844004e1", "5f6849d791cfc10f362278b1", "5f6849e6980c2653d22d2d80", "5f6849f491cfc10f362278ce", "5f684a03bd264b76844004fe", "5f684953980c2653d22d2d47", "5f69e6d86811e903a451a556", "5f6849b0bd264b76844004c5", "5f6849bc980c2653d22d2d64", "5f6849ccbd264b76844004e2", "5f6849d791cfc10f362278b2", "5f6849e6980c2653d22d2d81", "5f6849f491cfc10f362278cf", "5f684a04bd264b76844004ff", "5f684953980c2653d22d2d48", "5f6849a391cfc10f36227896", "5f6849b0bd264b76844004c6", "5f6849bc980c2653d22d2d65", "5f6849ccbd264b76844004e3", "5f6849d791cfc10f362278b3", "5f6849e6980c2653d22d2d82", "5f6849f491cfc10f362278d0", "5f684a04bd264b7684400500", "5f684956980c2653d22d2d5e", "5f6849a691cfc10f362278ae", "5f6849b3bd264b76844004dd", "5f6849bf980c2653d22d2d7b", "5f6849cfbd264b76844004fa", "5f6849da91cfc10f362278c9", "5f6849e9980c2653d22d2d98", "6308ef7c9429464202c30b93", "5f684a07bd264b7684400517", "5f684956980c2653d22d2d60", "5f6849a691cfc10f362278ac", "5f6849b3bd264b76844004de", "5f6849bf980c2653d22d2d7d", "5f6849cfbd264b76844004f9", "5f6849da91cfc10f362278ca", "5f6849e9980c2653d22d2d99", "5f6849f791cfc10f362278e7", "5f684a07bd264b7684400516", "5f684956980c2653d22d2d5f", "5f6849a691cfc10f362278ad", "5f6849b3bd264b76844004dc", "5f6849bf980c2653d22d2d7c", "5f6849cfbd264b76844004fb", "5f6849db91cfc10f362278cb", "5f6849e9980c2653d22d2d9a", "5f6849f791cfc10f362278e8", "5f684a07bd264b7684400518", "6308ec4c5ce69d50819ff079", "6308ed2bcf1542c52f78b583", "6308eda8af33d200283532b9", "6308edde8ca283c07f2de18b", "6308ee93bfa3323159c376ca", "6308ef02980d3ebbe3c76439", "6308ef3dc2244ca8d3514aed", "5f6849f791cfc10f362278e6", "6308ec4c5ce69d50819ff076", "6308ed2bcf1542c52f78b580", "6308eda8af33d200283532b6", "6308edde8ca283c07f2de188"],
      "stripe": "price_1QKvOQEy2I3xqILUSjutirIk",
      "children": 1,
      "subject": "math_ela_science",
      "cost": {
        "per_month": 3.99,
        "science_per_month": 4.99,
        "total": 1200,
        "sale": 699.99
      },
      "options": {
        "trial": false,
        "updates": true,
        "money_back": true
      },
      "title": "K12 Premium Math & ELA & Science",
      "description": "One-time payment unlocks lifetime access for all your children. Includes every future update and premium feature - invest once, benefit forever. ",
      "button_text": "TRY"
    },

    {
      "exam": "k12",
      "featured": true,
      "period": "month",
      "trial_period_days": 0,
      "premium_material_id": ["5f684953980c2653d22d2d4a", "5f6849a391cfc10f36227898", "5f6849b0bd264b76844004c8", "5f6849bc980c2653d22d2d67", "5f6849ccbd264b76844004e5", "5f6849d891cfc10f362278b5", "5f6849e6980c2653d22d2d84", "5f6849f491cfc10f362278d2", "5f684a04bd264b7684400502", "5f684953980c2653d22d2d4b", "5f6849a391cfc10f36227899", "5f6849b0bd264b76844004c9", "5f6849bc980c2653d22d2d68", "5f6849ccbd264b76844004e6", "5f6849d891cfc10f362278b6", "5f6849e6980c2653d22d2d85", "5f6849f591cfc10f362278d3", "5f684a04bd264b7684400503", "5f684954980c2653d22d2d50", "5f6849a491cfc10f3622789e", "5f6849b1bd264b76844004ce", "5f6849bc980c2653d22d2d69", "5f6849cdbd264b76844004e7", "5f6849d891cfc10f362278b7", "5f6849e6980c2653d22d2d86", "5f6849f591cfc10f362278d4", "5f684a04bd264b7684400504", "5f684954980c2653d22d2d4e", "5f6849a491cfc10f3622789c", "5f6849b1bd264b76844004cc", "5f6849bd980c2653d22d2d6b", "5f6849cdbd264b76844004e9", "5f6849d891cfc10f362278b9", "5f6849e7980c2653d22d2d88", "5f6849f591cfc10f362278d6", "5f684a05bd264b7684400506", "5f684954980c2653d22d2d4f", "5f6849a491cfc10f3622789d", "5f6849b1bd264b76844004cd", "5f6849bd980c2653d22d2d6c", "5f6849cdbd264b76844004ea", "5f6849d891cfc10f362278ba", "5f6849e7980c2653d22d2d89", "5f6849f591cfc10f362278d7", "5f684a05bd264b7684400507", "5f684954980c2653d22d2d4c", "5f6849a491cfc10f3622789a", "5f6849b0bd264b76844004ca", "5f6849bd980c2653d22d2d6d", "5f6849cdbd264b76844004eb", "5f6849d891cfc10f362278bb", "5f6849e7980c2653d22d2d8a", "5f6849f591cfc10f362278d8", "5f684a05bd264b7684400508", "5f684953980c2653d22d2d46", "5f69e6d86811e903a451a555", "5f6849afbd264b76844004c4", "5f6849bb980c2653d22d2d63", "5f6849ccbd264b76844004e1", "5f6849d791cfc10f362278b1", "5f6849e6980c2653d22d2d80", "5f6849f491cfc10f362278ce", "5f684a03bd264b76844004fe", "5f684953980c2653d22d2d47", "5f69e6d86811e903a451a556", "5f6849b0bd264b76844004c5", "5f6849bc980c2653d22d2d64", "5f6849ccbd264b76844004e2", "5f6849d791cfc10f362278b2", "5f6849e6980c2653d22d2d81", "5f6849f491cfc10f362278cf", "5f684a04bd264b76844004ff", "5f684953980c2653d22d2d48", "5f6849a391cfc10f36227896", "5f6849b0bd264b76844004c6", "5f6849bc980c2653d22d2d65", "5f6849ccbd264b76844004e3", "5f6849d791cfc10f362278b3", "5f6849e6980c2653d22d2d82", "5f6849f491cfc10f362278d0", "5f684a04bd264b7684400500", "5f684956980c2653d22d2d5e", "5f6849a691cfc10f362278ae", "5f6849b3bd264b76844004dd", "5f6849bf980c2653d22d2d7b", "5f6849cfbd264b76844004fa", "5f6849da91cfc10f362278c9", "5f6849e9980c2653d22d2d98", "6308ef7c9429464202c30b93", "5f684a07bd264b7684400517", "5f684956980c2653d22d2d60", "5f6849a691cfc10f362278ac", "5f6849b3bd264b76844004de", "5f6849bf980c2653d22d2d7d", "5f6849cfbd264b76844004f9", "5f6849da91cfc10f362278ca", "5f6849e9980c2653d22d2d99", "5f6849f791cfc10f362278e7", "5f684a07bd264b7684400516", "5f684956980c2653d22d2d5f", "5f6849a691cfc10f362278ad", "5f6849b3bd264b76844004dc", "5f6849bf980c2653d22d2d7c", "5f6849cfbd264b76844004fb", "5f6849db91cfc10f362278cb", "5f6849e9980c2653d22d2d9a", "5f6849f791cfc10f362278e8", "5f684a07bd264b7684400518", "6308ec4c5ce69d50819ff079", "6308ed2bcf1542c52f78b583", "6308eda8af33d200283532b9", "6308edde8ca283c07f2de18b", "6308ee93bfa3323159c376ca", "6308ef02980d3ebbe3c76439", "6308ef3dc2244ca8d3514aed", "5f6849f791cfc10f362278e6", "6308ec4c5ce69d50819ff076", "6308ed2bcf1542c52f78b580", "6308eda8af33d200283532b6", "6308edde8ca283c07f2de188"],
      "stripe": "price_1QKvOREy2I3xqILURdNrSyef",
      "children": 2,
      "subject": "math_ela_science",
      "cost": {
        "per_month": 15.588,
        "science_per_month": 5.988,
        "total": 60,
        "sale": 20.376
      },
      "options": {
        "trial": true,
        "updates": false,
        "money_back": false
      },
      "title": "K12 Premium Math & ELA & Science",
      "description": "Perfect for flexible learning - access expert-led lessons, practice questions, and printable workbooks instantly, with no long-term commitment.",
      "button_text": "TRY 3 DAYS FOR FREE"
    },
    {
      "exam": "k12",
      "featured": false,
      "period": "year",
      "trial_period_days": 0,
      "premium_material_id": ["5f684953980c2653d22d2d4a", "5f6849a391cfc10f36227898", "5f6849b0bd264b76844004c8", "5f6849bc980c2653d22d2d67", "5f6849ccbd264b76844004e5", "5f6849d891cfc10f362278b5", "5f6849e6980c2653d22d2d84", "5f6849f491cfc10f362278d2", "5f684a04bd264b7684400502", "5f684953980c2653d22d2d4b", "5f6849a391cfc10f36227899", "5f6849b0bd264b76844004c9", "5f6849bc980c2653d22d2d68", "5f6849ccbd264b76844004e6", "5f6849d891cfc10f362278b6", "5f6849e6980c2653d22d2d85", "5f6849f591cfc10f362278d3", "5f684a04bd264b7684400503", "5f684954980c2653d22d2d50", "5f6849a491cfc10f3622789e", "5f6849b1bd264b76844004ce", "5f6849bc980c2653d22d2d69", "5f6849cdbd264b76844004e7", "5f6849d891cfc10f362278b7", "5f6849e6980c2653d22d2d86", "5f6849f591cfc10f362278d4", "5f684a04bd264b7684400504", "5f684954980c2653d22d2d4e", "5f6849a491cfc10f3622789c", "5f6849b1bd264b76844004cc", "5f6849bd980c2653d22d2d6b", "5f6849cdbd264b76844004e9", "5f6849d891cfc10f362278b9", "5f6849e7980c2653d22d2d88", "5f6849f591cfc10f362278d6", "5f684a05bd264b7684400506", "5f684954980c2653d22d2d4f", "5f6849a491cfc10f3622789d", "5f6849b1bd264b76844004cd", "5f6849bd980c2653d22d2d6c", "5f6849cdbd264b76844004ea", "5f6849d891cfc10f362278ba", "5f6849e7980c2653d22d2d89", "5f6849f591cfc10f362278d7", "5f684a05bd264b7684400507", "5f684954980c2653d22d2d4c", "5f6849a491cfc10f3622789a", "5f6849b0bd264b76844004ca", "5f6849bd980c2653d22d2d6d", "5f6849cdbd264b76844004eb", "5f6849d891cfc10f362278bb", "5f6849e7980c2653d22d2d8a", "5f6849f591cfc10f362278d8", "5f684a05bd264b7684400508", "5f684953980c2653d22d2d46", "5f69e6d86811e903a451a555", "5f6849afbd264b76844004c4", "5f6849bb980c2653d22d2d63", "5f6849ccbd264b76844004e1", "5f6849d791cfc10f362278b1", "5f6849e6980c2653d22d2d80", "5f6849f491cfc10f362278ce", "5f684a03bd264b76844004fe", "5f684953980c2653d22d2d47", "5f69e6d86811e903a451a556", "5f6849b0bd264b76844004c5", "5f6849bc980c2653d22d2d64", "5f6849ccbd264b76844004e2", "5f6849d791cfc10f362278b2", "5f6849e6980c2653d22d2d81", "5f6849f491cfc10f362278cf", "5f684a04bd264b76844004ff", "5f684953980c2653d22d2d48", "5f6849a391cfc10f36227896", "5f6849b0bd264b76844004c6", "5f6849bc980c2653d22d2d65", "5f6849ccbd264b76844004e3", "5f6849d791cfc10f362278b3", "5f6849e6980c2653d22d2d82", "5f6849f491cfc10f362278d0", "5f684a04bd264b7684400500", "5f684956980c2653d22d2d5e", "5f6849a691cfc10f362278ae", "5f6849b3bd264b76844004dd", "5f6849bf980c2653d22d2d7b", "5f6849cfbd264b76844004fa", "5f6849da91cfc10f362278c9", "5f6849e9980c2653d22d2d98", "6308ef7c9429464202c30b93", "5f684a07bd264b7684400517", "5f684956980c2653d22d2d60", "5f6849a691cfc10f362278ac", "5f6849b3bd264b76844004de", "5f6849bf980c2653d22d2d7d", "5f6849cfbd264b76844004f9", "5f6849da91cfc10f362278ca", "5f6849e9980c2653d22d2d99", "5f6849f791cfc10f362278e7", "5f684a07bd264b7684400516", "5f684956980c2653d22d2d5f", "5f6849a691cfc10f362278ad", "5f6849b3bd264b76844004dc", "5f6849bf980c2653d22d2d7c", "5f6849cfbd264b76844004fb", "5f6849db91cfc10f362278cb", "5f6849e9980c2653d22d2d9a", "5f6849f791cfc10f362278e8", "5f684a07bd264b7684400518", "6308ec4c5ce69d50819ff079", "6308ed2bcf1542c52f78b583", "6308eda8af33d200283532b9", "6308edde8ca283c07f2de18b", "6308ee93bfa3323159c376ca", "6308ef02980d3ebbe3c76439", "6308ef3dc2244ca8d3514aed", "5f6849f791cfc10f362278e6", "6308ec4c5ce69d50819ff076", "6308ed2bcf1542c52f78b580", "6308eda8af33d200283532b6", "6308edde8ca283c07f2de188"],
      "stripe": "price_1QKvOREy2I3xqILUDWbcGdYM",
      "children": 2,
      "subject": "math_ela_science",
      "cost": {
        "per_month": 11.988,
        "science_per_month": 5.988,
        "total": 408,
        "sale": 215.712
      },
      "options": {
        "trial": true,
        "updates": true,
        "money_back": false
      },
      "title": "K12 Premium Math & ELA & Science",
      "description": "Most Popular! Save 50% while getting a full year of comprehensive learning. Perfect balance of value and flexibility - complete access to all premium features at our best annual rate.",
      "button_text": "TRY 3 DAYS FOR FREE"
    },
    {
      "exam": "k12",
      "featured": false,
      "period": "lifetime",
      "trial_period_days": 0,
      "premium_material_id": ["5f684953980c2653d22d2d4a", "5f6849a391cfc10f36227898", "5f6849b0bd264b76844004c8", "5f6849bc980c2653d22d2d67", "5f6849ccbd264b76844004e5", "5f6849d891cfc10f362278b5", "5f6849e6980c2653d22d2d84", "5f6849f491cfc10f362278d2", "5f684a04bd264b7684400502", "5f684953980c2653d22d2d4b", "5f6849a391cfc10f36227899", "5f6849b0bd264b76844004c9", "5f6849bc980c2653d22d2d68", "5f6849ccbd264b76844004e6", "5f6849d891cfc10f362278b6", "5f6849e6980c2653d22d2d85", "5f6849f591cfc10f362278d3", "5f684a04bd264b7684400503", "5f684954980c2653d22d2d50", "5f6849a491cfc10f3622789e", "5f6849b1bd264b76844004ce", "5f6849bc980c2653d22d2d69", "5f6849cdbd264b76844004e7", "5f6849d891cfc10f362278b7", "5f6849e6980c2653d22d2d86", "5f6849f591cfc10f362278d4", "5f684a04bd264b7684400504", "5f684954980c2653d22d2d4e", "5f6849a491cfc10f3622789c", "5f6849b1bd264b76844004cc", "5f6849bd980c2653d22d2d6b", "5f6849cdbd264b76844004e9", "5f6849d891cfc10f362278b9", "5f6849e7980c2653d22d2d88", "5f6849f591cfc10f362278d6", "5f684a05bd264b7684400506", "5f684954980c2653d22d2d4f", "5f6849a491cfc10f3622789d", "5f6849b1bd264b76844004cd", "5f6849bd980c2653d22d2d6c", "5f6849cdbd264b76844004ea", "5f6849d891cfc10f362278ba", "5f6849e7980c2653d22d2d89", "5f6849f591cfc10f362278d7", "5f684a05bd264b7684400507", "5f684954980c2653d22d2d4c", "5f6849a491cfc10f3622789a", "5f6849b0bd264b76844004ca", "5f6849bd980c2653d22d2d6d", "5f6849cdbd264b76844004eb", "5f6849d891cfc10f362278bb", "5f6849e7980c2653d22d2d8a", "5f6849f591cfc10f362278d8", "5f684a05bd264b7684400508", "5f684953980c2653d22d2d46", "5f69e6d86811e903a451a555", "5f6849afbd264b76844004c4", "5f6849bb980c2653d22d2d63", "5f6849ccbd264b76844004e1", "5f6849d791cfc10f362278b1", "5f6849e6980c2653d22d2d80", "5f6849f491cfc10f362278ce", "5f684a03bd264b76844004fe", "5f684953980c2653d22d2d47", "5f69e6d86811e903a451a556", "5f6849b0bd264b76844004c5", "5f6849bc980c2653d22d2d64", "5f6849ccbd264b76844004e2", "5f6849d791cfc10f362278b2", "5f6849e6980c2653d22d2d81", "5f6849f491cfc10f362278cf", "5f684a04bd264b76844004ff", "5f684953980c2653d22d2d48", "5f6849a391cfc10f36227896", "5f6849b0bd264b76844004c6", "5f6849bc980c2653d22d2d65", "5f6849ccbd264b76844004e3", "5f6849d791cfc10f362278b3", "5f6849e6980c2653d22d2d82", "5f6849f491cfc10f362278d0", "5f684a04bd264b7684400500", "5f684956980c2653d22d2d5e", "5f6849a691cfc10f362278ae", "5f6849b3bd264b76844004dd", "5f6849bf980c2653d22d2d7b", "5f6849cfbd264b76844004fa", "5f6849da91cfc10f362278c9", "5f6849e9980c2653d22d2d98", "6308ef7c9429464202c30b93", "5f684a07bd264b7684400517", "5f684956980c2653d22d2d60", "5f6849a691cfc10f362278ac", "5f6849b3bd264b76844004de", "5f6849bf980c2653d22d2d7d", "5f6849cfbd264b76844004f9", "5f6849da91cfc10f362278ca", "5f6849e9980c2653d22d2d99", "5f6849f791cfc10f362278e7", "5f684a07bd264b7684400516", "5f684956980c2653d22d2d5f", "5f6849a691cfc10f362278ad", "5f6849b3bd264b76844004dc", "5f6849bf980c2653d22d2d7c", "5f6849cfbd264b76844004fb", "5f6849db91cfc10f362278cb", "5f6849e9980c2653d22d2d9a", "5f6849f791cfc10f362278e8", "5f684a07bd264b7684400518", "6308ec4c5ce69d50819ff079", "6308ed2bcf1542c52f78b583", "6308eda8af33d200283532b9", "6308edde8ca283c07f2de18b", "6308ee93bfa3323159c376ca", "6308ef02980d3ebbe3c76439", "6308ef3dc2244ca8d3514aed", "5f6849f791cfc10f362278e6", "6308ec4c5ce69d50819ff076", "6308ed2bcf1542c52f78b580", "6308eda8af33d200283532b6", "6308edde8ca283c07f2de188"],
      "stripe": "price_1QKvOREy2I3xqILUlhzCZdjg",
      "children": 2,
      "subject": "math_ela_science",
      "cost": {
        "per_month": 4.788,
        "science_per_month": 5.988,
        "total": 1440,
        "sale": 839.9879999999999
      },
      "options": {
        "trial": false,
        "updates": true,
        "money_back": true
      },
      "title": "K12 Premium Math & ELA & Science",
      "description": "One-time payment unlocks lifetime access for all your children. Includes every future update and premium feature - invest once, benefit forever. ",
      "button_text": "TRY"
    },

    {
      "exam": "k12",
      "featured": true,
      "period": "month",
      "trial_period_days": 0,
      "premium_material_id": ["5f684953980c2653d22d2d4a", "5f6849a391cfc10f36227898", "5f6849b0bd264b76844004c8", "5f6849bc980c2653d22d2d67", "5f6849ccbd264b76844004e5", "5f6849d891cfc10f362278b5", "5f6849e6980c2653d22d2d84", "5f6849f491cfc10f362278d2", "5f684a04bd264b7684400502", "5f684953980c2653d22d2d4b", "5f6849a391cfc10f36227899", "5f6849b0bd264b76844004c9", "5f6849bc980c2653d22d2d68", "5f6849ccbd264b76844004e6", "5f6849d891cfc10f362278b6", "5f6849e6980c2653d22d2d85", "5f6849f591cfc10f362278d3", "5f684a04bd264b7684400503", "5f684954980c2653d22d2d50", "5f6849a491cfc10f3622789e", "5f6849b1bd264b76844004ce", "5f6849bc980c2653d22d2d69", "5f6849cdbd264b76844004e7", "5f6849d891cfc10f362278b7", "5f6849e6980c2653d22d2d86", "5f6849f591cfc10f362278d4", "5f684a04bd264b7684400504", "5f684954980c2653d22d2d4e", "5f6849a491cfc10f3622789c", "5f6849b1bd264b76844004cc", "5f6849bd980c2653d22d2d6b", "5f6849cdbd264b76844004e9", "5f6849d891cfc10f362278b9", "5f6849e7980c2653d22d2d88", "5f6849f591cfc10f362278d6", "5f684a05bd264b7684400506", "5f684954980c2653d22d2d4f", "5f6849a491cfc10f3622789d", "5f6849b1bd264b76844004cd", "5f6849bd980c2653d22d2d6c", "5f6849cdbd264b76844004ea", "5f6849d891cfc10f362278ba", "5f6849e7980c2653d22d2d89", "5f6849f591cfc10f362278d7", "5f684a05bd264b7684400507", "5f684954980c2653d22d2d4c", "5f6849a491cfc10f3622789a", "5f6849b0bd264b76844004ca", "5f6849bd980c2653d22d2d6d", "5f6849cdbd264b76844004eb", "5f6849d891cfc10f362278bb", "5f6849e7980c2653d22d2d8a", "5f6849f591cfc10f362278d8", "5f684a05bd264b7684400508", "5f684953980c2653d22d2d46", "5f69e6d86811e903a451a555", "5f6849afbd264b76844004c4", "5f6849bb980c2653d22d2d63", "5f6849ccbd264b76844004e1", "5f6849d791cfc10f362278b1", "5f6849e6980c2653d22d2d80", "5f6849f491cfc10f362278ce", "5f684a03bd264b76844004fe", "5f684953980c2653d22d2d47", "5f69e6d86811e903a451a556", "5f6849b0bd264b76844004c5", "5f6849bc980c2653d22d2d64", "5f6849ccbd264b76844004e2", "5f6849d791cfc10f362278b2", "5f6849e6980c2653d22d2d81", "5f6849f491cfc10f362278cf", "5f684a04bd264b76844004ff", "5f684953980c2653d22d2d48", "5f6849a391cfc10f36227896", "5f6849b0bd264b76844004c6", "5f6849bc980c2653d22d2d65", "5f6849ccbd264b76844004e3", "5f6849d791cfc10f362278b3", "5f6849e6980c2653d22d2d82", "5f6849f491cfc10f362278d0", "5f684a04bd264b7684400500", "5f684956980c2653d22d2d5e", "5f6849a691cfc10f362278ae", "5f6849b3bd264b76844004dd", "5f6849bf980c2653d22d2d7b", "5f6849cfbd264b76844004fa", "5f6849da91cfc10f362278c9", "5f6849e9980c2653d22d2d98", "6308ef7c9429464202c30b93", "5f684a07bd264b7684400517", "5f684956980c2653d22d2d60", "5f6849a691cfc10f362278ac", "5f6849b3bd264b76844004de", "5f6849bf980c2653d22d2d7d", "5f6849cfbd264b76844004f9", "5f6849da91cfc10f362278ca", "5f6849e9980c2653d22d2d99", "5f6849f791cfc10f362278e7", "5f684a07bd264b7684400516", "5f684956980c2653d22d2d5f", "5f6849a691cfc10f362278ad", "5f6849b3bd264b76844004dc", "5f6849bf980c2653d22d2d7c", "5f6849cfbd264b76844004fb", "5f6849db91cfc10f362278cb", "5f6849e9980c2653d22d2d9a", "5f6849f791cfc10f362278e8", "5f684a07bd264b7684400518", "6308ec4c5ce69d50819ff079", "6308ed2bcf1542c52f78b583", "6308eda8af33d200283532b9", "6308edde8ca283c07f2de18b", "6308ee93bfa3323159c376ca", "6308ef02980d3ebbe3c76439", "6308ef3dc2244ca8d3514aed", "5f6849f791cfc10f362278e6", "6308ec4c5ce69d50819ff076", "6308ed2bcf1542c52f78b580", "6308eda8af33d200283532b6", "6308edde8ca283c07f2de188"],
      "stripe": "price_1QKvOSEy2I3xqILUUM5uxxxv",
      "children": 3,
      "subject": "math_ela_science",
      "cost": {
        "per_month": 18.186,
        "science_per_month": 6.986,
        "total": 70,
        "sale": 23.772
      },
      "options": {
        "trial": true,
        "updates": false,
        "money_back": false
      },
      "title": "K12 Premium Math & ELA & Science",
      "description": "Perfect for flexible learning - access expert-led lessons, practice questions, and printable workbooks instantly, with no long-term commitment.",
      "button_text": "TRY 3 DAYS FOR FREE"
    },
    {
      "exam": "k12",
      "featured": false,
      "period": "year",
      "trial_period_days": 0,
      "premium_material_id": ["5f684953980c2653d22d2d4a", "5f6849a391cfc10f36227898", "5f6849b0bd264b76844004c8", "5f6849bc980c2653d22d2d67", "5f6849ccbd264b76844004e5", "5f6849d891cfc10f362278b5", "5f6849e6980c2653d22d2d84", "5f6849f491cfc10f362278d2", "5f684a04bd264b7684400502", "5f684953980c2653d22d2d4b", "5f6849a391cfc10f36227899", "5f6849b0bd264b76844004c9", "5f6849bc980c2653d22d2d68", "5f6849ccbd264b76844004e6", "5f6849d891cfc10f362278b6", "5f6849e6980c2653d22d2d85", "5f6849f591cfc10f362278d3", "5f684a04bd264b7684400503", "5f684954980c2653d22d2d50", "5f6849a491cfc10f3622789e", "5f6849b1bd264b76844004ce", "5f6849bc980c2653d22d2d69", "5f6849cdbd264b76844004e7", "5f6849d891cfc10f362278b7", "5f6849e6980c2653d22d2d86", "5f6849f591cfc10f362278d4", "5f684a04bd264b7684400504", "5f684954980c2653d22d2d4e", "5f6849a491cfc10f3622789c", "5f6849b1bd264b76844004cc", "5f6849bd980c2653d22d2d6b", "5f6849cdbd264b76844004e9", "5f6849d891cfc10f362278b9", "5f6849e7980c2653d22d2d88", "5f6849f591cfc10f362278d6", "5f684a05bd264b7684400506", "5f684954980c2653d22d2d4f", "5f6849a491cfc10f3622789d", "5f6849b1bd264b76844004cd", "5f6849bd980c2653d22d2d6c", "5f6849cdbd264b76844004ea", "5f6849d891cfc10f362278ba", "5f6849e7980c2653d22d2d89", "5f6849f591cfc10f362278d7", "5f684a05bd264b7684400507", "5f684954980c2653d22d2d4c", "5f6849a491cfc10f3622789a", "5f6849b0bd264b76844004ca", "5f6849bd980c2653d22d2d6d", "5f6849cdbd264b76844004eb", "5f6849d891cfc10f362278bb", "5f6849e7980c2653d22d2d8a", "5f6849f591cfc10f362278d8", "5f684a05bd264b7684400508", "5f684953980c2653d22d2d46", "5f69e6d86811e903a451a555", "5f6849afbd264b76844004c4", "5f6849bb980c2653d22d2d63", "5f6849ccbd264b76844004e1", "5f6849d791cfc10f362278b1", "5f6849e6980c2653d22d2d80", "5f6849f491cfc10f362278ce", "5f684a03bd264b76844004fe", "5f684953980c2653d22d2d47", "5f69e6d86811e903a451a556", "5f6849b0bd264b76844004c5", "5f6849bc980c2653d22d2d64", "5f6849ccbd264b76844004e2", "5f6849d791cfc10f362278b2", "5f6849e6980c2653d22d2d81", "5f6849f491cfc10f362278cf", "5f684a04bd264b76844004ff", "5f684953980c2653d22d2d48", "5f6849a391cfc10f36227896", "5f6849b0bd264b76844004c6", "5f6849bc980c2653d22d2d65", "5f6849ccbd264b76844004e3", "5f6849d791cfc10f362278b3", "5f6849e6980c2653d22d2d82", "5f6849f491cfc10f362278d0", "5f684a04bd264b7684400500", "5f684956980c2653d22d2d5e", "5f6849a691cfc10f362278ae", "5f6849b3bd264b76844004dd", "5f6849bf980c2653d22d2d7b", "5f6849cfbd264b76844004fa", "5f6849da91cfc10f362278c9", "5f6849e9980c2653d22d2d98", "6308ef7c9429464202c30b93", "5f684a07bd264b7684400517", "5f684956980c2653d22d2d60", "5f6849a691cfc10f362278ac", "5f6849b3bd264b76844004de", "5f6849bf980c2653d22d2d7d", "5f6849cfbd264b76844004f9", "5f6849da91cfc10f362278ca", "5f6849e9980c2653d22d2d99", "5f6849f791cfc10f362278e7", "5f684a07bd264b7684400516", "5f684956980c2653d22d2d5f", "5f6849a691cfc10f362278ad", "5f6849b3bd264b76844004dc", "5f6849bf980c2653d22d2d7c", "5f6849cfbd264b76844004fb", "5f6849db91cfc10f362278cb", "5f6849e9980c2653d22d2d9a", "5f6849f791cfc10f362278e8", "5f684a07bd264b7684400518", "6308ec4c5ce69d50819ff079", "6308ed2bcf1542c52f78b583", "6308eda8af33d200283532b9", "6308edde8ca283c07f2de18b", "6308ee93bfa3323159c376ca", "6308ef02980d3ebbe3c76439", "6308ef3dc2244ca8d3514aed", "5f6849f791cfc10f362278e6", "6308ec4c5ce69d50819ff076", "6308ed2bcf1542c52f78b580", "6308eda8af33d200283532b6", "6308edde8ca283c07f2de188"],
      "stripe": "price_1QKvOTEy2I3xqILUHqmmVylF",
      "children": 3,
      "subject": "math_ela_science",
      "cost": {
        "per_month": 13.985999999999999,
        "science_per_month": 6.986,
        "total": 475.99999999999994,
        "sale": 251.66399999999996
      },
      "options": {
        "trial": true,
        "updates": true,
        "money_back": false
      },
      "title": "K12 Premium Math & ELA & Science",
      "description": "Most Popular! Save 50% while getting a full year of comprehensive learning. Perfect balance of value and flexibility - complete access to all premium features at our best annual rate.",
      "button_text": "TRY 3 DAYS FOR FREE"
    },
    {
      "exam": "k12",
      "featured": false,
      "period": "lifetime",
      "trial_period_days": 0,
      "premium_material_id": ["5f684953980c2653d22d2d4a", "5f6849a391cfc10f36227898", "5f6849b0bd264b76844004c8", "5f6849bc980c2653d22d2d67", "5f6849ccbd264b76844004e5", "5f6849d891cfc10f362278b5", "5f6849e6980c2653d22d2d84", "5f6849f491cfc10f362278d2", "5f684a04bd264b7684400502", "5f684953980c2653d22d2d4b", "5f6849a391cfc10f36227899", "5f6849b0bd264b76844004c9", "5f6849bc980c2653d22d2d68", "5f6849ccbd264b76844004e6", "5f6849d891cfc10f362278b6", "5f6849e6980c2653d22d2d85", "5f6849f591cfc10f362278d3", "5f684a04bd264b7684400503", "5f684954980c2653d22d2d50", "5f6849a491cfc10f3622789e", "5f6849b1bd264b76844004ce", "5f6849bc980c2653d22d2d69", "5f6849cdbd264b76844004e7", "5f6849d891cfc10f362278b7", "5f6849e6980c2653d22d2d86", "5f6849f591cfc10f362278d4", "5f684a04bd264b7684400504", "5f684954980c2653d22d2d4e", "5f6849a491cfc10f3622789c", "5f6849b1bd264b76844004cc", "5f6849bd980c2653d22d2d6b", "5f6849cdbd264b76844004e9", "5f6849d891cfc10f362278b9", "5f6849e7980c2653d22d2d88", "5f6849f591cfc10f362278d6", "5f684a05bd264b7684400506", "5f684954980c2653d22d2d4f", "5f6849a491cfc10f3622789d", "5f6849b1bd264b76844004cd", "5f6849bd980c2653d22d2d6c", "5f6849cdbd264b76844004ea", "5f6849d891cfc10f362278ba", "5f6849e7980c2653d22d2d89", "5f6849f591cfc10f362278d7", "5f684a05bd264b7684400507", "5f684954980c2653d22d2d4c", "5f6849a491cfc10f3622789a", "5f6849b0bd264b76844004ca", "5f6849bd980c2653d22d2d6d", "5f6849cdbd264b76844004eb", "5f6849d891cfc10f362278bb", "5f6849e7980c2653d22d2d8a", "5f6849f591cfc10f362278d8", "5f684a05bd264b7684400508", "5f684953980c2653d22d2d46", "5f69e6d86811e903a451a555", "5f6849afbd264b76844004c4", "5f6849bb980c2653d22d2d63", "5f6849ccbd264b76844004e1", "5f6849d791cfc10f362278b1", "5f6849e6980c2653d22d2d80", "5f6849f491cfc10f362278ce", "5f684a03bd264b76844004fe", "5f684953980c2653d22d2d47", "5f69e6d86811e903a451a556", "5f6849b0bd264b76844004c5", "5f6849bc980c2653d22d2d64", "5f6849ccbd264b76844004e2", "5f6849d791cfc10f362278b2", "5f6849e6980c2653d22d2d81", "5f6849f491cfc10f362278cf", "5f684a04bd264b76844004ff", "5f684953980c2653d22d2d48", "5f6849a391cfc10f36227896", "5f6849b0bd264b76844004c6", "5f6849bc980c2653d22d2d65", "5f6849ccbd264b76844004e3", "5f6849d791cfc10f362278b3", "5f6849e6980c2653d22d2d82", "5f6849f491cfc10f362278d0", "5f684a04bd264b7684400500", "5f684956980c2653d22d2d5e", "5f6849a691cfc10f362278ae", "5f6849b3bd264b76844004dd", "5f6849bf980c2653d22d2d7b", "5f6849cfbd264b76844004fa", "5f6849da91cfc10f362278c9", "5f6849e9980c2653d22d2d98", "6308ef7c9429464202c30b93", "5f684a07bd264b7684400517", "5f684956980c2653d22d2d60", "5f6849a691cfc10f362278ac", "5f6849b3bd264b76844004de", "5f6849bf980c2653d22d2d7d", "5f6849cfbd264b76844004f9", "5f6849da91cfc10f362278ca", "5f6849e9980c2653d22d2d99", "5f6849f791cfc10f362278e7", "5f684a07bd264b7684400516", "5f684956980c2653d22d2d5f", "5f6849a691cfc10f362278ad", "5f6849b3bd264b76844004dc", "5f6849bf980c2653d22d2d7c", "5f6849cfbd264b76844004fb", "5f6849db91cfc10f362278cb", "5f6849e9980c2653d22d2d9a", "5f6849f791cfc10f362278e8", "5f684a07bd264b7684400518", "6308ec4c5ce69d50819ff079", "6308ed2bcf1542c52f78b583", "6308eda8af33d200283532b9", "6308edde8ca283c07f2de18b", "6308ee93bfa3323159c376ca", "6308ef02980d3ebbe3c76439", "6308ef3dc2244ca8d3514aed", "5f6849f791cfc10f362278e6", "6308ec4c5ce69d50819ff076", "6308ed2bcf1542c52f78b580", "6308eda8af33d200283532b6", "6308edde8ca283c07f2de188"],
      "stripe": "price_1QKvOSEy2I3xqILULgZl0SqK",
      "children": 3,
      "subject": "math_ela_science",
      "cost": {
        "per_month": 5.586,
        "science_per_month": 6.986,
        "total": 1680,
        "sale": 979.986
      },
      "options": {
        "trial": false,
        "updates": true,
        "money_back": true
      },
      "title": "K12 Premium Math & ELA & Science",
      "description": "One-time payment unlocks lifetime access for all your children. Includes every future update and premium feature - invest once, benefit forever. ",
      "button_text": "TRY"
    },

    {
      "exam": "k12",
      "featured": true,
      "period": "month",
      "trial_period_days": 0,
      "premium_material_id": ["5f684953980c2653d22d2d4a", "5f6849a391cfc10f36227898", "5f6849b0bd264b76844004c8", "5f6849bc980c2653d22d2d67", "5f6849ccbd264b76844004e5", "5f6849d891cfc10f362278b5", "5f6849e6980c2653d22d2d84", "5f6849f491cfc10f362278d2", "5f684a04bd264b7684400502", "5f684953980c2653d22d2d4b", "5f6849a391cfc10f36227899", "5f6849b0bd264b76844004c9", "5f6849bc980c2653d22d2d68", "5f6849ccbd264b76844004e6", "5f6849d891cfc10f362278b6", "5f6849e6980c2653d22d2d85", "5f6849f591cfc10f362278d3", "5f684a04bd264b7684400503", "5f684954980c2653d22d2d50", "5f6849a491cfc10f3622789e", "5f6849b1bd264b76844004ce", "5f6849bc980c2653d22d2d69", "5f6849cdbd264b76844004e7", "5f6849d891cfc10f362278b7", "5f6849e6980c2653d22d2d86", "5f6849f591cfc10f362278d4", "5f684a04bd264b7684400504", "5f684954980c2653d22d2d4e", "5f6849a491cfc10f3622789c", "5f6849b1bd264b76844004cc", "5f6849bd980c2653d22d2d6b", "5f6849cdbd264b76844004e9", "5f6849d891cfc10f362278b9", "5f6849e7980c2653d22d2d88", "5f6849f591cfc10f362278d6", "5f684a05bd264b7684400506", "5f684954980c2653d22d2d4f", "5f6849a491cfc10f3622789d", "5f6849b1bd264b76844004cd", "5f6849bd980c2653d22d2d6c", "5f6849cdbd264b76844004ea", "5f6849d891cfc10f362278ba", "5f6849e7980c2653d22d2d89", "5f6849f591cfc10f362278d7", "5f684a05bd264b7684400507", "5f684954980c2653d22d2d4c", "5f6849a491cfc10f3622789a", "5f6849b0bd264b76844004ca", "5f6849bd980c2653d22d2d6d", "5f6849cdbd264b76844004eb", "5f6849d891cfc10f362278bb", "5f6849e7980c2653d22d2d8a", "5f6849f591cfc10f362278d8", "5f684a05bd264b7684400508", "5f684953980c2653d22d2d46", "5f69e6d86811e903a451a555", "5f6849afbd264b76844004c4", "5f6849bb980c2653d22d2d63", "5f6849ccbd264b76844004e1", "5f6849d791cfc10f362278b1", "5f6849e6980c2653d22d2d80", "5f6849f491cfc10f362278ce", "5f684a03bd264b76844004fe", "5f684953980c2653d22d2d47", "5f69e6d86811e903a451a556", "5f6849b0bd264b76844004c5", "5f6849bc980c2653d22d2d64", "5f6849ccbd264b76844004e2", "5f6849d791cfc10f362278b2", "5f6849e6980c2653d22d2d81", "5f6849f491cfc10f362278cf", "5f684a04bd264b76844004ff", "5f684953980c2653d22d2d48", "5f6849a391cfc10f36227896", "5f6849b0bd264b76844004c6", "5f6849bc980c2653d22d2d65", "5f6849ccbd264b76844004e3", "5f6849d791cfc10f362278b3", "5f6849e6980c2653d22d2d82", "5f6849f491cfc10f362278d0", "5f684a04bd264b7684400500", "5f684956980c2653d22d2d5e", "5f6849a691cfc10f362278ae", "5f6849b3bd264b76844004dd", "5f6849bf980c2653d22d2d7b", "5f6849cfbd264b76844004fa", "5f6849da91cfc10f362278c9", "5f6849e9980c2653d22d2d98", "6308ef7c9429464202c30b93", "5f684a07bd264b7684400517", "5f684956980c2653d22d2d60", "5f6849a691cfc10f362278ac", "5f6849b3bd264b76844004de", "5f6849bf980c2653d22d2d7d", "5f6849cfbd264b76844004f9", "5f6849da91cfc10f362278ca", "5f6849e9980c2653d22d2d99", "5f6849f791cfc10f362278e7", "5f684a07bd264b7684400516", "5f684956980c2653d22d2d5f", "5f6849a691cfc10f362278ad", "5f6849b3bd264b76844004dc", "5f6849bf980c2653d22d2d7c", "5f6849cfbd264b76844004fb", "5f6849db91cfc10f362278cb", "5f6849e9980c2653d22d2d9a", "5f6849f791cfc10f362278e8", "5f684a07bd264b7684400518", "6308ec4c5ce69d50819ff079", "6308ed2bcf1542c52f78b583", "6308eda8af33d200283532b9", "6308edde8ca283c07f2de18b", "6308ee93bfa3323159c376ca", "6308ef02980d3ebbe3c76439", "6308ef3dc2244ca8d3514aed", "5f6849f791cfc10f362278e6", "6308ec4c5ce69d50819ff076", "6308ed2bcf1542c52f78b580", "6308eda8af33d200283532b6", "6308edde8ca283c07f2de188"],
      "stripe": "price_1QKvOTEy2I3xqILUXOERbvih",
      "children": 4,
      "subject": "math_ela_science",
      "cost": {
        "per_month": 20.784000000000002,
        "science_per_month": 7.984000000000001,
        "total": 80,
        "sale": 27.168000000000003
      },
      "options": {
        "trial": true,
        "updates": false,
        "money_back": false
      },
      "title": "K12 Premium Math & ELA & Science",
      "description": "Perfect for flexible learning - access expert-led lessons, practice questions, and printable workbooks instantly, with no long-term commitment.",
      "button_text": "TRY 3 DAYS FOR FREE"
    },
    {
      "exam": "k12",
      "featured": false,
      "period": "year",
      "trial_period_days": 0,
      "premium_material_id": ["5f684953980c2653d22d2d4a", "5f6849a391cfc10f36227898", "5f6849b0bd264b76844004c8", "5f6849bc980c2653d22d2d67", "5f6849ccbd264b76844004e5", "5f6849d891cfc10f362278b5", "5f6849e6980c2653d22d2d84", "5f6849f491cfc10f362278d2", "5f684a04bd264b7684400502", "5f684953980c2653d22d2d4b", "5f6849a391cfc10f36227899", "5f6849b0bd264b76844004c9", "5f6849bc980c2653d22d2d68", "5f6849ccbd264b76844004e6", "5f6849d891cfc10f362278b6", "5f6849e6980c2653d22d2d85", "5f6849f591cfc10f362278d3", "5f684a04bd264b7684400503", "5f684954980c2653d22d2d50", "5f6849a491cfc10f3622789e", "5f6849b1bd264b76844004ce", "5f6849bc980c2653d22d2d69", "5f6849cdbd264b76844004e7", "5f6849d891cfc10f362278b7", "5f6849e6980c2653d22d2d86", "5f6849f591cfc10f362278d4", "5f684a04bd264b7684400504", "5f684954980c2653d22d2d4e", "5f6849a491cfc10f3622789c", "5f6849b1bd264b76844004cc", "5f6849bd980c2653d22d2d6b", "5f6849cdbd264b76844004e9", "5f6849d891cfc10f362278b9", "5f6849e7980c2653d22d2d88", "5f6849f591cfc10f362278d6", "5f684a05bd264b7684400506", "5f684954980c2653d22d2d4f", "5f6849a491cfc10f3622789d", "5f6849b1bd264b76844004cd", "5f6849bd980c2653d22d2d6c", "5f6849cdbd264b76844004ea", "5f6849d891cfc10f362278ba", "5f6849e7980c2653d22d2d89", "5f6849f591cfc10f362278d7", "5f684a05bd264b7684400507", "5f684954980c2653d22d2d4c", "5f6849a491cfc10f3622789a", "5f6849b0bd264b76844004ca", "5f6849bd980c2653d22d2d6d", "5f6849cdbd264b76844004eb", "5f6849d891cfc10f362278bb", "5f6849e7980c2653d22d2d8a", "5f6849f591cfc10f362278d8", "5f684a05bd264b7684400508", "5f684953980c2653d22d2d46", "5f69e6d86811e903a451a555", "5f6849afbd264b76844004c4", "5f6849bb980c2653d22d2d63", "5f6849ccbd264b76844004e1", "5f6849d791cfc10f362278b1", "5f6849e6980c2653d22d2d80", "5f6849f491cfc10f362278ce", "5f684a03bd264b76844004fe", "5f684953980c2653d22d2d47", "5f69e6d86811e903a451a556", "5f6849b0bd264b76844004c5", "5f6849bc980c2653d22d2d64", "5f6849ccbd264b76844004e2", "5f6849d791cfc10f362278b2", "5f6849e6980c2653d22d2d81", "5f6849f491cfc10f362278cf", "5f684a04bd264b76844004ff", "5f684953980c2653d22d2d48", "5f6849a391cfc10f36227896", "5f6849b0bd264b76844004c6", "5f6849bc980c2653d22d2d65", "5f6849ccbd264b76844004e3", "5f6849d791cfc10f362278b3", "5f6849e6980c2653d22d2d82", "5f6849f491cfc10f362278d0", "5f684a04bd264b7684400500", "5f684956980c2653d22d2d5e", "5f6849a691cfc10f362278ae", "5f6849b3bd264b76844004dd", "5f6849bf980c2653d22d2d7b", "5f6849cfbd264b76844004fa", "5f6849da91cfc10f362278c9", "5f6849e9980c2653d22d2d98", "6308ef7c9429464202c30b93", "5f684a07bd264b7684400517", "5f684956980c2653d22d2d60", "5f6849a691cfc10f362278ac", "5f6849b3bd264b76844004de", "5f6849bf980c2653d22d2d7d", "5f6849cfbd264b76844004f9", "5f6849da91cfc10f362278ca", "5f6849e9980c2653d22d2d99", "5f6849f791cfc10f362278e7", "5f684a07bd264b7684400516", "5f684956980c2653d22d2d5f", "5f6849a691cfc10f362278ad", "5f6849b3bd264b76844004dc", "5f6849bf980c2653d22d2d7c", "5f6849cfbd264b76844004fb", "5f6849db91cfc10f362278cb", "5f6849e9980c2653d22d2d9a", "5f6849f791cfc10f362278e8", "5f684a07bd264b7684400518", "6308ec4c5ce69d50819ff079", "6308ed2bcf1542c52f78b583", "6308eda8af33d200283532b9", "6308edde8ca283c07f2de18b", "6308ee93bfa3323159c376ca", "6308ef02980d3ebbe3c76439", "6308ef3dc2244ca8d3514aed", "5f6849f791cfc10f362278e6", "6308ec4c5ce69d50819ff076", "6308ed2bcf1542c52f78b580", "6308eda8af33d200283532b6", "6308edde8ca283c07f2de188"],
      "stripe": "price_1QKvOUEy2I3xqILUmLx0ghfe",
      "children": 4,
      "subject": "math_ela_science",
      "cost": {
        "per_month": 15.984000000000002,
        "science_per_month": 7.984000000000001,
        "total": 544,
        "sale": 287.616
      },
      "options": {
        "trial": true,
        "updates": true,
        "money_back": false
      },
      "title": "K12 Premium Math & ELA & Science",
      "description": "Most Popular! Save 50% while getting a full year of comprehensive learning. Perfect balance of value and flexibility - complete access to all premium features at our best annual rate.",
      "button_text": "TRY 3 DAYS FOR FREE"
    },
    {
      "exam": "k12",
      "featured": false,
      "period": "lifetime",
      "trial_period_days": 0,
      "premium_material_id": ["5f684953980c2653d22d2d4a", "5f6849a391cfc10f36227898", "5f6849b0bd264b76844004c8", "5f6849bc980c2653d22d2d67", "5f6849ccbd264b76844004e5", "5f6849d891cfc10f362278b5", "5f6849e6980c2653d22d2d84", "5f6849f491cfc10f362278d2", "5f684a04bd264b7684400502", "5f684953980c2653d22d2d4b", "5f6849a391cfc10f36227899", "5f6849b0bd264b76844004c9", "5f6849bc980c2653d22d2d68", "5f6849ccbd264b76844004e6", "5f6849d891cfc10f362278b6", "5f6849e6980c2653d22d2d85", "5f6849f591cfc10f362278d3", "5f684a04bd264b7684400503", "5f684954980c2653d22d2d50", "5f6849a491cfc10f3622789e", "5f6849b1bd264b76844004ce", "5f6849bc980c2653d22d2d69", "5f6849cdbd264b76844004e7", "5f6849d891cfc10f362278b7", "5f6849e6980c2653d22d2d86", "5f6849f591cfc10f362278d4", "5f684a04bd264b7684400504", "5f684954980c2653d22d2d4e", "5f6849a491cfc10f3622789c", "5f6849b1bd264b76844004cc", "5f6849bd980c2653d22d2d6b", "5f6849cdbd264b76844004e9", "5f6849d891cfc10f362278b9", "5f6849e7980c2653d22d2d88", "5f6849f591cfc10f362278d6", "5f684a05bd264b7684400506", "5f684954980c2653d22d2d4f", "5f6849a491cfc10f3622789d", "5f6849b1bd264b76844004cd", "5f6849bd980c2653d22d2d6c", "5f6849cdbd264b76844004ea", "5f6849d891cfc10f362278ba", "5f6849e7980c2653d22d2d89", "5f6849f591cfc10f362278d7", "5f684a05bd264b7684400507", "5f684954980c2653d22d2d4c", "5f6849a491cfc10f3622789a", "5f6849b0bd264b76844004ca", "5f6849bd980c2653d22d2d6d", "5f6849cdbd264b76844004eb", "5f6849d891cfc10f362278bb", "5f6849e7980c2653d22d2d8a", "5f6849f591cfc10f362278d8", "5f684a05bd264b7684400508", "5f684953980c2653d22d2d46", "5f69e6d86811e903a451a555", "5f6849afbd264b76844004c4", "5f6849bb980c2653d22d2d63", "5f6849ccbd264b76844004e1", "5f6849d791cfc10f362278b1", "5f6849e6980c2653d22d2d80", "5f6849f491cfc10f362278ce", "5f684a03bd264b76844004fe", "5f684953980c2653d22d2d47", "5f69e6d86811e903a451a556", "5f6849b0bd264b76844004c5", "5f6849bc980c2653d22d2d64", "5f6849ccbd264b76844004e2", "5f6849d791cfc10f362278b2", "5f6849e6980c2653d22d2d81", "5f6849f491cfc10f362278cf", "5f684a04bd264b76844004ff", "5f684953980c2653d22d2d48", "5f6849a391cfc10f36227896", "5f6849b0bd264b76844004c6", "5f6849bc980c2653d22d2d65", "5f6849ccbd264b76844004e3", "5f6849d791cfc10f362278b3", "5f6849e6980c2653d22d2d82", "5f6849f491cfc10f362278d0", "5f684a04bd264b7684400500", "5f684956980c2653d22d2d5e", "5f6849a691cfc10f362278ae", "5f6849b3bd264b76844004dd", "5f6849bf980c2653d22d2d7b", "5f6849cfbd264b76844004fa", "5f6849da91cfc10f362278c9", "5f6849e9980c2653d22d2d98", "6308ef7c9429464202c30b93", "5f684a07bd264b7684400517", "5f684956980c2653d22d2d60", "5f6849a691cfc10f362278ac", "5f6849b3bd264b76844004de", "5f6849bf980c2653d22d2d7d", "5f6849cfbd264b76844004f9", "5f6849da91cfc10f362278ca", "5f6849e9980c2653d22d2d99", "5f6849f791cfc10f362278e7", "5f684a07bd264b7684400516", "5f684956980c2653d22d2d5f", "5f6849a691cfc10f362278ad", "5f6849b3bd264b76844004dc", "5f6849bf980c2653d22d2d7c", "5f6849cfbd264b76844004fb", "5f6849db91cfc10f362278cb", "5f6849e9980c2653d22d2d9a", "5f6849f791cfc10f362278e8", "5f684a07bd264b7684400518", "6308ec4c5ce69d50819ff079", "6308ed2bcf1542c52f78b583", "6308eda8af33d200283532b9", "6308edde8ca283c07f2de18b", "6308ee93bfa3323159c376ca", "6308ef02980d3ebbe3c76439", "6308ef3dc2244ca8d3514aed", "5f6849f791cfc10f362278e6", "6308ec4c5ce69d50819ff076", "6308ed2bcf1542c52f78b580", "6308eda8af33d200283532b6", "6308edde8ca283c07f2de188"],
      "stripe": "price_1QKvOTEy2I3xqILU59KPOgvd",
      "children": 4,
      "subject": "math_ela_science",
      "cost": {
        "per_month": 6.384,
        "science_per_month": 7.984000000000001,
        "total": 1920,
        "sale": 1119.9840000000002
      },
      "options": {
        "trial": false,
        "updates": true,
        "money_back": true
      },
      "title": "K12 Premium Math & ELA & Science",
      "description": "One-time payment unlocks lifetime access for all your children. Includes every future update and premium feature - invest once, benefit forever. ",
      "button_text": "TRY"
    },


    {
      "exam": "shsat",
      "featured": false,
      "period": "halfyear",
      "premium_material_id": "6728938edcca0c1ea1dde559",
      "stripe": "price_1QKvOUEy2I3xqILUqVOcNDUl",
      "children": 1,
      "subject": "math_ela",
      "cost": {
        "per_month": 41.66,
        "total": 400,
        "sale": 249.99
      },
      "options": {
        "trial": true,
        "updates": false,
        "money_back": false
      },
      "title": "SHSAT Premium Math & ELA",
      "description": "You will get unlimited access to all our premium video lectures, practice questions, and quizzes.",
      "button_text": "TRY FOR FREE"
    },
    {
      "exam": "shsat",
      "featured": true,
      "period": "year",
      "premium_material_id": "6728938edcca0c1ea1dde559",
      "stripe": "price_1QKvOUEy2I3xqILU0XpOgIGN",
      "children": 1,
      "subject": "math_ela",
      "cost": {
        "per_month": 33.33,
        "total": 600,
        "sale": 399.99
      },
      "options": {
        "trial": true,
        "updates": true,
        "money_back": false
      },
      "title": "SHSAT Premium Math & ELA",
      "description": "You will save 20% by choosing this plan, and get unlimited access to all our premium video lectures, practice questions, and quizzes. This is a great balance between price and access time.",
      "button_text": "TRY FOR FREE"
    },
    {
      "exam": "shsat",
      "featured": false,
      "period": "month",
      "premium_material_id": "6728938edcca0c1ea1dde559",
      "stripe": "price_1QKvOVEy2I3xqILUjHd1KarD",
      "children": 1,
      "subject": "math_ela",
      "cost": {
        "per_month": 49.99,
        "total": 70,
        "sale": 49.99
      },
      "options": {
        "trial": false,
        "updates": true,
        "money_back": true
      },
      "title": "SHSAT Premium Math & ELA",
      "description": "This plan is for those who love to have access on demand. You will get unlimited access to all our premium video lectures, practice questions, and quizzes. A great option for those who focus on goals and get things done.",
      "button_text": "TRY FOR FREE"
    }
  ],*/
  list: [
    {
      "exam": "k12",
      "featured": true,
      "period": "month",
      "trial_period_days": 0,
      "premium_material_id": [
        "5f684953980c2653d22d2d4a",
        "5f6849a391cfc10f36227898",
        "5f6849b0bd264b76844004c8",
        "5f6849bc980c2653d22d2d67",
        "5f6849ccbd264b76844004e5",
        "5f6849d891cfc10f362278b5",
        "5f6849e6980c2653d22d2d84",
        "5f6849f491cfc10f362278d2",
        "5f684a04bd264b7684400502",
        "5f684953980c2653d22d2d4b",
        "5f6849a391cfc10f36227899",
        "5f6849b0bd264b76844004c9",
        "5f6849bc980c2653d22d2d68",
        "5f6849ccbd264b76844004e6",
        "5f6849d891cfc10f362278b6",
        "5f6849e6980c2653d22d2d85",
        "5f6849f591cfc10f362278d3",
        "5f684a04bd264b7684400503",
        "5f684954980c2653d22d2d4e",
        "5f6849a491cfc10f3622789c",
        "5f6849b1bd264b76844004cc",
        "5f6849bd980c2653d22d2d6b",
        "5f6849cdbd264b76844004e9",
        "5f6849d891cfc10f362278b9",
        "5f6849e7980c2653d22d2d88",
        "5f6849f591cfc10f362278d6",
        "5f684a05bd264b7684400506",
        "5f684954980c2653d22d2d4f",
        "5f6849a491cfc10f3622789d",
        "5f6849b1bd264b76844004cd",
        "5f6849bd980c2653d22d2d6c",
        "5f6849cdbd264b76844004ea",
        "5f6849d891cfc10f362278ba",
        "5f6849e7980c2653d22d2d89",
        "5f6849f591cfc10f362278d7",
        "5f684a05bd264b7684400507",
        "5f684953980c2653d22d2d46",
        "5f69e6d86811e903a451a555",
        "5f6849afbd264b76844004c4",
        "5f6849bb980c2653d22d2d63",
        "5f6849ccbd264b76844004e1",
        "5f6849d791cfc10f362278b1",
        "5f6849e6980c2653d22d2d80",
        "5f6849f491cfc10f362278ce",
        "5f684a03bd264b76844004fe",
        "5f684953980c2653d22d2d47",
        "5f69e6d86811e903a451a556",
        "5f6849b0bd264b76844004c5",
        "5f6849bc980c2653d22d2d64",
        "5f6849ccbd264b76844004e2",
        "5f6849d791cfc10f362278b2",
        "5f6849e6980c2653d22d2d81",
        "5f6849f491cfc10f362278cf",
        "5f684a04bd264b76844004ff",
        "5f684956980c2653d22d2d5e",
        "5f6849b3bd264b76844004dd",
        "5f6849bf980c2653d22d2d7b",
        "5f6849cfbd264b76844004fa",
        "5f6849da91cfc10f362278c9",
        "5f6849e9980c2653d22d2d98",
        "6308ef7c9429464202c30b93",
        "5f684a07bd264b7684400517",
        "5f6849a691cfc10f362278ac",
        "5f6849cfbd264b76844004f9",
        "5f6849da91cfc10f362278ca",
        "5f6849e9980c2653d22d2d99",
        "5f6849f791cfc10f362278e7",
        "5f684a07bd264b7684400516",
        "5f684956980c2653d22d2d5f",
        "5f6849a691cfc10f362278ad",
        "5f6849b3bd264b76844004dc",
        "5f6849bf980c2653d22d2d7c",
        "6308ec4c5ce69d50819ff079",
        "6308ed2bcf1542c52f78b583",
        "6308eda8af33d200283532b9",
        "6308edde8ca283c07f2de18b",
        "6308ee93bfa3323159c376ca",
        "6308ef02980d3ebbe3c76439",
        "6308ef3dc2244ca8d3514aed",
        "5f6849f791cfc10f362278e6",
        "6308ec4c5ce69d50819ff076",
        "6308ed2bcf1542c52f78b580",
        "6308eda8af33d200283532b6",
        "6308edde8ca283c07f2de188"
      ],
      "stripe": "price_1QgnfqEy2I3xqILUpeRQqYCP",
      "children": 1,
      "subject": "math_ela",
      "cost": {
        "per_month": 12.99,
        "total": 40,
        "sale": 12.99
      },
      "options": {
        "trial": true,
        "updates": false,
        "money_back": false
      },
      "title": "K12 Premium Math & ELA",
      "description": "Perfect for flexible learning - access expert-led lessons, practice questions, and printable workbooks instantly, with no long-term commitment.",
      "button_text": "TRY 3 DAYS FOR FREE"
    },
    {
      "exam": "k12",
      "featured": false,
      "period": "year",
      "trial_period_days": 0,
      "premium_material_id": [
        "5f684953980c2653d22d2d4a",
        "5f6849a391cfc10f36227898",
        "5f6849b0bd264b76844004c8",
        "5f6849bc980c2653d22d2d67",
        "5f6849ccbd264b76844004e5",
        "5f6849d891cfc10f362278b5",
        "5f6849e6980c2653d22d2d84",
        "5f6849f491cfc10f362278d2",
        "5f684a04bd264b7684400502",
        "5f684953980c2653d22d2d4b",
        "5f6849a391cfc10f36227899",
        "5f6849b0bd264b76844004c9",
        "5f6849bc980c2653d22d2d68",
        "5f6849ccbd264b76844004e6",
        "5f6849d891cfc10f362278b6",
        "5f6849e6980c2653d22d2d85",
        "5f6849f591cfc10f362278d3",
        "5f684a04bd264b7684400503",
        "5f684954980c2653d22d2d4e",
        "5f6849a491cfc10f3622789c",
        "5f6849b1bd264b76844004cc",
        "5f6849bd980c2653d22d2d6b",
        "5f6849cdbd264b76844004e9",
        "5f6849d891cfc10f362278b9",
        "5f6849e7980c2653d22d2d88",
        "5f6849f591cfc10f362278d6",
        "5f684a05bd264b7684400506",
        "5f684954980c2653d22d2d4f",
        "5f6849a491cfc10f3622789d",
        "5f6849b1bd264b76844004cd",
        "5f6849bd980c2653d22d2d6c",
        "5f6849cdbd264b76844004ea",
        "5f6849d891cfc10f362278ba",
        "5f6849e7980c2653d22d2d89",
        "5f6849f591cfc10f362278d7",
        "5f684a05bd264b7684400507",
        "5f684953980c2653d22d2d46",
        "5f69e6d86811e903a451a555",
        "5f6849afbd264b76844004c4",
        "5f6849bb980c2653d22d2d63",
        "5f6849ccbd264b76844004e1",
        "5f6849d791cfc10f362278b1",
        "5f6849e6980c2653d22d2d80",
        "5f6849f491cfc10f362278ce",
        "5f684a03bd264b76844004fe",
        "5f684953980c2653d22d2d47",
        "5f69e6d86811e903a451a556",
        "5f6849b0bd264b76844004c5",
        "5f6849bc980c2653d22d2d64",
        "5f6849ccbd264b76844004e2",
        "5f6849d791cfc10f362278b2",
        "5f6849e6980c2653d22d2d81",
        "5f6849f491cfc10f362278cf",
        "5f684a04bd264b76844004ff",
        "5f684956980c2653d22d2d5e",
        "5f6849b3bd264b76844004dd",
        "5f6849bf980c2653d22d2d7b",
        "5f6849cfbd264b76844004fa",
        "5f6849da91cfc10f362278c9",
        "5f6849e9980c2653d22d2d98",
        "6308ef7c9429464202c30b93",
        "5f684a07bd264b7684400517",
        "5f6849a691cfc10f362278ac",
        "5f6849cfbd264b76844004f9",
        "5f6849da91cfc10f362278ca",
        "5f6849e9980c2653d22d2d99",
        "5f6849f791cfc10f362278e7",
        "5f684a07bd264b7684400516",
        "5f684956980c2653d22d2d5f",
        "5f6849a691cfc10f362278ad",
        "5f6849b3bd264b76844004dc",
        "5f6849bf980c2653d22d2d7c",
        "6308ec4c5ce69d50819ff079",
        "6308ed2bcf1542c52f78b583",
        "6308eda8af33d200283532b9",
        "6308edde8ca283c07f2de18b",
        "6308ee93bfa3323159c376ca",
        "6308ef02980d3ebbe3c76439",
        "6308ef3dc2244ca8d3514aed",
        "5f6849f791cfc10f362278e6",
        "6308ec4c5ce69d50819ff076",
        "6308ed2bcf1542c52f78b580",
        "6308eda8af33d200283532b6",
        "6308edde8ca283c07f2de188"
      ],
      "stripe": "price_1QgnfqEy2I3xqILUgRBDyzE5",
      "children": 1,
      "subject": "math_ela",
      "cost": {
        "per_month": 9.99,
        "total": 240,
        "sale": 119.99
      },
      "options": {
        "trial": true,
        "updates": true,
        "money_back": false
      },
      "title": "K12 Premium Math & ELA",
      "description": "Most Popular! Save 50% while getting a full year of comprehensive learning. Perfect balance of value and flexibility - complete access to all premium features at our best annual rate.",
      "button_text": "TRY 3 DAYS FOR FREE"
    },
    {
      "exam": "k12",
      "featured": false,
      "period": "lifetime",
      "trial_period_days": 0,
      "premium_material_id": [
        "5f684953980c2653d22d2d4a",
        "5f6849a391cfc10f36227898",
        "5f6849b0bd264b76844004c8",
        "5f6849bc980c2653d22d2d67",
        "5f6849ccbd264b76844004e5",
        "5f6849d891cfc10f362278b5",
        "5f6849e6980c2653d22d2d84",
        "5f6849f491cfc10f362278d2",
        "5f684a04bd264b7684400502",
        "5f684953980c2653d22d2d4b",
        "5f6849a391cfc10f36227899",
        "5f6849b0bd264b76844004c9",
        "5f6849bc980c2653d22d2d68",
        "5f6849ccbd264b76844004e6",
        "5f6849d891cfc10f362278b6",
        "5f6849e6980c2653d22d2d85",
        "5f6849f591cfc10f362278d3",
        "5f684a04bd264b7684400503",
        "5f684954980c2653d22d2d4e",
        "5f6849a491cfc10f3622789c",
        "5f6849b1bd264b76844004cc",
        "5f6849bd980c2653d22d2d6b",
        "5f6849cdbd264b76844004e9",
        "5f6849d891cfc10f362278b9",
        "5f6849e7980c2653d22d2d88",
        "5f6849f591cfc10f362278d6",
        "5f684a05bd264b7684400506",
        "5f684954980c2653d22d2d4f",
        "5f6849a491cfc10f3622789d",
        "5f6849b1bd264b76844004cd",
        "5f6849bd980c2653d22d2d6c",
        "5f6849cdbd264b76844004ea",
        "5f6849d891cfc10f362278ba",
        "5f6849e7980c2653d22d2d89",
        "5f6849f591cfc10f362278d7",
        "5f684a05bd264b7684400507",
        "5f684953980c2653d22d2d46",
        "5f69e6d86811e903a451a555",
        "5f6849afbd264b76844004c4",
        "5f6849bb980c2653d22d2d63",
        "5f6849ccbd264b76844004e1",
        "5f6849d791cfc10f362278b1",
        "5f6849e6980c2653d22d2d80",
        "5f6849f491cfc10f362278ce",
        "5f684a03bd264b76844004fe",
        "5f684953980c2653d22d2d47",
        "5f69e6d86811e903a451a556",
        "5f6849b0bd264b76844004c5",
        "5f6849bc980c2653d22d2d64",
        "5f6849ccbd264b76844004e2",
        "5f6849d791cfc10f362278b2",
        "5f6849e6980c2653d22d2d81",
        "5f6849f491cfc10f362278cf",
        "5f684a04bd264b76844004ff",
        "5f684956980c2653d22d2d5e",
        "5f6849b3bd264b76844004dd",
        "5f6849bf980c2653d22d2d7b",
        "5f6849cfbd264b76844004fa",
        "5f6849da91cfc10f362278c9",
        "5f6849e9980c2653d22d2d98",
        "6308ef7c9429464202c30b93",
        "5f684a07bd264b7684400517",
        "5f6849a691cfc10f362278ac",
        "5f6849cfbd264b76844004f9",
        "5f6849da91cfc10f362278ca",
        "5f6849e9980c2653d22d2d99",
        "5f6849f791cfc10f362278e7",
        "5f684a07bd264b7684400516",
        "5f684956980c2653d22d2d5f",
        "5f6849a691cfc10f362278ad",
        "5f6849b3bd264b76844004dc",
        "5f6849bf980c2653d22d2d7c",
        "6308ec4c5ce69d50819ff079",
        "6308ed2bcf1542c52f78b583",
        "6308eda8af33d200283532b9",
        "6308edde8ca283c07f2de18b",
        "6308ee93bfa3323159c376ca",
        "6308ef02980d3ebbe3c76439",
        "6308ef3dc2244ca8d3514aed",
        "5f6849f791cfc10f362278e6",
        "6308ec4c5ce69d50819ff076",
        "6308ed2bcf1542c52f78b580",
        "6308eda8af33d200283532b6",
        "6308edde8ca283c07f2de188"
      ],
      "stripe": "price_1QgnfqEy2I3xqILUKfcfalhk",
      "children": 1,
      "subject": "math_ela",
      "cost": {
        "per_month": 3.99,
        "total": 900,
        "sale": 499.99
      },
      "options": {
        "trial": false,
        "updates": true,
        "money_back": true
      },
      "title": "K12 Premium Math & ELA",
      "description": "One-time payment unlocks lifetime access for all your children. Includes every future update and premium feature - invest once, benefit forever. ",
      "button_text": "TRY"
    },
    {
      "exam": "k12",
      "featured": true,
      "period": "month",
      "trial_period_days": 0,
      "premium_material_id": [
        "5f684953980c2653d22d2d4a",
        "5f6849a391cfc10f36227898",
        "5f6849b0bd264b76844004c8",
        "5f6849bc980c2653d22d2d67",
        "5f6849ccbd264b76844004e5",
        "5f6849d891cfc10f362278b5",
        "5f6849e6980c2653d22d2d84",
        "5f6849f491cfc10f362278d2",
        "5f684a04bd264b7684400502",
        "5f684953980c2653d22d2d4b",
        "5f6849a391cfc10f36227899",
        "5f6849b0bd264b76844004c9",
        "5f6849bc980c2653d22d2d68",
        "5f6849ccbd264b76844004e6",
        "5f6849d891cfc10f362278b6",
        "5f6849e6980c2653d22d2d85",
        "5f6849f591cfc10f362278d3",
        "5f684a04bd264b7684400503",
        "5f684954980c2653d22d2d4e",
        "5f6849a491cfc10f3622789c",
        "5f6849b1bd264b76844004cc",
        "5f6849bd980c2653d22d2d6b",
        "5f6849cdbd264b76844004e9",
        "5f6849d891cfc10f362278b9",
        "5f6849e7980c2653d22d2d88",
        "5f6849f591cfc10f362278d6",
        "5f684a05bd264b7684400506",
        "5f684954980c2653d22d2d4f",
        "5f6849a491cfc10f3622789d",
        "5f6849b1bd264b76844004cd",
        "5f6849bd980c2653d22d2d6c",
        "5f6849cdbd264b76844004ea",
        "5f6849d891cfc10f362278ba",
        "5f6849e7980c2653d22d2d89",
        "5f6849f591cfc10f362278d7",
        "5f684a05bd264b7684400507",
        "5f684953980c2653d22d2d46",
        "5f69e6d86811e903a451a555",
        "5f6849afbd264b76844004c4",
        "5f6849bb980c2653d22d2d63",
        "5f6849ccbd264b76844004e1",
        "5f6849d791cfc10f362278b1",
        "5f6849e6980c2653d22d2d80",
        "5f6849f491cfc10f362278ce",
        "5f684a03bd264b76844004fe",
        "5f684953980c2653d22d2d47",
        "5f69e6d86811e903a451a556",
        "5f6849b0bd264b76844004c5",
        "5f6849bc980c2653d22d2d64",
        "5f6849ccbd264b76844004e2",
        "5f6849d791cfc10f362278b2",
        "5f6849e6980c2653d22d2d81",
        "5f6849f491cfc10f362278cf",
        "5f684a04bd264b76844004ff",
        "5f684956980c2653d22d2d5e",
        "5f6849b3bd264b76844004dd",
        "5f6849bf980c2653d22d2d7b",
        "5f6849cfbd264b76844004fa",
        "5f6849da91cfc10f362278c9",
        "5f6849e9980c2653d22d2d98",
        "6308ef7c9429464202c30b93",
        "5f684a07bd264b7684400517",
        "5f6849a691cfc10f362278ac",
        "5f6849cfbd264b76844004f9",
        "5f6849da91cfc10f362278ca",
        "5f6849e9980c2653d22d2d99",
        "5f6849f791cfc10f362278e7",
        "5f684a07bd264b7684400516",
        "5f684956980c2653d22d2d5f",
        "5f6849a691cfc10f362278ad",
        "5f6849b3bd264b76844004dc",
        "5f6849bf980c2653d22d2d7c",
        "6308ec4c5ce69d50819ff079",
        "6308ed2bcf1542c52f78b583",
        "6308eda8af33d200283532b9",
        "6308edde8ca283c07f2de18b",
        "6308ee93bfa3323159c376ca",
        "6308ef02980d3ebbe3c76439",
        "6308ef3dc2244ca8d3514aed",
        "5f6849f791cfc10f362278e6",
        "6308ec4c5ce69d50819ff076",
        "6308ed2bcf1542c52f78b580",
        "6308eda8af33d200283532b6",
        "6308edde8ca283c07f2de188"
      ],
      "stripe": "price_1QgnfqEy2I3xqILUk4Coj3aj",
      "children": 2,
      "subject": "math_ela",
      "cost": {
        "per_month": 15.588,
        "total": 48,
        "sale": 15.588
      },
      "options": {
        "trial": true,
        "updates": false,
        "money_back": false
      },
      "title": "K12 Premium Math & ELA",
      "description": "Perfect for flexible learning - access expert-led lessons, practice questions, and printable workbooks instantly, with no long-term commitment.",
      "button_text": "TRY 3 DAYS FOR FREE"
    },
    {
      "exam": "k12",
      "featured": false,
      "period": "year",
      "trial_period_days": 0,
      "premium_material_id": [
        "5f684953980c2653d22d2d4a",
        "5f6849a391cfc10f36227898",
        "5f6849b0bd264b76844004c8",
        "5f6849bc980c2653d22d2d67",
        "5f6849ccbd264b76844004e5",
        "5f6849d891cfc10f362278b5",
        "5f6849e6980c2653d22d2d84",
        "5f6849f491cfc10f362278d2",
        "5f684a04bd264b7684400502",
        "5f684953980c2653d22d2d4b",
        "5f6849a391cfc10f36227899",
        "5f6849b0bd264b76844004c9",
        "5f6849bc980c2653d22d2d68",
        "5f6849ccbd264b76844004e6",
        "5f6849d891cfc10f362278b6",
        "5f6849e6980c2653d22d2d85",
        "5f6849f591cfc10f362278d3",
        "5f684a04bd264b7684400503",
        "5f684954980c2653d22d2d4e",
        "5f6849a491cfc10f3622789c",
        "5f6849b1bd264b76844004cc",
        "5f6849bd980c2653d22d2d6b",
        "5f6849cdbd264b76844004e9",
        "5f6849d891cfc10f362278b9",
        "5f6849e7980c2653d22d2d88",
        "5f6849f591cfc10f362278d6",
        "5f684a05bd264b7684400506",
        "5f684954980c2653d22d2d4f",
        "5f6849a491cfc10f3622789d",
        "5f6849b1bd264b76844004cd",
        "5f6849bd980c2653d22d2d6c",
        "5f6849cdbd264b76844004ea",
        "5f6849d891cfc10f362278ba",
        "5f6849e7980c2653d22d2d89",
        "5f6849f591cfc10f362278d7",
        "5f684a05bd264b7684400507",
        "5f684953980c2653d22d2d46",
        "5f69e6d86811e903a451a555",
        "5f6849afbd264b76844004c4",
        "5f6849bb980c2653d22d2d63",
        "5f6849ccbd264b76844004e1",
        "5f6849d791cfc10f362278b1",
        "5f6849e6980c2653d22d2d80",
        "5f6849f491cfc10f362278ce",
        "5f684a03bd264b76844004fe",
        "5f684953980c2653d22d2d47",
        "5f69e6d86811e903a451a556",
        "5f6849b0bd264b76844004c5",
        "5f6849bc980c2653d22d2d64",
        "5f6849ccbd264b76844004e2",
        "5f6849d791cfc10f362278b2",
        "5f6849e6980c2653d22d2d81",
        "5f6849f491cfc10f362278cf",
        "5f684a04bd264b76844004ff",
        "5f684956980c2653d22d2d5e",
        "5f6849b3bd264b76844004dd",
        "5f6849bf980c2653d22d2d7b",
        "5f6849cfbd264b76844004fa",
        "5f6849da91cfc10f362278c9",
        "5f6849e9980c2653d22d2d98",
        "6308ef7c9429464202c30b93",
        "5f684a07bd264b7684400517",
        "5f6849a691cfc10f362278ac",
        "5f6849cfbd264b76844004f9",
        "5f6849da91cfc10f362278ca",
        "5f6849e9980c2653d22d2d99",
        "5f6849f791cfc10f362278e7",
        "5f684a07bd264b7684400516",
        "5f684956980c2653d22d2d5f",
        "5f6849a691cfc10f362278ad",
        "5f6849b3bd264b76844004dc",
        "5f6849bf980c2653d22d2d7c",
        "6308ec4c5ce69d50819ff079",
        "6308ed2bcf1542c52f78b583",
        "6308eda8af33d200283532b9",
        "6308edde8ca283c07f2de18b",
        "6308ee93bfa3323159c376ca",
        "6308ef02980d3ebbe3c76439",
        "6308ef3dc2244ca8d3514aed",
        "5f6849f791cfc10f362278e6",
        "6308ec4c5ce69d50819ff076",
        "6308ed2bcf1542c52f78b580",
        "6308eda8af33d200283532b6",
        "6308edde8ca283c07f2de188"
      ],
      "stripe": "price_1QgnfqEy2I3xqILUXtXaFkQi",
      "children": 2,
      "subject": "math_ela",
      "cost": {
        "per_month": 11.988,
        "total": 288,
        "sale": 143.988
      },
      "options": {
        "trial": true,
        "updates": true,
        "money_back": false
      },
      "title": "K12 Premium Math & ELA",
      "description": "Most Popular! Save 50% while getting a full year of comprehensive learning. Perfect balance of value and flexibility - complete access to all premium features at our best annual rate.",
      "button_text": "TRY 3 DAYS FOR FREE"
    },
    {
      "exam": "k12",
      "featured": false,
      "period": "lifetime",
      "trial_period_days": 0,
      "premium_material_id": [
        "5f684953980c2653d22d2d4a",
        "5f6849a391cfc10f36227898",
        "5f6849b0bd264b76844004c8",
        "5f6849bc980c2653d22d2d67",
        "5f6849ccbd264b76844004e5",
        "5f6849d891cfc10f362278b5",
        "5f6849e6980c2653d22d2d84",
        "5f6849f491cfc10f362278d2",
        "5f684a04bd264b7684400502",
        "5f684953980c2653d22d2d4b",
        "5f6849a391cfc10f36227899",
        "5f6849b0bd264b76844004c9",
        "5f6849bc980c2653d22d2d68",
        "5f6849ccbd264b76844004e6",
        "5f6849d891cfc10f362278b6",
        "5f6849e6980c2653d22d2d85",
        "5f6849f591cfc10f362278d3",
        "5f684a04bd264b7684400503",
        "5f684954980c2653d22d2d4e",
        "5f6849a491cfc10f3622789c",
        "5f6849b1bd264b76844004cc",
        "5f6849bd980c2653d22d2d6b",
        "5f6849cdbd264b76844004e9",
        "5f6849d891cfc10f362278b9",
        "5f6849e7980c2653d22d2d88",
        "5f6849f591cfc10f362278d6",
        "5f684a05bd264b7684400506",
        "5f684954980c2653d22d2d4f",
        "5f6849a491cfc10f3622789d",
        "5f6849b1bd264b76844004cd",
        "5f6849bd980c2653d22d2d6c",
        "5f6849cdbd264b76844004ea",
        "5f6849d891cfc10f362278ba",
        "5f6849e7980c2653d22d2d89",
        "5f6849f591cfc10f362278d7",
        "5f684a05bd264b7684400507",
        "5f684953980c2653d22d2d46",
        "5f69e6d86811e903a451a555",
        "5f6849afbd264b76844004c4",
        "5f6849bb980c2653d22d2d63",
        "5f6849ccbd264b76844004e1",
        "5f6849d791cfc10f362278b1",
        "5f6849e6980c2653d22d2d80",
        "5f6849f491cfc10f362278ce",
        "5f684a03bd264b76844004fe",
        "5f684953980c2653d22d2d47",
        "5f69e6d86811e903a451a556",
        "5f6849b0bd264b76844004c5",
        "5f6849bc980c2653d22d2d64",
        "5f6849ccbd264b76844004e2",
        "5f6849d791cfc10f362278b2",
        "5f6849e6980c2653d22d2d81",
        "5f6849f491cfc10f362278cf",
        "5f684a04bd264b76844004ff",
        "5f684956980c2653d22d2d5e",
        "5f6849b3bd264b76844004dd",
        "5f6849bf980c2653d22d2d7b",
        "5f6849cfbd264b76844004fa",
        "5f6849da91cfc10f362278c9",
        "5f6849e9980c2653d22d2d98",
        "6308ef7c9429464202c30b93",
        "5f684a07bd264b7684400517",
        "5f6849a691cfc10f362278ac",
        "5f6849cfbd264b76844004f9",
        "5f6849da91cfc10f362278ca",
        "5f6849e9980c2653d22d2d99",
        "5f6849f791cfc10f362278e7",
        "5f684a07bd264b7684400516",
        "5f684956980c2653d22d2d5f",
        "5f6849a691cfc10f362278ad",
        "5f6849b3bd264b76844004dc",
        "5f6849bf980c2653d22d2d7c",
        "6308ec4c5ce69d50819ff079",
        "6308ed2bcf1542c52f78b583",
        "6308eda8af33d200283532b9",
        "6308edde8ca283c07f2de18b",
        "6308ee93bfa3323159c376ca",
        "6308ef02980d3ebbe3c76439",
        "6308ef3dc2244ca8d3514aed",
        "5f6849f791cfc10f362278e6",
        "6308ec4c5ce69d50819ff076",
        "6308ed2bcf1542c52f78b580",
        "6308eda8af33d200283532b6",
        "6308edde8ca283c07f2de188"
      ],
      "stripe": "price_1QgnfqEy2I3xqILUscIMj5xk",
      "children": 2,
      "subject": "math_ela",
      "cost": {
        "per_month": 4.788,
        "total": 1080,
        "sale": 599.9879999999999
      },
      "options": {
        "trial": false,
        "updates": true,
        "money_back": true
      },
      "title": "K12 Premium Math & ELA",
      "description": "One-time payment unlocks lifetime access for all your children. Includes every future update and premium feature - invest once, benefit forever. ",
      "button_text": "TRY"
    },
    {
      "exam": "k12",
      "featured": true,
      "period": "month",
      "trial_period_days": 0,
      "premium_material_id": [
        "5f684953980c2653d22d2d4a",
        "5f6849a391cfc10f36227898",
        "5f6849b0bd264b76844004c8",
        "5f6849bc980c2653d22d2d67",
        "5f6849ccbd264b76844004e5",
        "5f6849d891cfc10f362278b5",
        "5f6849e6980c2653d22d2d84",
        "5f6849f491cfc10f362278d2",
        "5f684a04bd264b7684400502",
        "5f684953980c2653d22d2d4b",
        "5f6849a391cfc10f36227899",
        "5f6849b0bd264b76844004c9",
        "5f6849bc980c2653d22d2d68",
        "5f6849ccbd264b76844004e6",
        "5f6849d891cfc10f362278b6",
        "5f6849e6980c2653d22d2d85",
        "5f6849f591cfc10f362278d3",
        "5f684a04bd264b7684400503",
        "5f684954980c2653d22d2d4e",
        "5f6849a491cfc10f3622789c",
        "5f6849b1bd264b76844004cc",
        "5f6849bd980c2653d22d2d6b",
        "5f6849cdbd264b76844004e9",
        "5f6849d891cfc10f362278b9",
        "5f6849e7980c2653d22d2d88",
        "5f6849f591cfc10f362278d6",
        "5f684a05bd264b7684400506",
        "5f684954980c2653d22d2d4f",
        "5f6849a491cfc10f3622789d",
        "5f6849b1bd264b76844004cd",
        "5f6849bd980c2653d22d2d6c",
        "5f6849cdbd264b76844004ea",
        "5f6849d891cfc10f362278ba",
        "5f6849e7980c2653d22d2d89",
        "5f6849f591cfc10f362278d7",
        "5f684a05bd264b7684400507",
        "5f684953980c2653d22d2d46",
        "5f69e6d86811e903a451a555",
        "5f6849afbd264b76844004c4",
        "5f6849bb980c2653d22d2d63",
        "5f6849ccbd264b76844004e1",
        "5f6849d791cfc10f362278b1",
        "5f6849e6980c2653d22d2d80",
        "5f6849f491cfc10f362278ce",
        "5f684a03bd264b76844004fe",
        "5f684953980c2653d22d2d47",
        "5f69e6d86811e903a451a556",
        "5f6849b0bd264b76844004c5",
        "5f6849bc980c2653d22d2d64",
        "5f6849ccbd264b76844004e2",
        "5f6849d791cfc10f362278b2",
        "5f6849e6980c2653d22d2d81",
        "5f6849f491cfc10f362278cf",
        "5f684a04bd264b76844004ff",
        "5f684956980c2653d22d2d5e",
        "5f6849b3bd264b76844004dd",
        "5f6849bf980c2653d22d2d7b",
        "5f6849cfbd264b76844004fa",
        "5f6849da91cfc10f362278c9",
        "5f6849e9980c2653d22d2d98",
        "6308ef7c9429464202c30b93",
        "5f684a07bd264b7684400517",
        "5f6849a691cfc10f362278ac",
        "5f6849cfbd264b76844004f9",
        "5f6849da91cfc10f362278ca",
        "5f6849e9980c2653d22d2d99",
        "5f6849f791cfc10f362278e7",
        "5f684a07bd264b7684400516",
        "5f684956980c2653d22d2d5f",
        "5f6849a691cfc10f362278ad",
        "5f6849b3bd264b76844004dc",
        "5f6849bf980c2653d22d2d7c",
        "6308ec4c5ce69d50819ff079",
        "6308ed2bcf1542c52f78b583",
        "6308eda8af33d200283532b9",
        "6308edde8ca283c07f2de18b",
        "6308ee93bfa3323159c376ca",
        "6308ef02980d3ebbe3c76439",
        "6308ef3dc2244ca8d3514aed",
        "5f6849f791cfc10f362278e6",
        "6308ec4c5ce69d50819ff076",
        "6308ed2bcf1542c52f78b580",
        "6308eda8af33d200283532b6",
        "6308edde8ca283c07f2de188"
      ],
      "stripe": "price_1QgnfqEy2I3xqILU3bMM02yw",
      "children": 3,
      "subject": "math_ela",
      "cost": {
        "per_month": 18.186,
        "total": 56,
        "sale": 18.186
      },
      "options": {
        "trial": true,
        "updates": false,
        "money_back": false
      },
      "title": "K12 Premium Math & ELA",
      "description": "Perfect for flexible learning - access expert-led lessons, practice questions, and printable workbooks instantly, with no long-term commitment.",
      "button_text": "TRY 3 DAYS FOR FREE"
    },
    {
      "exam": "k12",
      "featured": false,
      "period": "year",
      "trial_period_days": 0,
      "premium_material_id": [
        "5f684953980c2653d22d2d4a",
        "5f6849a391cfc10f36227898",
        "5f6849b0bd264b76844004c8",
        "5f6849bc980c2653d22d2d67",
        "5f6849ccbd264b76844004e5",
        "5f6849d891cfc10f362278b5",
        "5f6849e6980c2653d22d2d84",
        "5f6849f491cfc10f362278d2",
        "5f684a04bd264b7684400502",
        "5f684953980c2653d22d2d4b",
        "5f6849a391cfc10f36227899",
        "5f6849b0bd264b76844004c9",
        "5f6849bc980c2653d22d2d68",
        "5f6849ccbd264b76844004e6",
        "5f6849d891cfc10f362278b6",
        "5f6849e6980c2653d22d2d85",
        "5f6849f591cfc10f362278d3",
        "5f684a04bd264b7684400503",
        "5f684954980c2653d22d2d4e",
        "5f6849a491cfc10f3622789c",
        "5f6849b1bd264b76844004cc",
        "5f6849bd980c2653d22d2d6b",
        "5f6849cdbd264b76844004e9",
        "5f6849d891cfc10f362278b9",
        "5f6849e7980c2653d22d2d88",
        "5f6849f591cfc10f362278d6",
        "5f684a05bd264b7684400506",
        "5f684954980c2653d22d2d4f",
        "5f6849a491cfc10f3622789d",
        "5f6849b1bd264b76844004cd",
        "5f6849bd980c2653d22d2d6c",
        "5f6849cdbd264b76844004ea",
        "5f6849d891cfc10f362278ba",
        "5f6849e7980c2653d22d2d89",
        "5f6849f591cfc10f362278d7",
        "5f684a05bd264b7684400507",
        "5f684953980c2653d22d2d46",
        "5f69e6d86811e903a451a555",
        "5f6849afbd264b76844004c4",
        "5f6849bb980c2653d22d2d63",
        "5f6849ccbd264b76844004e1",
        "5f6849d791cfc10f362278b1",
        "5f6849e6980c2653d22d2d80",
        "5f6849f491cfc10f362278ce",
        "5f684a03bd264b76844004fe",
        "5f684953980c2653d22d2d47",
        "5f69e6d86811e903a451a556",
        "5f6849b0bd264b76844004c5",
        "5f6849bc980c2653d22d2d64",
        "5f6849ccbd264b76844004e2",
        "5f6849d791cfc10f362278b2",
        "5f6849e6980c2653d22d2d81",
        "5f6849f491cfc10f362278cf",
        "5f684a04bd264b76844004ff",
        "5f684956980c2653d22d2d5e",
        "5f6849b3bd264b76844004dd",
        "5f6849bf980c2653d22d2d7b",
        "5f6849cfbd264b76844004fa",
        "5f6849da91cfc10f362278c9",
        "5f6849e9980c2653d22d2d98",
        "6308ef7c9429464202c30b93",
        "5f684a07bd264b7684400517",
        "5f6849a691cfc10f362278ac",
        "5f6849cfbd264b76844004f9",
        "5f6849da91cfc10f362278ca",
        "5f6849e9980c2653d22d2d99",
        "5f6849f791cfc10f362278e7",
        "5f684a07bd264b7684400516",
        "5f684956980c2653d22d2d5f",
        "5f6849a691cfc10f362278ad",
        "5f6849b3bd264b76844004dc",
        "5f6849bf980c2653d22d2d7c",
        "6308ec4c5ce69d50819ff079",
        "6308ed2bcf1542c52f78b583",
        "6308eda8af33d200283532b9",
        "6308edde8ca283c07f2de18b",
        "6308ee93bfa3323159c376ca",
        "6308ef02980d3ebbe3c76439",
        "6308ef3dc2244ca8d3514aed",
        "5f6849f791cfc10f362278e6",
        "6308ec4c5ce69d50819ff076",
        "6308ed2bcf1542c52f78b580",
        "6308eda8af33d200283532b6",
        "6308edde8ca283c07f2de188"
      ],
      "stripe": "price_1QgnfqEy2I3xqILUxDjYjqFl",
      "children": 3,
      "subject": "math_ela",
      "cost": {
        "per_month": 13.985999999999999,
        "total": 336,
        "sale": 167.986
      },
      "options": {
        "trial": true,
        "updates": true,
        "money_back": false
      },
      "title": "K12 Premium Math & ELA",
      "description": "Most Popular! Save 50% while getting a full year of comprehensive learning. Perfect balance of value and flexibility - complete access to all premium features at our best annual rate.",
      "button_text": "TRY 3 DAYS FOR FREE"
    },
    {
      "exam": "k12",
      "featured": false,
      "period": "lifetime",
      "trial_period_days": 0,
      "premium_material_id": [
        "5f684953980c2653d22d2d4a",
        "5f6849a391cfc10f36227898",
        "5f6849b0bd264b76844004c8",
        "5f6849bc980c2653d22d2d67",
        "5f6849ccbd264b76844004e5",
        "5f6849d891cfc10f362278b5",
        "5f6849e6980c2653d22d2d84",
        "5f6849f491cfc10f362278d2",
        "5f684a04bd264b7684400502",
        "5f684953980c2653d22d2d4b",
        "5f6849a391cfc10f36227899",
        "5f6849b0bd264b76844004c9",
        "5f6849bc980c2653d22d2d68",
        "5f6849ccbd264b76844004e6",
        "5f6849d891cfc10f362278b6",
        "5f6849e6980c2653d22d2d85",
        "5f6849f591cfc10f362278d3",
        "5f684a04bd264b7684400503",
        "5f684954980c2653d22d2d4e",
        "5f6849a491cfc10f3622789c",
        "5f6849b1bd264b76844004cc",
        "5f6849bd980c2653d22d2d6b",
        "5f6849cdbd264b76844004e9",
        "5f6849d891cfc10f362278b9",
        "5f6849e7980c2653d22d2d88",
        "5f6849f591cfc10f362278d6",
        "5f684a05bd264b7684400506",
        "5f684954980c2653d22d2d4f",
        "5f6849a491cfc10f3622789d",
        "5f6849b1bd264b76844004cd",
        "5f6849bd980c2653d22d2d6c",
        "5f6849cdbd264b76844004ea",
        "5f6849d891cfc10f362278ba",
        "5f6849e7980c2653d22d2d89",
        "5f6849f591cfc10f362278d7",
        "5f684a05bd264b7684400507",
        "5f684953980c2653d22d2d46",
        "5f69e6d86811e903a451a555",
        "5f6849afbd264b76844004c4",
        "5f6849bb980c2653d22d2d63",
        "5f6849ccbd264b76844004e1",
        "5f6849d791cfc10f362278b1",
        "5f6849e6980c2653d22d2d80",
        "5f6849f491cfc10f362278ce",
        "5f684a03bd264b76844004fe",
        "5f684953980c2653d22d2d47",
        "5f69e6d86811e903a451a556",
        "5f6849b0bd264b76844004c5",
        "5f6849bc980c2653d22d2d64",
        "5f6849ccbd264b76844004e2",
        "5f6849d791cfc10f362278b2",
        "5f6849e6980c2653d22d2d81",
        "5f6849f491cfc10f362278cf",
        "5f684a04bd264b76844004ff",
        "5f684956980c2653d22d2d5e",
        "5f6849b3bd264b76844004dd",
        "5f6849bf980c2653d22d2d7b",
        "5f6849cfbd264b76844004fa",
        "5f6849da91cfc10f362278c9",
        "5f6849e9980c2653d22d2d98",
        "6308ef7c9429464202c30b93",
        "5f684a07bd264b7684400517",
        "5f6849a691cfc10f362278ac",
        "5f6849cfbd264b76844004f9",
        "5f6849da91cfc10f362278ca",
        "5f6849e9980c2653d22d2d99",
        "5f6849f791cfc10f362278e7",
        "5f684a07bd264b7684400516",
        "5f684956980c2653d22d2d5f",
        "5f6849a691cfc10f362278ad",
        "5f6849b3bd264b76844004dc",
        "5f6849bf980c2653d22d2d7c",
        "6308ec4c5ce69d50819ff079",
        "6308ed2bcf1542c52f78b583",
        "6308eda8af33d200283532b9",
        "6308edde8ca283c07f2de18b",
        "6308ee93bfa3323159c376ca",
        "6308ef02980d3ebbe3c76439",
        "6308ef3dc2244ca8d3514aed",
        "5f6849f791cfc10f362278e6",
        "6308ec4c5ce69d50819ff076",
        "6308ed2bcf1542c52f78b580",
        "6308eda8af33d200283532b6",
        "6308edde8ca283c07f2de188"
      ],
      "stripe": "price_1QgnfqEy2I3xqILUqv0Hi0q6",
      "children": 3,
      "subject": "math_ela",
      "cost": {
        "per_month": 5.586,
        "total": 1260,
        "sale": 699.986
      },
      "options": {
        "trial": false,
        "updates": true,
        "money_back": true
      },
      "title": "K12 Premium Math & ELA",
      "description": "One-time payment unlocks lifetime access for all your children. Includes every future update and premium feature - invest once, benefit forever. ",
      "button_text": "TRY"
    },
    {
      "exam": "k12",
      "featured": true,
      "period": "month",
      "trial_period_days": 0,
      "premium_material_id": [
        "5f684953980c2653d22d2d4a",
        "5f6849a391cfc10f36227898",
        "5f6849b0bd264b76844004c8",
        "5f6849bc980c2653d22d2d67",
        "5f6849ccbd264b76844004e5",
        "5f6849d891cfc10f362278b5",
        "5f6849e6980c2653d22d2d84",
        "5f6849f491cfc10f362278d2",
        "5f684a04bd264b7684400502",
        "5f684953980c2653d22d2d4b",
        "5f6849a391cfc10f36227899",
        "5f6849b0bd264b76844004c9",
        "5f6849bc980c2653d22d2d68",
        "5f6849ccbd264b76844004e6",
        "5f6849d891cfc10f362278b6",
        "5f6849e6980c2653d22d2d85",
        "5f6849f591cfc10f362278d3",
        "5f684a04bd264b7684400503",
        "5f684954980c2653d22d2d4e",
        "5f6849a491cfc10f3622789c",
        "5f6849b1bd264b76844004cc",
        "5f6849bd980c2653d22d2d6b",
        "5f6849cdbd264b76844004e9",
        "5f6849d891cfc10f362278b9",
        "5f6849e7980c2653d22d2d88",
        "5f6849f591cfc10f362278d6",
        "5f684a05bd264b7684400506",
        "5f684954980c2653d22d2d4f",
        "5f6849a491cfc10f3622789d",
        "5f6849b1bd264b76844004cd",
        "5f6849bd980c2653d22d2d6c",
        "5f6849cdbd264b76844004ea",
        "5f6849d891cfc10f362278ba",
        "5f6849e7980c2653d22d2d89",
        "5f6849f591cfc10f362278d7",
        "5f684a05bd264b7684400507",
        "5f684953980c2653d22d2d46",
        "5f69e6d86811e903a451a555",
        "5f6849afbd264b76844004c4",
        "5f6849bb980c2653d22d2d63",
        "5f6849ccbd264b76844004e1",
        "5f6849d791cfc10f362278b1",
        "5f6849e6980c2653d22d2d80",
        "5f6849f491cfc10f362278ce",
        "5f684a03bd264b76844004fe",
        "5f684953980c2653d22d2d47",
        "5f69e6d86811e903a451a556",
        "5f6849b0bd264b76844004c5",
        "5f6849bc980c2653d22d2d64",
        "5f6849ccbd264b76844004e2",
        "5f6849d791cfc10f362278b2",
        "5f6849e6980c2653d22d2d81",
        "5f6849f491cfc10f362278cf",
        "5f684a04bd264b76844004ff",
        "5f684956980c2653d22d2d5e",
        "5f6849b3bd264b76844004dd",
        "5f6849bf980c2653d22d2d7b",
        "5f6849cfbd264b76844004fa",
        "5f6849da91cfc10f362278c9",
        "5f6849e9980c2653d22d2d98",
        "6308ef7c9429464202c30b93",
        "5f684a07bd264b7684400517",
        "5f6849a691cfc10f362278ac",
        "5f6849cfbd264b76844004f9",
        "5f6849da91cfc10f362278ca",
        "5f6849e9980c2653d22d2d99",
        "5f6849f791cfc10f362278e7",
        "5f684a07bd264b7684400516",
        "5f684956980c2653d22d2d5f",
        "5f6849a691cfc10f362278ad",
        "5f6849b3bd264b76844004dc",
        "5f6849bf980c2653d22d2d7c",
        "6308ec4c5ce69d50819ff079",
        "6308ed2bcf1542c52f78b583",
        "6308eda8af33d200283532b9",
        "6308edde8ca283c07f2de18b",
        "6308ee93bfa3323159c376ca",
        "6308ef02980d3ebbe3c76439",
        "6308ef3dc2244ca8d3514aed",
        "5f6849f791cfc10f362278e6",
        "6308ec4c5ce69d50819ff076",
        "6308ed2bcf1542c52f78b580",
        "6308eda8af33d200283532b6",
        "6308edde8ca283c07f2de188"
      ],
      "stripe": "price_1QgnfqEy2I3xqILUmNRthM25",
      "children": 4,
      "subject": "math_ela",
      "cost": {
        "per_month": 20.784000000000002,
        "total": 64,
        "sale": 20.784000000000002
      },
      "options": {
        "trial": true,
        "updates": false,
        "money_back": false
      },
      "title": "K12 Premium Math & ELA",
      "description": "Perfect for flexible learning - access expert-led lessons, practice questions, and printable workbooks instantly, with no long-term commitment.",
      "button_text": "TRY 3 DAYS FOR FREE"
    },
    {
      "exam": "k12",
      "featured": false,
      "period": "year",
      "trial_period_days": 0,
      "premium_material_id": [
        "5f684953980c2653d22d2d4a",
        "5f6849a391cfc10f36227898",
        "5f6849b0bd264b76844004c8",
        "5f6849bc980c2653d22d2d67",
        "5f6849ccbd264b76844004e5",
        "5f6849d891cfc10f362278b5",
        "5f6849e6980c2653d22d2d84",
        "5f6849f491cfc10f362278d2",
        "5f684a04bd264b7684400502",
        "5f684953980c2653d22d2d4b",
        "5f6849a391cfc10f36227899",
        "5f6849b0bd264b76844004c9",
        "5f6849bc980c2653d22d2d68",
        "5f6849ccbd264b76844004e6",
        "5f6849d891cfc10f362278b6",
        "5f6849e6980c2653d22d2d85",
        "5f6849f591cfc10f362278d3",
        "5f684a04bd264b7684400503",
        "5f684954980c2653d22d2d4e",
        "5f6849a491cfc10f3622789c",
        "5f6849b1bd264b76844004cc",
        "5f6849bd980c2653d22d2d6b",
        "5f6849cdbd264b76844004e9",
        "5f6849d891cfc10f362278b9",
        "5f6849e7980c2653d22d2d88",
        "5f6849f591cfc10f362278d6",
        "5f684a05bd264b7684400506",
        "5f684954980c2653d22d2d4f",
        "5f6849a491cfc10f3622789d",
        "5f6849b1bd264b76844004cd",
        "5f6849bd980c2653d22d2d6c",
        "5f6849cdbd264b76844004ea",
        "5f6849d891cfc10f362278ba",
        "5f6849e7980c2653d22d2d89",
        "5f6849f591cfc10f362278d7",
        "5f684a05bd264b7684400507",
        "5f684953980c2653d22d2d46",
        "5f69e6d86811e903a451a555",
        "5f6849afbd264b76844004c4",
        "5f6849bb980c2653d22d2d63",
        "5f6849ccbd264b76844004e1",
        "5f6849d791cfc10f362278b1",
        "5f6849e6980c2653d22d2d80",
        "5f6849f491cfc10f362278ce",
        "5f684a03bd264b76844004fe",
        "5f684953980c2653d22d2d47",
        "5f69e6d86811e903a451a556",
        "5f6849b0bd264b76844004c5",
        "5f6849bc980c2653d22d2d64",
        "5f6849ccbd264b76844004e2",
        "5f6849d791cfc10f362278b2",
        "5f6849e6980c2653d22d2d81",
        "5f6849f491cfc10f362278cf",
        "5f684a04bd264b76844004ff",
        "5f684956980c2653d22d2d5e",
        "5f6849b3bd264b76844004dd",
        "5f6849bf980c2653d22d2d7b",
        "5f6849cfbd264b76844004fa",
        "5f6849da91cfc10f362278c9",
        "5f6849e9980c2653d22d2d98",
        "6308ef7c9429464202c30b93",
        "5f684a07bd264b7684400517",
        "5f6849a691cfc10f362278ac",
        "5f6849cfbd264b76844004f9",
        "5f6849da91cfc10f362278ca",
        "5f6849e9980c2653d22d2d99",
        "5f6849f791cfc10f362278e7",
        "5f684a07bd264b7684400516",
        "5f684956980c2653d22d2d5f",
        "5f6849a691cfc10f362278ad",
        "5f6849b3bd264b76844004dc",
        "5f6849bf980c2653d22d2d7c",
        "6308ec4c5ce69d50819ff079",
        "6308ed2bcf1542c52f78b583",
        "6308eda8af33d200283532b9",
        "6308edde8ca283c07f2de18b",
        "6308ee93bfa3323159c376ca",
        "6308ef02980d3ebbe3c76439",
        "6308ef3dc2244ca8d3514aed",
        "5f6849f791cfc10f362278e6",
        "6308ec4c5ce69d50819ff076",
        "6308ed2bcf1542c52f78b580",
        "6308eda8af33d200283532b6",
        "6308edde8ca283c07f2de188"
      ],
      "stripe": "price_1QgnfqEy2I3xqILUW4zVRP6Y",
      "children": 4,
      "subject": "math_ela",
      "cost": {
        "per_month": 15.984000000000002,
        "total": 384,
        "sale": 191.984
      },
      "options": {
        "trial": true,
        "updates": true,
        "money_back": false
      },
      "title": "K12 Premium Math & ELA",
      "description": "Most Popular! Save 50% while getting a full year of comprehensive learning. Perfect balance of value and flexibility - complete access to all premium features at our best annual rate.",
      "button_text": "TRY 3 DAYS FOR FREE"
    },
    {
      "exam": "k12",
      "featured": false,
      "period": "lifetime",
      "trial_period_days": 0,
      "premium_material_id": [
        "5f684953980c2653d22d2d4a",
        "5f6849a391cfc10f36227898",
        "5f6849b0bd264b76844004c8",
        "5f6849bc980c2653d22d2d67",
        "5f6849ccbd264b76844004e5",
        "5f6849d891cfc10f362278b5",
        "5f6849e6980c2653d22d2d84",
        "5f6849f491cfc10f362278d2",
        "5f684a04bd264b7684400502",
        "5f684953980c2653d22d2d4b",
        "5f6849a391cfc10f36227899",
        "5f6849b0bd264b76844004c9",
        "5f6849bc980c2653d22d2d68",
        "5f6849ccbd264b76844004e6",
        "5f6849d891cfc10f362278b6",
        "5f6849e6980c2653d22d2d85",
        "5f6849f591cfc10f362278d3",
        "5f684a04bd264b7684400503",
        "5f684954980c2653d22d2d4e",
        "5f6849a491cfc10f3622789c",
        "5f6849b1bd264b76844004cc",
        "5f6849bd980c2653d22d2d6b",
        "5f6849cdbd264b76844004e9",
        "5f6849d891cfc10f362278b9",
        "5f6849e7980c2653d22d2d88",
        "5f6849f591cfc10f362278d6",
        "5f684a05bd264b7684400506",
        "5f684954980c2653d22d2d4f",
        "5f6849a491cfc10f3622789d",
        "5f6849b1bd264b76844004cd",
        "5f6849bd980c2653d22d2d6c",
        "5f6849cdbd264b76844004ea",
        "5f6849d891cfc10f362278ba",
        "5f6849e7980c2653d22d2d89",
        "5f6849f591cfc10f362278d7",
        "5f684a05bd264b7684400507",
        "5f684953980c2653d22d2d46",
        "5f69e6d86811e903a451a555",
        "5f6849afbd264b76844004c4",
        "5f6849bb980c2653d22d2d63",
        "5f6849ccbd264b76844004e1",
        "5f6849d791cfc10f362278b1",
        "5f6849e6980c2653d22d2d80",
        "5f6849f491cfc10f362278ce",
        "5f684a03bd264b76844004fe",
        "5f684953980c2653d22d2d47",
        "5f69e6d86811e903a451a556",
        "5f6849b0bd264b76844004c5",
        "5f6849bc980c2653d22d2d64",
        "5f6849ccbd264b76844004e2",
        "5f6849d791cfc10f362278b2",
        "5f6849e6980c2653d22d2d81",
        "5f6849f491cfc10f362278cf",
        "5f684a04bd264b76844004ff",
        "5f684956980c2653d22d2d5e",
        "5f6849b3bd264b76844004dd",
        "5f6849bf980c2653d22d2d7b",
        "5f6849cfbd264b76844004fa",
        "5f6849da91cfc10f362278c9",
        "5f6849e9980c2653d22d2d98",
        "6308ef7c9429464202c30b93",
        "5f684a07bd264b7684400517",
        "5f6849a691cfc10f362278ac",
        "5f6849cfbd264b76844004f9",
        "5f6849da91cfc10f362278ca",
        "5f6849e9980c2653d22d2d99",
        "5f6849f791cfc10f362278e7",
        "5f684a07bd264b7684400516",
        "5f684956980c2653d22d2d5f",
        "5f6849a691cfc10f362278ad",
        "5f6849b3bd264b76844004dc",
        "5f6849bf980c2653d22d2d7c",
        "6308ec4c5ce69d50819ff079",
        "6308ed2bcf1542c52f78b583",
        "6308eda8af33d200283532b9",
        "6308edde8ca283c07f2de18b",
        "6308ee93bfa3323159c376ca",
        "6308ef02980d3ebbe3c76439",
        "6308ef3dc2244ca8d3514aed",
        "5f6849f791cfc10f362278e6",
        "6308ec4c5ce69d50819ff076",
        "6308ed2bcf1542c52f78b580",
        "6308eda8af33d200283532b6",
        "6308edde8ca283c07f2de188"
      ],
      "stripe": "price_1QgnfqEy2I3xqILUgeFmuc9P",
      "children": 4,
      "subject": "math_ela",
      "cost": {
        "per_month": 6.384,
        "total": 1440,
        "sale": 799.984
      },
      "options": {
        "trial": false,
        "updates": true,
        "money_back": true
      },
      "title": "K12 Premium Math & ELA",
      "description": "One-time payment unlocks lifetime access for all your children. Includes every future update and premium feature - invest once, benefit forever. ",
      "button_text": "TRY"
    },
    {
      "exam": "k12",
      "featured": true,
      "period": "month",
      "trial_period_days": 0,
      "premium_material_id": [
        "5f684953980c2653d22d2d4a",
        "5f6849a391cfc10f36227898",
        "5f6849b0bd264b76844004c8",
        "5f6849bc980c2653d22d2d67",
        "5f6849ccbd264b76844004e5",
        "5f6849d891cfc10f362278b5",
        "5f6849e6980c2653d22d2d84",
        "5f6849f491cfc10f362278d2",
        "5f684a04bd264b7684400502",
        "5f684953980c2653d22d2d4b",
        "5f6849a391cfc10f36227899",
        "5f6849b0bd264b76844004c9",
        "5f6849bc980c2653d22d2d68",
        "5f6849ccbd264b76844004e6",
        "5f6849d891cfc10f362278b6",
        "5f6849e6980c2653d22d2d85",
        "5f6849f591cfc10f362278d3",
        "5f684a04bd264b7684400503",
        "5f684954980c2653d22d2d50",
        "5f6849a491cfc10f3622789e",
        "5f6849b1bd264b76844004ce",
        "5f6849bc980c2653d22d2d69",
        "5f6849cdbd264b76844004e7",
        "5f6849d891cfc10f362278b7",
        "5f6849e6980c2653d22d2d86",
        "5f6849f591cfc10f362278d4",
        "5f684a04bd264b7684400504",
        "5f684954980c2653d22d2d4e",
        "5f6849a491cfc10f3622789c",
        "5f6849b1bd264b76844004cc",
        "5f6849bd980c2653d22d2d6b",
        "5f6849cdbd264b76844004e9",
        "5f6849d891cfc10f362278b9",
        "5f6849e7980c2653d22d2d88",
        "5f6849f591cfc10f362278d6",
        "5f684a05bd264b7684400506",
        "5f684954980c2653d22d2d4f",
        "5f6849a491cfc10f3622789d",
        "5f6849b1bd264b76844004cd",
        "5f6849bd980c2653d22d2d6c",
        "5f6849cdbd264b76844004ea",
        "5f6849d891cfc10f362278ba",
        "5f6849e7980c2653d22d2d89",
        "5f6849f591cfc10f362278d7",
        "5f684a05bd264b7684400507",
        "5f684954980c2653d22d2d4c",
        "5f6849a491cfc10f3622789a",
        "5f6849b0bd264b76844004ca",
        "5f6849bd980c2653d22d2d6d",
        "5f6849cdbd264b76844004eb",
        "5f6849d891cfc10f362278bb",
        "5f6849e7980c2653d22d2d8a",
        "5f6849f591cfc10f362278d8",
        "5f684a05bd264b7684400508",
        "5f684953980c2653d22d2d46",
        "5f69e6d86811e903a451a555",
        "5f6849afbd264b76844004c4",
        "5f6849bb980c2653d22d2d63",
        "5f6849ccbd264b76844004e1",
        "5f6849d791cfc10f362278b1",
        "5f6849e6980c2653d22d2d80",
        "5f6849f491cfc10f362278ce",
        "5f684a03bd264b76844004fe",
        "5f684953980c2653d22d2d47",
        "5f69e6d86811e903a451a556",
        "5f6849b0bd264b76844004c5",
        "5f6849bc980c2653d22d2d64",
        "5f6849ccbd264b76844004e2",
        "5f6849d791cfc10f362278b2",
        "5f6849e6980c2653d22d2d81",
        "5f6849f491cfc10f362278cf",
        "5f684a04bd264b76844004ff",
        "5f684953980c2653d22d2d48",
        "5f6849a391cfc10f36227896",
        "5f6849b0bd264b76844004c6",
        "5f6849bc980c2653d22d2d65",
        "5f6849ccbd264b76844004e3",
        "5f6849d791cfc10f362278b3",
        "5f6849e6980c2653d22d2d82",
        "5f6849f491cfc10f362278d0",
        "5f684a04bd264b7684400500",
        "5f684956980c2653d22d2d5e",
        "5f6849a691cfc10f362278ae",
        "5f6849b3bd264b76844004dd",
        "5f6849bf980c2653d22d2d7b",
        "5f6849cfbd264b76844004fa",
        "5f6849da91cfc10f362278c9",
        "5f6849e9980c2653d22d2d98",
        "6308ef7c9429464202c30b93",
        "5f684a07bd264b7684400517",
        "5f684956980c2653d22d2d60",
        "5f6849a691cfc10f362278ac",
        "5f6849b3bd264b76844004de",
        "5f6849bf980c2653d22d2d7d",
        "5f6849cfbd264b76844004f9",
        "5f6849da91cfc10f362278ca",
        "5f6849e9980c2653d22d2d99",
        "5f6849f791cfc10f362278e7",
        "5f684a07bd264b7684400516",
        "5f684956980c2653d22d2d5f",
        "5f6849a691cfc10f362278ad",
        "5f6849b3bd264b76844004dc",
        "5f6849bf980c2653d22d2d7c",
        "5f6849cfbd264b76844004fb",
        "5f6849db91cfc10f362278cb",
        "5f6849e9980c2653d22d2d9a",
        "5f6849f791cfc10f362278e8",
        "5f684a07bd264b7684400518",
        "6308ec4c5ce69d50819ff079",
        "6308ed2bcf1542c52f78b583",
        "6308eda8af33d200283532b9",
        "6308edde8ca283c07f2de18b",
        "6308ee93bfa3323159c376ca",
        "6308ef02980d3ebbe3c76439",
        "6308ef3dc2244ca8d3514aed",
        "5f6849f791cfc10f362278e6",
        "6308ec4c5ce69d50819ff076",
        "6308ed2bcf1542c52f78b580",
        "6308eda8af33d200283532b6",
        "6308edde8ca283c07f2de188"
      ],
      "stripe": "price_1QgnfqEy2I3xqILUisiZG2u9",
      "children": 1,
      "subject": "math_ela_science",
      "cost": {
        "per_month": 12.99,
        "science_per_month": 4.99,
        "total": 50,
        "sale": 16.98
      },
      "options": {
        "trial": true,
        "updates": false,
        "money_back": false
      },
      "title": "K12 Premium Math & ELA & Science",
      "description": "Perfect for flexible learning - access expert-led lessons, practice questions, and printable workbooks instantly, with no long-term commitment.",
      "button_text": "TRY 3 DAYS FOR FREE"
    },
    {
      "exam": "k12",
      "featured": false,
      "period": "year",
      "trial_period_days": 0,
      "premium_material_id": [
        "5f684953980c2653d22d2d4a",
        "5f6849a391cfc10f36227898",
        "5f6849b0bd264b76844004c8",
        "5f6849bc980c2653d22d2d67",
        "5f6849ccbd264b76844004e5",
        "5f6849d891cfc10f362278b5",
        "5f6849e6980c2653d22d2d84",
        "5f6849f491cfc10f362278d2",
        "5f684a04bd264b7684400502",
        "5f684953980c2653d22d2d4b",
        "5f6849a391cfc10f36227899",
        "5f6849b0bd264b76844004c9",
        "5f6849bc980c2653d22d2d68",
        "5f6849ccbd264b76844004e6",
        "5f6849d891cfc10f362278b6",
        "5f6849e6980c2653d22d2d85",
        "5f6849f591cfc10f362278d3",
        "5f684a04bd264b7684400503",
        "5f684954980c2653d22d2d50",
        "5f6849a491cfc10f3622789e",
        "5f6849b1bd264b76844004ce",
        "5f6849bc980c2653d22d2d69",
        "5f6849cdbd264b76844004e7",
        "5f6849d891cfc10f362278b7",
        "5f6849e6980c2653d22d2d86",
        "5f6849f591cfc10f362278d4",
        "5f684a04bd264b7684400504",
        "5f684954980c2653d22d2d4e",
        "5f6849a491cfc10f3622789c",
        "5f6849b1bd264b76844004cc",
        "5f6849bd980c2653d22d2d6b",
        "5f6849cdbd264b76844004e9",
        "5f6849d891cfc10f362278b9",
        "5f6849e7980c2653d22d2d88",
        "5f6849f591cfc10f362278d6",
        "5f684a05bd264b7684400506",
        "5f684954980c2653d22d2d4f",
        "5f6849a491cfc10f3622789d",
        "5f6849b1bd264b76844004cd",
        "5f6849bd980c2653d22d2d6c",
        "5f6849cdbd264b76844004ea",
        "5f6849d891cfc10f362278ba",
        "5f6849e7980c2653d22d2d89",
        "5f6849f591cfc10f362278d7",
        "5f684a05bd264b7684400507",
        "5f684954980c2653d22d2d4c",
        "5f6849a491cfc10f3622789a",
        "5f6849b0bd264b76844004ca",
        "5f6849bd980c2653d22d2d6d",
        "5f6849cdbd264b76844004eb",
        "5f6849d891cfc10f362278bb",
        "5f6849e7980c2653d22d2d8a",
        "5f6849f591cfc10f362278d8",
        "5f684a05bd264b7684400508",
        "5f684953980c2653d22d2d46",
        "5f69e6d86811e903a451a555",
        "5f6849afbd264b76844004c4",
        "5f6849bb980c2653d22d2d63",
        "5f6849ccbd264b76844004e1",
        "5f6849d791cfc10f362278b1",
        "5f6849e6980c2653d22d2d80",
        "5f6849f491cfc10f362278ce",
        "5f684a03bd264b76844004fe",
        "5f684953980c2653d22d2d47",
        "5f69e6d86811e903a451a556",
        "5f6849b0bd264b76844004c5",
        "5f6849bc980c2653d22d2d64",
        "5f6849ccbd264b76844004e2",
        "5f6849d791cfc10f362278b2",
        "5f6849e6980c2653d22d2d81",
        "5f6849f491cfc10f362278cf",
        "5f684a04bd264b76844004ff",
        "5f684953980c2653d22d2d48",
        "5f6849a391cfc10f36227896",
        "5f6849b0bd264b76844004c6",
        "5f6849bc980c2653d22d2d65",
        "5f6849ccbd264b76844004e3",
        "5f6849d791cfc10f362278b3",
        "5f6849e6980c2653d22d2d82",
        "5f6849f491cfc10f362278d0",
        "5f684a04bd264b7684400500",
        "5f684956980c2653d22d2d5e",
        "5f6849a691cfc10f362278ae",
        "5f6849b3bd264b76844004dd",
        "5f6849bf980c2653d22d2d7b",
        "5f6849cfbd264b76844004fa",
        "5f6849da91cfc10f362278c9",
        "5f6849e9980c2653d22d2d98",
        "6308ef7c9429464202c30b93",
        "5f684a07bd264b7684400517",
        "5f684956980c2653d22d2d60",
        "5f6849a691cfc10f362278ac",
        "5f6849b3bd264b76844004de",
        "5f6849bf980c2653d22d2d7d",
        "5f6849cfbd264b76844004f9",
        "5f6849da91cfc10f362278ca",
        "5f6849e9980c2653d22d2d99",
        "5f6849f791cfc10f362278e7",
        "5f684a07bd264b7684400516",
        "5f684956980c2653d22d2d5f",
        "5f6849a691cfc10f362278ad",
        "5f6849b3bd264b76844004dc",
        "5f6849bf980c2653d22d2d7c",
        "5f6849cfbd264b76844004fb",
        "5f6849db91cfc10f362278cb",
        "5f6849e9980c2653d22d2d9a",
        "5f6849f791cfc10f362278e8",
        "5f684a07bd264b7684400518",
        "6308ec4c5ce69d50819ff079",
        "6308ed2bcf1542c52f78b583",
        "6308eda8af33d200283532b9",
        "6308edde8ca283c07f2de18b",
        "6308ee93bfa3323159c376ca",
        "6308ef02980d3ebbe3c76439",
        "6308ef3dc2244ca8d3514aed",
        "5f6849f791cfc10f362278e6",
        "6308ec4c5ce69d50819ff076",
        "6308ed2bcf1542c52f78b580",
        "6308eda8af33d200283532b6",
        "6308edde8ca283c07f2de188"
      ],
      "stripe": "price_1QgnfqEy2I3xqILUaWTOSgZ3",
      "children": 1,
      "subject": "math_ela_science",
      "cost": {
        "per_month": 9.99,
        "science_per_month": 4.99,
        "total": 340,
        "sale": 179.76
      },
      "options": {
        "trial": true,
        "updates": true,
        "money_back": false
      },
      "title": "K12 Premium Math & ELA & Science",
      "description": "Most Popular! Save 50% while getting a full year of comprehensive learning. Perfect balance of value and flexibility - complete access to all premium features at our best annual rate.",
      "button_text": "TRY 3 DAYS FOR FREE"
    },
    {
      "exam": "k12",
      "featured": false,
      "period": "lifetime",
      "trial_period_days": 0,
      "premium_material_id": [
        "5f684953980c2653d22d2d4a",
        "5f6849a391cfc10f36227898",
        "5f6849b0bd264b76844004c8",
        "5f6849bc980c2653d22d2d67",
        "5f6849ccbd264b76844004e5",
        "5f6849d891cfc10f362278b5",
        "5f6849e6980c2653d22d2d84",
        "5f6849f491cfc10f362278d2",
        "5f684a04bd264b7684400502",
        "5f684953980c2653d22d2d4b",
        "5f6849a391cfc10f36227899",
        "5f6849b0bd264b76844004c9",
        "5f6849bc980c2653d22d2d68",
        "5f6849ccbd264b76844004e6",
        "5f6849d891cfc10f362278b6",
        "5f6849e6980c2653d22d2d85",
        "5f6849f591cfc10f362278d3",
        "5f684a04bd264b7684400503",
        "5f684954980c2653d22d2d50",
        "5f6849a491cfc10f3622789e",
        "5f6849b1bd264b76844004ce",
        "5f6849bc980c2653d22d2d69",
        "5f6849cdbd264b76844004e7",
        "5f6849d891cfc10f362278b7",
        "5f6849e6980c2653d22d2d86",
        "5f6849f591cfc10f362278d4",
        "5f684a04bd264b7684400504",
        "5f684954980c2653d22d2d4e",
        "5f6849a491cfc10f3622789c",
        "5f6849b1bd264b76844004cc",
        "5f6849bd980c2653d22d2d6b",
        "5f6849cdbd264b76844004e9",
        "5f6849d891cfc10f362278b9",
        "5f6849e7980c2653d22d2d88",
        "5f6849f591cfc10f362278d6",
        "5f684a05bd264b7684400506",
        "5f684954980c2653d22d2d4f",
        "5f6849a491cfc10f3622789d",
        "5f6849b1bd264b76844004cd",
        "5f6849bd980c2653d22d2d6c",
        "5f6849cdbd264b76844004ea",
        "5f6849d891cfc10f362278ba",
        "5f6849e7980c2653d22d2d89",
        "5f6849f591cfc10f362278d7",
        "5f684a05bd264b7684400507",
        "5f684954980c2653d22d2d4c",
        "5f6849a491cfc10f3622789a",
        "5f6849b0bd264b76844004ca",
        "5f6849bd980c2653d22d2d6d",
        "5f6849cdbd264b76844004eb",
        "5f6849d891cfc10f362278bb",
        "5f6849e7980c2653d22d2d8a",
        "5f6849f591cfc10f362278d8",
        "5f684a05bd264b7684400508",
        "5f684953980c2653d22d2d46",
        "5f69e6d86811e903a451a555",
        "5f6849afbd264b76844004c4",
        "5f6849bb980c2653d22d2d63",
        "5f6849ccbd264b76844004e1",
        "5f6849d791cfc10f362278b1",
        "5f6849e6980c2653d22d2d80",
        "5f6849f491cfc10f362278ce",
        "5f684a03bd264b76844004fe",
        "5f684953980c2653d22d2d47",
        "5f69e6d86811e903a451a556",
        "5f6849b0bd264b76844004c5",
        "5f6849bc980c2653d22d2d64",
        "5f6849ccbd264b76844004e2",
        "5f6849d791cfc10f362278b2",
        "5f6849e6980c2653d22d2d81",
        "5f6849f491cfc10f362278cf",
        "5f684a04bd264b76844004ff",
        "5f684953980c2653d22d2d48",
        "5f6849a391cfc10f36227896",
        "5f6849b0bd264b76844004c6",
        "5f6849bc980c2653d22d2d65",
        "5f6849ccbd264b76844004e3",
        "5f6849d791cfc10f362278b3",
        "5f6849e6980c2653d22d2d82",
        "5f6849f491cfc10f362278d0",
        "5f684a04bd264b7684400500",
        "5f684956980c2653d22d2d5e",
        "5f6849a691cfc10f362278ae",
        "5f6849b3bd264b76844004dd",
        "5f6849bf980c2653d22d2d7b",
        "5f6849cfbd264b76844004fa",
        "5f6849da91cfc10f362278c9",
        "5f6849e9980c2653d22d2d98",
        "6308ef7c9429464202c30b93",
        "5f684a07bd264b7684400517",
        "5f684956980c2653d22d2d60",
        "5f6849a691cfc10f362278ac",
        "5f6849b3bd264b76844004de",
        "5f6849bf980c2653d22d2d7d",
        "5f6849cfbd264b76844004f9",
        "5f6849da91cfc10f362278ca",
        "5f6849e9980c2653d22d2d99",
        "5f6849f791cfc10f362278e7",
        "5f684a07bd264b7684400516",
        "5f684956980c2653d22d2d5f",
        "5f6849a691cfc10f362278ad",
        "5f6849b3bd264b76844004dc",
        "5f6849bf980c2653d22d2d7c",
        "5f6849cfbd264b76844004fb",
        "5f6849db91cfc10f362278cb",
        "5f6849e9980c2653d22d2d9a",
        "5f6849f791cfc10f362278e8",
        "5f684a07bd264b7684400518",
        "6308ec4c5ce69d50819ff079",
        "6308ed2bcf1542c52f78b583",
        "6308eda8af33d200283532b9",
        "6308edde8ca283c07f2de18b",
        "6308ee93bfa3323159c376ca",
        "6308ef02980d3ebbe3c76439",
        "6308ef3dc2244ca8d3514aed",
        "5f6849f791cfc10f362278e6",
        "6308ec4c5ce69d50819ff076",
        "6308ed2bcf1542c52f78b580",
        "6308eda8af33d200283532b6",
        "6308edde8ca283c07f2de188"
      ],
      "stripe": "price_1QgnfqEy2I3xqILUdYVNvpKC",
      "children": 1,
      "subject": "math_ela_science",
      "cost": {
        "per_month": 3.99,
        "science_per_month": 4.99,
        "total": 1200,
        "sale": 699.99
      },
      "options": {
        "trial": false,
        "updates": true,
        "money_back": true
      },
      "title": "K12 Premium Math & ELA & Science",
      "description": "One-time payment unlocks lifetime access for all your children. Includes every future update and premium feature - invest once, benefit forever. ",
      "button_text": "TRY"
    },
    {
      "exam": "k12",
      "featured": true,
      "period": "month",
      "trial_period_days": 0,
      "premium_material_id": [
        "5f684953980c2653d22d2d4a",
        "5f6849a391cfc10f36227898",
        "5f6849b0bd264b76844004c8",
        "5f6849bc980c2653d22d2d67",
        "5f6849ccbd264b76844004e5",
        "5f6849d891cfc10f362278b5",
        "5f6849e6980c2653d22d2d84",
        "5f6849f491cfc10f362278d2",
        "5f684a04bd264b7684400502",
        "5f684953980c2653d22d2d4b",
        "5f6849a391cfc10f36227899",
        "5f6849b0bd264b76844004c9",
        "5f6849bc980c2653d22d2d68",
        "5f6849ccbd264b76844004e6",
        "5f6849d891cfc10f362278b6",
        "5f6849e6980c2653d22d2d85",
        "5f6849f591cfc10f362278d3",
        "5f684a04bd264b7684400503",
        "5f684954980c2653d22d2d50",
        "5f6849a491cfc10f3622789e",
        "5f6849b1bd264b76844004ce",
        "5f6849bc980c2653d22d2d69",
        "5f6849cdbd264b76844004e7",
        "5f6849d891cfc10f362278b7",
        "5f6849e6980c2653d22d2d86",
        "5f6849f591cfc10f362278d4",
        "5f684a04bd264b7684400504",
        "5f684954980c2653d22d2d4e",
        "5f6849a491cfc10f3622789c",
        "5f6849b1bd264b76844004cc",
        "5f6849bd980c2653d22d2d6b",
        "5f6849cdbd264b76844004e9",
        "5f6849d891cfc10f362278b9",
        "5f6849e7980c2653d22d2d88",
        "5f6849f591cfc10f362278d6",
        "5f684a05bd264b7684400506",
        "5f684954980c2653d22d2d4f",
        "5f6849a491cfc10f3622789d",
        "5f6849b1bd264b76844004cd",
        "5f6849bd980c2653d22d2d6c",
        "5f6849cdbd264b76844004ea",
        "5f6849d891cfc10f362278ba",
        "5f6849e7980c2653d22d2d89",
        "5f6849f591cfc10f362278d7",
        "5f684a05bd264b7684400507",
        "5f684954980c2653d22d2d4c",
        "5f6849a491cfc10f3622789a",
        "5f6849b0bd264b76844004ca",
        "5f6849bd980c2653d22d2d6d",
        "5f6849cdbd264b76844004eb",
        "5f6849d891cfc10f362278bb",
        "5f6849e7980c2653d22d2d8a",
        "5f6849f591cfc10f362278d8",
        "5f684a05bd264b7684400508",
        "5f684953980c2653d22d2d46",
        "5f69e6d86811e903a451a555",
        "5f6849afbd264b76844004c4",
        "5f6849bb980c2653d22d2d63",
        "5f6849ccbd264b76844004e1",
        "5f6849d791cfc10f362278b1",
        "5f6849e6980c2653d22d2d80",
        "5f6849f491cfc10f362278ce",
        "5f684a03bd264b76844004fe",
        "5f684953980c2653d22d2d47",
        "5f69e6d86811e903a451a556",
        "5f6849b0bd264b76844004c5",
        "5f6849bc980c2653d22d2d64",
        "5f6849ccbd264b76844004e2",
        "5f6849d791cfc10f362278b2",
        "5f6849e6980c2653d22d2d81",
        "5f6849f491cfc10f362278cf",
        "5f684a04bd264b76844004ff",
        "5f684953980c2653d22d2d48",
        "5f6849a391cfc10f36227896",
        "5f6849b0bd264b76844004c6",
        "5f6849bc980c2653d22d2d65",
        "5f6849ccbd264b76844004e3",
        "5f6849d791cfc10f362278b3",
        "5f6849e6980c2653d22d2d82",
        "5f6849f491cfc10f362278d0",
        "5f684a04bd264b7684400500",
        "5f684956980c2653d22d2d5e",
        "5f6849a691cfc10f362278ae",
        "5f6849b3bd264b76844004dd",
        "5f6849bf980c2653d22d2d7b",
        "5f6849cfbd264b76844004fa",
        "5f6849da91cfc10f362278c9",
        "5f6849e9980c2653d22d2d98",
        "6308ef7c9429464202c30b93",
        "5f684a07bd264b7684400517",
        "5f684956980c2653d22d2d60",
        "5f6849a691cfc10f362278ac",
        "5f6849b3bd264b76844004de",
        "5f6849bf980c2653d22d2d7d",
        "5f6849cfbd264b76844004f9",
        "5f6849da91cfc10f362278ca",
        "5f6849e9980c2653d22d2d99",
        "5f6849f791cfc10f362278e7",
        "5f684a07bd264b7684400516",
        "5f684956980c2653d22d2d5f",
        "5f6849a691cfc10f362278ad",
        "5f6849b3bd264b76844004dc",
        "5f6849bf980c2653d22d2d7c",
        "5f6849cfbd264b76844004fb",
        "5f6849db91cfc10f362278cb",
        "5f6849e9980c2653d22d2d9a",
        "5f6849f791cfc10f362278e8",
        "5f684a07bd264b7684400518",
        "6308ec4c5ce69d50819ff079",
        "6308ed2bcf1542c52f78b583",
        "6308eda8af33d200283532b9",
        "6308edde8ca283c07f2de18b",
        "6308ee93bfa3323159c376ca",
        "6308ef02980d3ebbe3c76439",
        "6308ef3dc2244ca8d3514aed",
        "5f6849f791cfc10f362278e6",
        "6308ec4c5ce69d50819ff076",
        "6308ed2bcf1542c52f78b580",
        "6308eda8af33d200283532b6",
        "6308edde8ca283c07f2de188"
      ],
      "stripe": "price_1QgnfqEy2I3xqILU1tvo0qHj",
      "children": 2,
      "subject": "math_ela_science",
      "cost": {
        "per_month": 15.588,
        "science_per_month": 5.988,
        "total": 60,
        "sale": 20.376
      },
      "options": {
        "trial": true,
        "updates": false,
        "money_back": false
      },
      "title": "K12 Premium Math & ELA & Science",
      "description": "Perfect for flexible learning - access expert-led lessons, practice questions, and printable workbooks instantly, with no long-term commitment.",
      "button_text": "TRY 3 DAYS FOR FREE"
    },
    {
      "exam": "k12",
      "featured": false,
      "period": "year",
      "trial_period_days": 0,
      "premium_material_id": [
        "5f684953980c2653d22d2d4a",
        "5f6849a391cfc10f36227898",
        "5f6849b0bd264b76844004c8",
        "5f6849bc980c2653d22d2d67",
        "5f6849ccbd264b76844004e5",
        "5f6849d891cfc10f362278b5",
        "5f6849e6980c2653d22d2d84",
        "5f6849f491cfc10f362278d2",
        "5f684a04bd264b7684400502",
        "5f684953980c2653d22d2d4b",
        "5f6849a391cfc10f36227899",
        "5f6849b0bd264b76844004c9",
        "5f6849bc980c2653d22d2d68",
        "5f6849ccbd264b76844004e6",
        "5f6849d891cfc10f362278b6",
        "5f6849e6980c2653d22d2d85",
        "5f6849f591cfc10f362278d3",
        "5f684a04bd264b7684400503",
        "5f684954980c2653d22d2d50",
        "5f6849a491cfc10f3622789e",
        "5f6849b1bd264b76844004ce",
        "5f6849bc980c2653d22d2d69",
        "5f6849cdbd264b76844004e7",
        "5f6849d891cfc10f362278b7",
        "5f6849e6980c2653d22d2d86",
        "5f6849f591cfc10f362278d4",
        "5f684a04bd264b7684400504",
        "5f684954980c2653d22d2d4e",
        "5f6849a491cfc10f3622789c",
        "5f6849b1bd264b76844004cc",
        "5f6849bd980c2653d22d2d6b",
        "5f6849cdbd264b76844004e9",
        "5f6849d891cfc10f362278b9",
        "5f6849e7980c2653d22d2d88",
        "5f6849f591cfc10f362278d6",
        "5f684a05bd264b7684400506",
        "5f684954980c2653d22d2d4f",
        "5f6849a491cfc10f3622789d",
        "5f6849b1bd264b76844004cd",
        "5f6849bd980c2653d22d2d6c",
        "5f6849cdbd264b76844004ea",
        "5f6849d891cfc10f362278ba",
        "5f6849e7980c2653d22d2d89",
        "5f6849f591cfc10f362278d7",
        "5f684a05bd264b7684400507",
        "5f684954980c2653d22d2d4c",
        "5f6849a491cfc10f3622789a",
        "5f6849b0bd264b76844004ca",
        "5f6849bd980c2653d22d2d6d",
        "5f6849cdbd264b76844004eb",
        "5f6849d891cfc10f362278bb",
        "5f6849e7980c2653d22d2d8a",
        "5f6849f591cfc10f362278d8",
        "5f684a05bd264b7684400508",
        "5f684953980c2653d22d2d46",
        "5f69e6d86811e903a451a555",
        "5f6849afbd264b76844004c4",
        "5f6849bb980c2653d22d2d63",
        "5f6849ccbd264b76844004e1",
        "5f6849d791cfc10f362278b1",
        "5f6849e6980c2653d22d2d80",
        "5f6849f491cfc10f362278ce",
        "5f684a03bd264b76844004fe",
        "5f684953980c2653d22d2d47",
        "5f69e6d86811e903a451a556",
        "5f6849b0bd264b76844004c5",
        "5f6849bc980c2653d22d2d64",
        "5f6849ccbd264b76844004e2",
        "5f6849d791cfc10f362278b2",
        "5f6849e6980c2653d22d2d81",
        "5f6849f491cfc10f362278cf",
        "5f684a04bd264b76844004ff",
        "5f684953980c2653d22d2d48",
        "5f6849a391cfc10f36227896",
        "5f6849b0bd264b76844004c6",
        "5f6849bc980c2653d22d2d65",
        "5f6849ccbd264b76844004e3",
        "5f6849d791cfc10f362278b3",
        "5f6849e6980c2653d22d2d82",
        "5f6849f491cfc10f362278d0",
        "5f684a04bd264b7684400500",
        "5f684956980c2653d22d2d5e",
        "5f6849a691cfc10f362278ae",
        "5f6849b3bd264b76844004dd",
        "5f6849bf980c2653d22d2d7b",
        "5f6849cfbd264b76844004fa",
        "5f6849da91cfc10f362278c9",
        "5f6849e9980c2653d22d2d98",
        "6308ef7c9429464202c30b93",
        "5f684a07bd264b7684400517",
        "5f684956980c2653d22d2d60",
        "5f6849a691cfc10f362278ac",
        "5f6849b3bd264b76844004de",
        "5f6849bf980c2653d22d2d7d",
        "5f6849cfbd264b76844004f9",
        "5f6849da91cfc10f362278ca",
        "5f6849e9980c2653d22d2d99",
        "5f6849f791cfc10f362278e7",
        "5f684a07bd264b7684400516",
        "5f684956980c2653d22d2d5f",
        "5f6849a691cfc10f362278ad",
        "5f6849b3bd264b76844004dc",
        "5f6849bf980c2653d22d2d7c",
        "5f6849cfbd264b76844004fb",
        "5f6849db91cfc10f362278cb",
        "5f6849e9980c2653d22d2d9a",
        "5f6849f791cfc10f362278e8",
        "5f684a07bd264b7684400518",
        "6308ec4c5ce69d50819ff079",
        "6308ed2bcf1542c52f78b583",
        "6308eda8af33d200283532b9",
        "6308edde8ca283c07f2de18b",
        "6308ee93bfa3323159c376ca",
        "6308ef02980d3ebbe3c76439",
        "6308ef3dc2244ca8d3514aed",
        "5f6849f791cfc10f362278e6",
        "6308ec4c5ce69d50819ff076",
        "6308ed2bcf1542c52f78b580",
        "6308eda8af33d200283532b6",
        "6308edde8ca283c07f2de188"
      ],
      "stripe": "price_1QgnfqEy2I3xqILULJDkaJHI",
      "children": 2,
      "subject": "math_ela_science",
      "cost": {
        "per_month": 11.988,
        "science_per_month": 5.988,
        "total": 408,
        "sale": 215.712
      },
      "options": {
        "trial": true,
        "updates": true,
        "money_back": false
      },
      "title": "K12 Premium Math & ELA & Science",
      "description": "Most Popular! Save 50% while getting a full year of comprehensive learning. Perfect balance of value and flexibility - complete access to all premium features at our best annual rate.",
      "button_text": "TRY 3 DAYS FOR FREE"
    },
    {
      "exam": "k12",
      "featured": false,
      "period": "lifetime",
      "trial_period_days": 0,
      "premium_material_id": [
        "5f684953980c2653d22d2d4a",
        "5f6849a391cfc10f36227898",
        "5f6849b0bd264b76844004c8",
        "5f6849bc980c2653d22d2d67",
        "5f6849ccbd264b76844004e5",
        "5f6849d891cfc10f362278b5",
        "5f6849e6980c2653d22d2d84",
        "5f6849f491cfc10f362278d2",
        "5f684a04bd264b7684400502",
        "5f684953980c2653d22d2d4b",
        "5f6849a391cfc10f36227899",
        "5f6849b0bd264b76844004c9",
        "5f6849bc980c2653d22d2d68",
        "5f6849ccbd264b76844004e6",
        "5f6849d891cfc10f362278b6",
        "5f6849e6980c2653d22d2d85",
        "5f6849f591cfc10f362278d3",
        "5f684a04bd264b7684400503",
        "5f684954980c2653d22d2d50",
        "5f6849a491cfc10f3622789e",
        "5f6849b1bd264b76844004ce",
        "5f6849bc980c2653d22d2d69",
        "5f6849cdbd264b76844004e7",
        "5f6849d891cfc10f362278b7",
        "5f6849e6980c2653d22d2d86",
        "5f6849f591cfc10f362278d4",
        "5f684a04bd264b7684400504",
        "5f684954980c2653d22d2d4e",
        "5f6849a491cfc10f3622789c",
        "5f6849b1bd264b76844004cc",
        "5f6849bd980c2653d22d2d6b",
        "5f6849cdbd264b76844004e9",
        "5f6849d891cfc10f362278b9",
        "5f6849e7980c2653d22d2d88",
        "5f6849f591cfc10f362278d6",
        "5f684a05bd264b7684400506",
        "5f684954980c2653d22d2d4f",
        "5f6849a491cfc10f3622789d",
        "5f6849b1bd264b76844004cd",
        "5f6849bd980c2653d22d2d6c",
        "5f6849cdbd264b76844004ea",
        "5f6849d891cfc10f362278ba",
        "5f6849e7980c2653d22d2d89",
        "5f6849f591cfc10f362278d7",
        "5f684a05bd264b7684400507",
        "5f684954980c2653d22d2d4c",
        "5f6849a491cfc10f3622789a",
        "5f6849b0bd264b76844004ca",
        "5f6849bd980c2653d22d2d6d",
        "5f6849cdbd264b76844004eb",
        "5f6849d891cfc10f362278bb",
        "5f6849e7980c2653d22d2d8a",
        "5f6849f591cfc10f362278d8",
        "5f684a05bd264b7684400508",
        "5f684953980c2653d22d2d46",
        "5f69e6d86811e903a451a555",
        "5f6849afbd264b76844004c4",
        "5f6849bb980c2653d22d2d63",
        "5f6849ccbd264b76844004e1",
        "5f6849d791cfc10f362278b1",
        "5f6849e6980c2653d22d2d80",
        "5f6849f491cfc10f362278ce",
        "5f684a03bd264b76844004fe",
        "5f684953980c2653d22d2d47",
        "5f69e6d86811e903a451a556",
        "5f6849b0bd264b76844004c5",
        "5f6849bc980c2653d22d2d64",
        "5f6849ccbd264b76844004e2",
        "5f6849d791cfc10f362278b2",
        "5f6849e6980c2653d22d2d81",
        "5f6849f491cfc10f362278cf",
        "5f684a04bd264b76844004ff",
        "5f684953980c2653d22d2d48",
        "5f6849a391cfc10f36227896",
        "5f6849b0bd264b76844004c6",
        "5f6849bc980c2653d22d2d65",
        "5f6849ccbd264b76844004e3",
        "5f6849d791cfc10f362278b3",
        "5f6849e6980c2653d22d2d82",
        "5f6849f491cfc10f362278d0",
        "5f684a04bd264b7684400500",
        "5f684956980c2653d22d2d5e",
        "5f6849a691cfc10f362278ae",
        "5f6849b3bd264b76844004dd",
        "5f6849bf980c2653d22d2d7b",
        "5f6849cfbd264b76844004fa",
        "5f6849da91cfc10f362278c9",
        "5f6849e9980c2653d22d2d98",
        "6308ef7c9429464202c30b93",
        "5f684a07bd264b7684400517",
        "5f684956980c2653d22d2d60",
        "5f6849a691cfc10f362278ac",
        "5f6849b3bd264b76844004de",
        "5f6849bf980c2653d22d2d7d",
        "5f6849cfbd264b76844004f9",
        "5f6849da91cfc10f362278ca",
        "5f6849e9980c2653d22d2d99",
        "5f6849f791cfc10f362278e7",
        "5f684a07bd264b7684400516",
        "5f684956980c2653d22d2d5f",
        "5f6849a691cfc10f362278ad",
        "5f6849b3bd264b76844004dc",
        "5f6849bf980c2653d22d2d7c",
        "5f6849cfbd264b76844004fb",
        "5f6849db91cfc10f362278cb",
        "5f6849e9980c2653d22d2d9a",
        "5f6849f791cfc10f362278e8",
        "5f684a07bd264b7684400518",
        "6308ec4c5ce69d50819ff079",
        "6308ed2bcf1542c52f78b583",
        "6308eda8af33d200283532b9",
        "6308edde8ca283c07f2de18b",
        "6308ee93bfa3323159c376ca",
        "6308ef02980d3ebbe3c76439",
        "6308ef3dc2244ca8d3514aed",
        "5f6849f791cfc10f362278e6",
        "6308ec4c5ce69d50819ff076",
        "6308ed2bcf1542c52f78b580",
        "6308eda8af33d200283532b6",
        "6308edde8ca283c07f2de188"
      ],
      "stripe": "price_1QgnfqEy2I3xqILUrpUwcAL7",
      "children": 2,
      "subject": "math_ela_science",
      "cost": {
        "per_month": 4.788,
        "science_per_month": 5.988,
        "total": 1440,
        "sale": 839.9879999999999
      },
      "options": {
        "trial": false,
        "updates": true,
        "money_back": true
      },
      "title": "K12 Premium Math & ELA & Science",
      "description": "One-time payment unlocks lifetime access for all your children. Includes every future update and premium feature - invest once, benefit forever. ",
      "button_text": "TRY"
    },
    {
      "exam": "k12",
      "featured": true,
      "period": "month",
      "trial_period_days": 0,
      "premium_material_id": [
        "5f684953980c2653d22d2d4a",
        "5f6849a391cfc10f36227898",
        "5f6849b0bd264b76844004c8",
        "5f6849bc980c2653d22d2d67",
        "5f6849ccbd264b76844004e5",
        "5f6849d891cfc10f362278b5",
        "5f6849e6980c2653d22d2d84",
        "5f6849f491cfc10f362278d2",
        "5f684a04bd264b7684400502",
        "5f684953980c2653d22d2d4b",
        "5f6849a391cfc10f36227899",
        "5f6849b0bd264b76844004c9",
        "5f6849bc980c2653d22d2d68",
        "5f6849ccbd264b76844004e6",
        "5f6849d891cfc10f362278b6",
        "5f6849e6980c2653d22d2d85",
        "5f6849f591cfc10f362278d3",
        "5f684a04bd264b7684400503",
        "5f684954980c2653d22d2d50",
        "5f6849a491cfc10f3622789e",
        "5f6849b1bd264b76844004ce",
        "5f6849bc980c2653d22d2d69",
        "5f6849cdbd264b76844004e7",
        "5f6849d891cfc10f362278b7",
        "5f6849e6980c2653d22d2d86",
        "5f6849f591cfc10f362278d4",
        "5f684a04bd264b7684400504",
        "5f684954980c2653d22d2d4e",
        "5f6849a491cfc10f3622789c",
        "5f6849b1bd264b76844004cc",
        "5f6849bd980c2653d22d2d6b",
        "5f6849cdbd264b76844004e9",
        "5f6849d891cfc10f362278b9",
        "5f6849e7980c2653d22d2d88",
        "5f6849f591cfc10f362278d6",
        "5f684a05bd264b7684400506",
        "5f684954980c2653d22d2d4f",
        "5f6849a491cfc10f3622789d",
        "5f6849b1bd264b76844004cd",
        "5f6849bd980c2653d22d2d6c",
        "5f6849cdbd264b76844004ea",
        "5f6849d891cfc10f362278ba",
        "5f6849e7980c2653d22d2d89",
        "5f6849f591cfc10f362278d7",
        "5f684a05bd264b7684400507",
        "5f684954980c2653d22d2d4c",
        "5f6849a491cfc10f3622789a",
        "5f6849b0bd264b76844004ca",
        "5f6849bd980c2653d22d2d6d",
        "5f6849cdbd264b76844004eb",
        "5f6849d891cfc10f362278bb",
        "5f6849e7980c2653d22d2d8a",
        "5f6849f591cfc10f362278d8",
        "5f684a05bd264b7684400508",
        "5f684953980c2653d22d2d46",
        "5f69e6d86811e903a451a555",
        "5f6849afbd264b76844004c4",
        "5f6849bb980c2653d22d2d63",
        "5f6849ccbd264b76844004e1",
        "5f6849d791cfc10f362278b1",
        "5f6849e6980c2653d22d2d80",
        "5f6849f491cfc10f362278ce",
        "5f684a03bd264b76844004fe",
        "5f684953980c2653d22d2d47",
        "5f69e6d86811e903a451a556",
        "5f6849b0bd264b76844004c5",
        "5f6849bc980c2653d22d2d64",
        "5f6849ccbd264b76844004e2",
        "5f6849d791cfc10f362278b2",
        "5f6849e6980c2653d22d2d81",
        "5f6849f491cfc10f362278cf",
        "5f684a04bd264b76844004ff",
        "5f684953980c2653d22d2d48",
        "5f6849a391cfc10f36227896",
        "5f6849b0bd264b76844004c6",
        "5f6849bc980c2653d22d2d65",
        "5f6849ccbd264b76844004e3",
        "5f6849d791cfc10f362278b3",
        "5f6849e6980c2653d22d2d82",
        "5f6849f491cfc10f362278d0",
        "5f684a04bd264b7684400500",
        "5f684956980c2653d22d2d5e",
        "5f6849a691cfc10f362278ae",
        "5f6849b3bd264b76844004dd",
        "5f6849bf980c2653d22d2d7b",
        "5f6849cfbd264b76844004fa",
        "5f6849da91cfc10f362278c9",
        "5f6849e9980c2653d22d2d98",
        "6308ef7c9429464202c30b93",
        "5f684a07bd264b7684400517",
        "5f684956980c2653d22d2d60",
        "5f6849a691cfc10f362278ac",
        "5f6849b3bd264b76844004de",
        "5f6849bf980c2653d22d2d7d",
        "5f6849cfbd264b76844004f9",
        "5f6849da91cfc10f362278ca",
        "5f6849e9980c2653d22d2d99",
        "5f6849f791cfc10f362278e7",
        "5f684a07bd264b7684400516",
        "5f684956980c2653d22d2d5f",
        "5f6849a691cfc10f362278ad",
        "5f6849b3bd264b76844004dc",
        "5f6849bf980c2653d22d2d7c",
        "5f6849cfbd264b76844004fb",
        "5f6849db91cfc10f362278cb",
        "5f6849e9980c2653d22d2d9a",
        "5f6849f791cfc10f362278e8",
        "5f684a07bd264b7684400518",
        "6308ec4c5ce69d50819ff079",
        "6308ed2bcf1542c52f78b583",
        "6308eda8af33d200283532b9",
        "6308edde8ca283c07f2de18b",
        "6308ee93bfa3323159c376ca",
        "6308ef02980d3ebbe3c76439",
        "6308ef3dc2244ca8d3514aed",
        "5f6849f791cfc10f362278e6",
        "6308ec4c5ce69d50819ff076",
        "6308ed2bcf1542c52f78b580",
        "6308eda8af33d200283532b6",
        "6308edde8ca283c07f2de188"
      ],
      "stripe": "price_1QgnfqEy2I3xqILUkKiUQz26",
      "children": 3,
      "subject": "math_ela_science",
      "cost": {
        "per_month": 18.186,
        "science_per_month": 6.986,
        "total": 70,
        "sale": 23.772
      },
      "options": {
        "trial": true,
        "updates": false,
        "money_back": false
      },
      "title": "K12 Premium Math & ELA & Science",
      "description": "Perfect for flexible learning - access expert-led lessons, practice questions, and printable workbooks instantly, with no long-term commitment.",
      "button_text": "TRY 3 DAYS FOR FREE"
    },
    {
      "exam": "k12",
      "featured": false,
      "period": "year",
      "trial_period_days": 0,
      "premium_material_id": [
        "5f684953980c2653d22d2d4a",
        "5f6849a391cfc10f36227898",
        "5f6849b0bd264b76844004c8",
        "5f6849bc980c2653d22d2d67",
        "5f6849ccbd264b76844004e5",
        "5f6849d891cfc10f362278b5",
        "5f6849e6980c2653d22d2d84",
        "5f6849f491cfc10f362278d2",
        "5f684a04bd264b7684400502",
        "5f684953980c2653d22d2d4b",
        "5f6849a391cfc10f36227899",
        "5f6849b0bd264b76844004c9",
        "5f6849bc980c2653d22d2d68",
        "5f6849ccbd264b76844004e6",
        "5f6849d891cfc10f362278b6",
        "5f6849e6980c2653d22d2d85",
        "5f6849f591cfc10f362278d3",
        "5f684a04bd264b7684400503",
        "5f684954980c2653d22d2d50",
        "5f6849a491cfc10f3622789e",
        "5f6849b1bd264b76844004ce",
        "5f6849bc980c2653d22d2d69",
        "5f6849cdbd264b76844004e7",
        "5f6849d891cfc10f362278b7",
        "5f6849e6980c2653d22d2d86",
        "5f6849f591cfc10f362278d4",
        "5f684a04bd264b7684400504",
        "5f684954980c2653d22d2d4e",
        "5f6849a491cfc10f3622789c",
        "5f6849b1bd264b76844004cc",
        "5f6849bd980c2653d22d2d6b",
        "5f6849cdbd264b76844004e9",
        "5f6849d891cfc10f362278b9",
        "5f6849e7980c2653d22d2d88",
        "5f6849f591cfc10f362278d6",
        "5f684a05bd264b7684400506",
        "5f684954980c2653d22d2d4f",
        "5f6849a491cfc10f3622789d",
        "5f6849b1bd264b76844004cd",
        "5f6849bd980c2653d22d2d6c",
        "5f6849cdbd264b76844004ea",
        "5f6849d891cfc10f362278ba",
        "5f6849e7980c2653d22d2d89",
        "5f6849f591cfc10f362278d7",
        "5f684a05bd264b7684400507",
        "5f684954980c2653d22d2d4c",
        "5f6849a491cfc10f3622789a",
        "5f6849b0bd264b76844004ca",
        "5f6849bd980c2653d22d2d6d",
        "5f6849cdbd264b76844004eb",
        "5f6849d891cfc10f362278bb",
        "5f6849e7980c2653d22d2d8a",
        "5f6849f591cfc10f362278d8",
        "5f684a05bd264b7684400508",
        "5f684953980c2653d22d2d46",
        "5f69e6d86811e903a451a555",
        "5f6849afbd264b76844004c4",
        "5f6849bb980c2653d22d2d63",
        "5f6849ccbd264b76844004e1",
        "5f6849d791cfc10f362278b1",
        "5f6849e6980c2653d22d2d80",
        "5f6849f491cfc10f362278ce",
        "5f684a03bd264b76844004fe",
        "5f684953980c2653d22d2d47",
        "5f69e6d86811e903a451a556",
        "5f6849b0bd264b76844004c5",
        "5f6849bc980c2653d22d2d64",
        "5f6849ccbd264b76844004e2",
        "5f6849d791cfc10f362278b2",
        "5f6849e6980c2653d22d2d81",
        "5f6849f491cfc10f362278cf",
        "5f684a04bd264b76844004ff",
        "5f684953980c2653d22d2d48",
        "5f6849a391cfc10f36227896",
        "5f6849b0bd264b76844004c6",
        "5f6849bc980c2653d22d2d65",
        "5f6849ccbd264b76844004e3",
        "5f6849d791cfc10f362278b3",
        "5f6849e6980c2653d22d2d82",
        "5f6849f491cfc10f362278d0",
        "5f684a04bd264b7684400500",
        "5f684956980c2653d22d2d5e",
        "5f6849a691cfc10f362278ae",
        "5f6849b3bd264b76844004dd",
        "5f6849bf980c2653d22d2d7b",
        "5f6849cfbd264b76844004fa",
        "5f6849da91cfc10f362278c9",
        "5f6849e9980c2653d22d2d98",
        "6308ef7c9429464202c30b93",
        "5f684a07bd264b7684400517",
        "5f684956980c2653d22d2d60",
        "5f6849a691cfc10f362278ac",
        "5f6849b3bd264b76844004de",
        "5f6849bf980c2653d22d2d7d",
        "5f6849cfbd264b76844004f9",
        "5f6849da91cfc10f362278ca",
        "5f6849e9980c2653d22d2d99",
        "5f6849f791cfc10f362278e7",
        "5f684a07bd264b7684400516",
        "5f684956980c2653d22d2d5f",
        "5f6849a691cfc10f362278ad",
        "5f6849b3bd264b76844004dc",
        "5f6849bf980c2653d22d2d7c",
        "5f6849cfbd264b76844004fb",
        "5f6849db91cfc10f362278cb",
        "5f6849e9980c2653d22d2d9a",
        "5f6849f791cfc10f362278e8",
        "5f684a07bd264b7684400518",
        "6308ec4c5ce69d50819ff079",
        "6308ed2bcf1542c52f78b583",
        "6308eda8af33d200283532b9",
        "6308edde8ca283c07f2de18b",
        "6308ee93bfa3323159c376ca",
        "6308ef02980d3ebbe3c76439",
        "6308ef3dc2244ca8d3514aed",
        "5f6849f791cfc10f362278e6",
        "6308ec4c5ce69d50819ff076",
        "6308ed2bcf1542c52f78b580",
        "6308eda8af33d200283532b6",
        "6308edde8ca283c07f2de188"
      ],
      "stripe": "price_1QgnfpEy2I3xqILUAigSeDFY",
      "children": 3,
      "subject": "math_ela_science",
      "cost": {
        "per_month": 13.985999999999999,
        "science_per_month": 6.986,
        "total": 475.99999999999994,
        "sale": 251.66399999999996
      },
      "options": {
        "trial": true,
        "updates": true,
        "money_back": false
      },
      "title": "K12 Premium Math & ELA & Science",
      "description": "Most Popular! Save 50% while getting a full year of comprehensive learning. Perfect balance of value and flexibility - complete access to all premium features at our best annual rate.",
      "button_text": "TRY 3 DAYS FOR FREE"
    },
    {
      "exam": "k12",
      "featured": false,
      "period": "lifetime",
      "trial_period_days": 0,
      "premium_material_id": [
        "5f684953980c2653d22d2d4a",
        "5f6849a391cfc10f36227898",
        "5f6849b0bd264b76844004c8",
        "5f6849bc980c2653d22d2d67",
        "5f6849ccbd264b76844004e5",
        "5f6849d891cfc10f362278b5",
        "5f6849e6980c2653d22d2d84",
        "5f6849f491cfc10f362278d2",
        "5f684a04bd264b7684400502",
        "5f684953980c2653d22d2d4b",
        "5f6849a391cfc10f36227899",
        "5f6849b0bd264b76844004c9",
        "5f6849bc980c2653d22d2d68",
        "5f6849ccbd264b76844004e6",
        "5f6849d891cfc10f362278b6",
        "5f6849e6980c2653d22d2d85",
        "5f6849f591cfc10f362278d3",
        "5f684a04bd264b7684400503",
        "5f684954980c2653d22d2d50",
        "5f6849a491cfc10f3622789e",
        "5f6849b1bd264b76844004ce",
        "5f6849bc980c2653d22d2d69",
        "5f6849cdbd264b76844004e7",
        "5f6849d891cfc10f362278b7",
        "5f6849e6980c2653d22d2d86",
        "5f6849f591cfc10f362278d4",
        "5f684a04bd264b7684400504",
        "5f684954980c2653d22d2d4e",
        "5f6849a491cfc10f3622789c",
        "5f6849b1bd264b76844004cc",
        "5f6849bd980c2653d22d2d6b",
        "5f6849cdbd264b76844004e9",
        "5f6849d891cfc10f362278b9",
        "5f6849e7980c2653d22d2d88",
        "5f6849f591cfc10f362278d6",
        "5f684a05bd264b7684400506",
        "5f684954980c2653d22d2d4f",
        "5f6849a491cfc10f3622789d",
        "5f6849b1bd264b76844004cd",
        "5f6849bd980c2653d22d2d6c",
        "5f6849cdbd264b76844004ea",
        "5f6849d891cfc10f362278ba",
        "5f6849e7980c2653d22d2d89",
        "5f6849f591cfc10f362278d7",
        "5f684a05bd264b7684400507",
        "5f684954980c2653d22d2d4c",
        "5f6849a491cfc10f3622789a",
        "5f6849b0bd264b76844004ca",
        "5f6849bd980c2653d22d2d6d",
        "5f6849cdbd264b76844004eb",
        "5f6849d891cfc10f362278bb",
        "5f6849e7980c2653d22d2d8a",
        "5f6849f591cfc10f362278d8",
        "5f684a05bd264b7684400508",
        "5f684953980c2653d22d2d46",
        "5f69e6d86811e903a451a555",
        "5f6849afbd264b76844004c4",
        "5f6849bb980c2653d22d2d63",
        "5f6849ccbd264b76844004e1",
        "5f6849d791cfc10f362278b1",
        "5f6849e6980c2653d22d2d80",
        "5f6849f491cfc10f362278ce",
        "5f684a03bd264b76844004fe",
        "5f684953980c2653d22d2d47",
        "5f69e6d86811e903a451a556",
        "5f6849b0bd264b76844004c5",
        "5f6849bc980c2653d22d2d64",
        "5f6849ccbd264b76844004e2",
        "5f6849d791cfc10f362278b2",
        "5f6849e6980c2653d22d2d81",
        "5f6849f491cfc10f362278cf",
        "5f684a04bd264b76844004ff",
        "5f684953980c2653d22d2d48",
        "5f6849a391cfc10f36227896",
        "5f6849b0bd264b76844004c6",
        "5f6849bc980c2653d22d2d65",
        "5f6849ccbd264b76844004e3",
        "5f6849d791cfc10f362278b3",
        "5f6849e6980c2653d22d2d82",
        "5f6849f491cfc10f362278d0",
        "5f684a04bd264b7684400500",
        "5f684956980c2653d22d2d5e",
        "5f6849a691cfc10f362278ae",
        "5f6849b3bd264b76844004dd",
        "5f6849bf980c2653d22d2d7b",
        "5f6849cfbd264b76844004fa",
        "5f6849da91cfc10f362278c9",
        "5f6849e9980c2653d22d2d98",
        "6308ef7c9429464202c30b93",
        "5f684a07bd264b7684400517",
        "5f684956980c2653d22d2d60",
        "5f6849a691cfc10f362278ac",
        "5f6849b3bd264b76844004de",
        "5f6849bf980c2653d22d2d7d",
        "5f6849cfbd264b76844004f9",
        "5f6849da91cfc10f362278ca",
        "5f6849e9980c2653d22d2d99",
        "5f6849f791cfc10f362278e7",
        "5f684a07bd264b7684400516",
        "5f684956980c2653d22d2d5f",
        "5f6849a691cfc10f362278ad",
        "5f6849b3bd264b76844004dc",
        "5f6849bf980c2653d22d2d7c",
        "5f6849cfbd264b76844004fb",
        "5f6849db91cfc10f362278cb",
        "5f6849e9980c2653d22d2d9a",
        "5f6849f791cfc10f362278e8",
        "5f684a07bd264b7684400518",
        "6308ec4c5ce69d50819ff079",
        "6308ed2bcf1542c52f78b583",
        "6308eda8af33d200283532b9",
        "6308edde8ca283c07f2de18b",
        "6308ee93bfa3323159c376ca",
        "6308ef02980d3ebbe3c76439",
        "6308ef3dc2244ca8d3514aed",
        "5f6849f791cfc10f362278e6",
        "6308ec4c5ce69d50819ff076",
        "6308ed2bcf1542c52f78b580",
        "6308eda8af33d200283532b6",
        "6308edde8ca283c07f2de188"
      ],
      "stripe": "price_1QgnfpEy2I3xqILUMfv7HA7h",
      "children": 3,
      "subject": "math_ela_science",
      "cost": {
        "per_month": 5.586,
        "science_per_month": 6.986,
        "total": 1680,
        "sale": 979.986
      },
      "options": {
        "trial": false,
        "updates": true,
        "money_back": true
      },
      "title": "K12 Premium Math & ELA & Science",
      "description": "One-time payment unlocks lifetime access for all your children. Includes every future update and premium feature - invest once, benefit forever. ",
      "button_text": "TRY"
    },
    {
      "exam": "k12",
      "featured": true,
      "period": "month",
      "trial_period_days": 0,
      "premium_material_id": [
        "5f684953980c2653d22d2d4a",
        "5f6849a391cfc10f36227898",
        "5f6849b0bd264b76844004c8",
        "5f6849bc980c2653d22d2d67",
        "5f6849ccbd264b76844004e5",
        "5f6849d891cfc10f362278b5",
        "5f6849e6980c2653d22d2d84",
        "5f6849f491cfc10f362278d2",
        "5f684a04bd264b7684400502",
        "5f684953980c2653d22d2d4b",
        "5f6849a391cfc10f36227899",
        "5f6849b0bd264b76844004c9",
        "5f6849bc980c2653d22d2d68",
        "5f6849ccbd264b76844004e6",
        "5f6849d891cfc10f362278b6",
        "5f6849e6980c2653d22d2d85",
        "5f6849f591cfc10f362278d3",
        "5f684a04bd264b7684400503",
        "5f684954980c2653d22d2d50",
        "5f6849a491cfc10f3622789e",
        "5f6849b1bd264b76844004ce",
        "5f6849bc980c2653d22d2d69",
        "5f6849cdbd264b76844004e7",
        "5f6849d891cfc10f362278b7",
        "5f6849e6980c2653d22d2d86",
        "5f6849f591cfc10f362278d4",
        "5f684a04bd264b7684400504",
        "5f684954980c2653d22d2d4e",
        "5f6849a491cfc10f3622789c",
        "5f6849b1bd264b76844004cc",
        "5f6849bd980c2653d22d2d6b",
        "5f6849cdbd264b76844004e9",
        "5f6849d891cfc10f362278b9",
        "5f6849e7980c2653d22d2d88",
        "5f6849f591cfc10f362278d6",
        "5f684a05bd264b7684400506",
        "5f684954980c2653d22d2d4f",
        "5f6849a491cfc10f3622789d",
        "5f6849b1bd264b76844004cd",
        "5f6849bd980c2653d22d2d6c",
        "5f6849cdbd264b76844004ea",
        "5f6849d891cfc10f362278ba",
        "5f6849e7980c2653d22d2d89",
        "5f6849f591cfc10f362278d7",
        "5f684a05bd264b7684400507",
        "5f684954980c2653d22d2d4c",
        "5f6849a491cfc10f3622789a",
        "5f6849b0bd264b76844004ca",
        "5f6849bd980c2653d22d2d6d",
        "5f6849cdbd264b76844004eb",
        "5f6849d891cfc10f362278bb",
        "5f6849e7980c2653d22d2d8a",
        "5f6849f591cfc10f362278d8",
        "5f684a05bd264b7684400508",
        "5f684953980c2653d22d2d46",
        "5f69e6d86811e903a451a555",
        "5f6849afbd264b76844004c4",
        "5f6849bb980c2653d22d2d63",
        "5f6849ccbd264b76844004e1",
        "5f6849d791cfc10f362278b1",
        "5f6849e6980c2653d22d2d80",
        "5f6849f491cfc10f362278ce",
        "5f684a03bd264b76844004fe",
        "5f684953980c2653d22d2d47",
        "5f69e6d86811e903a451a556",
        "5f6849b0bd264b76844004c5",
        "5f6849bc980c2653d22d2d64",
        "5f6849ccbd264b76844004e2",
        "5f6849d791cfc10f362278b2",
        "5f6849e6980c2653d22d2d81",
        "5f6849f491cfc10f362278cf",
        "5f684a04bd264b76844004ff",
        "5f684953980c2653d22d2d48",
        "5f6849a391cfc10f36227896",
        "5f6849b0bd264b76844004c6",
        "5f6849bc980c2653d22d2d65",
        "5f6849ccbd264b76844004e3",
        "5f6849d791cfc10f362278b3",
        "5f6849e6980c2653d22d2d82",
        "5f6849f491cfc10f362278d0",
        "5f684a04bd264b7684400500",
        "5f684956980c2653d22d2d5e",
        "5f6849a691cfc10f362278ae",
        "5f6849b3bd264b76844004dd",
        "5f6849bf980c2653d22d2d7b",
        "5f6849cfbd264b76844004fa",
        "5f6849da91cfc10f362278c9",
        "5f6849e9980c2653d22d2d98",
        "6308ef7c9429464202c30b93",
        "5f684a07bd264b7684400517",
        "5f684956980c2653d22d2d60",
        "5f6849a691cfc10f362278ac",
        "5f6849b3bd264b76844004de",
        "5f6849bf980c2653d22d2d7d",
        "5f6849cfbd264b76844004f9",
        "5f6849da91cfc10f362278ca",
        "5f6849e9980c2653d22d2d99",
        "5f6849f791cfc10f362278e7",
        "5f684a07bd264b7684400516",
        "5f684956980c2653d22d2d5f",
        "5f6849a691cfc10f362278ad",
        "5f6849b3bd264b76844004dc",
        "5f6849bf980c2653d22d2d7c",
        "5f6849cfbd264b76844004fb",
        "5f6849db91cfc10f362278cb",
        "5f6849e9980c2653d22d2d9a",
        "5f6849f791cfc10f362278e8",
        "5f684a07bd264b7684400518",
        "6308ec4c5ce69d50819ff079",
        "6308ed2bcf1542c52f78b583",
        "6308eda8af33d200283532b9",
        "6308edde8ca283c07f2de18b",
        "6308ee93bfa3323159c376ca",
        "6308ef02980d3ebbe3c76439",
        "6308ef3dc2244ca8d3514aed",
        "5f6849f791cfc10f362278e6",
        "6308ec4c5ce69d50819ff076",
        "6308ed2bcf1542c52f78b580",
        "6308eda8af33d200283532b6",
        "6308edde8ca283c07f2de188"
      ],
      "stripe": "price_1QgnfpEy2I3xqILUCT2ALR6d",
      "children": 4,
      "subject": "math_ela_science",
      "cost": {
        "per_month": 20.784000000000002,
        "science_per_month": 7.984000000000001,
        "total": 80,
        "sale": 27.168000000000003
      },
      "options": {
        "trial": true,
        "updates": false,
        "money_back": false
      },
      "title": "K12 Premium Math & ELA & Science",
      "description": "Perfect for flexible learning - access expert-led lessons, practice questions, and printable workbooks instantly, with no long-term commitment.",
      "button_text": "TRY 3 DAYS FOR FREE"
    },
    {
      "exam": "k12",
      "featured": false,
      "period": "year",
      "trial_period_days": 0,
      "premium_material_id": [
        "5f684953980c2653d22d2d4a",
        "5f6849a391cfc10f36227898",
        "5f6849b0bd264b76844004c8",
        "5f6849bc980c2653d22d2d67",
        "5f6849ccbd264b76844004e5",
        "5f6849d891cfc10f362278b5",
        "5f6849e6980c2653d22d2d84",
        "5f6849f491cfc10f362278d2",
        "5f684a04bd264b7684400502",
        "5f684953980c2653d22d2d4b",
        "5f6849a391cfc10f36227899",
        "5f6849b0bd264b76844004c9",
        "5f6849bc980c2653d22d2d68",
        "5f6849ccbd264b76844004e6",
        "5f6849d891cfc10f362278b6",
        "5f6849e6980c2653d22d2d85",
        "5f6849f591cfc10f362278d3",
        "5f684a04bd264b7684400503",
        "5f684954980c2653d22d2d50",
        "5f6849a491cfc10f3622789e",
        "5f6849b1bd264b76844004ce",
        "5f6849bc980c2653d22d2d69",
        "5f6849cdbd264b76844004e7",
        "5f6849d891cfc10f362278b7",
        "5f6849e6980c2653d22d2d86",
        "5f6849f591cfc10f362278d4",
        "5f684a04bd264b7684400504",
        "5f684954980c2653d22d2d4e",
        "5f6849a491cfc10f3622789c",
        "5f6849b1bd264b76844004cc",
        "5f6849bd980c2653d22d2d6b",
        "5f6849cdbd264b76844004e9",
        "5f6849d891cfc10f362278b9",
        "5f6849e7980c2653d22d2d88",
        "5f6849f591cfc10f362278d6",
        "5f684a05bd264b7684400506",
        "5f684954980c2653d22d2d4f",
        "5f6849a491cfc10f3622789d",
        "5f6849b1bd264b76844004cd",
        "5f6849bd980c2653d22d2d6c",
        "5f6849cdbd264b76844004ea",
        "5f6849d891cfc10f362278ba",
        "5f6849e7980c2653d22d2d89",
        "5f6849f591cfc10f362278d7",
        "5f684a05bd264b7684400507",
        "5f684954980c2653d22d2d4c",
        "5f6849a491cfc10f3622789a",
        "5f6849b0bd264b76844004ca",
        "5f6849bd980c2653d22d2d6d",
        "5f6849cdbd264b76844004eb",
        "5f6849d891cfc10f362278bb",
        "5f6849e7980c2653d22d2d8a",
        "5f6849f591cfc10f362278d8",
        "5f684a05bd264b7684400508",
        "5f684953980c2653d22d2d46",
        "5f69e6d86811e903a451a555",
        "5f6849afbd264b76844004c4",
        "5f6849bb980c2653d22d2d63",
        "5f6849ccbd264b76844004e1",
        "5f6849d791cfc10f362278b1",
        "5f6849e6980c2653d22d2d80",
        "5f6849f491cfc10f362278ce",
        "5f684a03bd264b76844004fe",
        "5f684953980c2653d22d2d47",
        "5f69e6d86811e903a451a556",
        "5f6849b0bd264b76844004c5",
        "5f6849bc980c2653d22d2d64",
        "5f6849ccbd264b76844004e2",
        "5f6849d791cfc10f362278b2",
        "5f6849e6980c2653d22d2d81",
        "5f6849f491cfc10f362278cf",
        "5f684a04bd264b76844004ff",
        "5f684953980c2653d22d2d48",
        "5f6849a391cfc10f36227896",
        "5f6849b0bd264b76844004c6",
        "5f6849bc980c2653d22d2d65",
        "5f6849ccbd264b76844004e3",
        "5f6849d791cfc10f362278b3",
        "5f6849e6980c2653d22d2d82",
        "5f6849f491cfc10f362278d0",
        "5f684a04bd264b7684400500",
        "5f684956980c2653d22d2d5e",
        "5f6849a691cfc10f362278ae",
        "5f6849b3bd264b76844004dd",
        "5f6849bf980c2653d22d2d7b",
        "5f6849cfbd264b76844004fa",
        "5f6849da91cfc10f362278c9",
        "5f6849e9980c2653d22d2d98",
        "6308ef7c9429464202c30b93",
        "5f684a07bd264b7684400517",
        "5f684956980c2653d22d2d60",
        "5f6849a691cfc10f362278ac",
        "5f6849b3bd264b76844004de",
        "5f6849bf980c2653d22d2d7d",
        "5f6849cfbd264b76844004f9",
        "5f6849da91cfc10f362278ca",
        "5f6849e9980c2653d22d2d99",
        "5f6849f791cfc10f362278e7",
        "5f684a07bd264b7684400516",
        "5f684956980c2653d22d2d5f",
        "5f6849a691cfc10f362278ad",
        "5f6849b3bd264b76844004dc",
        "5f6849bf980c2653d22d2d7c",
        "5f6849cfbd264b76844004fb",
        "5f6849db91cfc10f362278cb",
        "5f6849e9980c2653d22d2d9a",
        "5f6849f791cfc10f362278e8",
        "5f684a07bd264b7684400518",
        "6308ec4c5ce69d50819ff079",
        "6308ed2bcf1542c52f78b583",
        "6308eda8af33d200283532b9",
        "6308edde8ca283c07f2de18b",
        "6308ee93bfa3323159c376ca",
        "6308ef02980d3ebbe3c76439",
        "6308ef3dc2244ca8d3514aed",
        "5f6849f791cfc10f362278e6",
        "6308ec4c5ce69d50819ff076",
        "6308ed2bcf1542c52f78b580",
        "6308eda8af33d200283532b6",
        "6308edde8ca283c07f2de188"
      ],
      "stripe": "price_1QgnfpEy2I3xqILU9EOSifSe",
      "children": 4,
      "subject": "math_ela_science",
      "cost": {
        "per_month": 15.984000000000002,
        "science_per_month": 7.984000000000001,
        "total": 544,
        "sale": 287.616
      },
      "options": {
        "trial": true,
        "updates": true,
        "money_back": false
      },
      "title": "K12 Premium Math & ELA & Science",
      "description": "Most Popular! Save 50% while getting a full year of comprehensive learning. Perfect balance of value and flexibility - complete access to all premium features at our best annual rate.",
      "button_text": "TRY 3 DAYS FOR FREE"
    },
    {
      "exam": "k12",
      "featured": false,
      "period": "lifetime",
      "trial_period_days": 0,
      "premium_material_id": [
        "5f684953980c2653d22d2d4a",
        "5f6849a391cfc10f36227898",
        "5f6849b0bd264b76844004c8",
        "5f6849bc980c2653d22d2d67",
        "5f6849ccbd264b76844004e5",
        "5f6849d891cfc10f362278b5",
        "5f6849e6980c2653d22d2d84",
        "5f6849f491cfc10f362278d2",
        "5f684a04bd264b7684400502",
        "5f684953980c2653d22d2d4b",
        "5f6849a391cfc10f36227899",
        "5f6849b0bd264b76844004c9",
        "5f6849bc980c2653d22d2d68",
        "5f6849ccbd264b76844004e6",
        "5f6849d891cfc10f362278b6",
        "5f6849e6980c2653d22d2d85",
        "5f6849f591cfc10f362278d3",
        "5f684a04bd264b7684400503",
        "5f684954980c2653d22d2d50",
        "5f6849a491cfc10f3622789e",
        "5f6849b1bd264b76844004ce",
        "5f6849bc980c2653d22d2d69",
        "5f6849cdbd264b76844004e7",
        "5f6849d891cfc10f362278b7",
        "5f6849e6980c2653d22d2d86",
        "5f6849f591cfc10f362278d4",
        "5f684a04bd264b7684400504",
        "5f684954980c2653d22d2d4e",
        "5f6849a491cfc10f3622789c",
        "5f6849b1bd264b76844004cc",
        "5f6849bd980c2653d22d2d6b",
        "5f6849cdbd264b76844004e9",
        "5f6849d891cfc10f362278b9",
        "5f6849e7980c2653d22d2d88",
        "5f6849f591cfc10f362278d6",
        "5f684a05bd264b7684400506",
        "5f684954980c2653d22d2d4f",
        "5f6849a491cfc10f3622789d",
        "5f6849b1bd264b76844004cd",
        "5f6849bd980c2653d22d2d6c",
        "5f6849cdbd264b76844004ea",
        "5f6849d891cfc10f362278ba",
        "5f6849e7980c2653d22d2d89",
        "5f6849f591cfc10f362278d7",
        "5f684a05bd264b7684400507",
        "5f684954980c2653d22d2d4c",
        "5f6849a491cfc10f3622789a",
        "5f6849b0bd264b76844004ca",
        "5f6849bd980c2653d22d2d6d",
        "5f6849cdbd264b76844004eb",
        "5f6849d891cfc10f362278bb",
        "5f6849e7980c2653d22d2d8a",
        "5f6849f591cfc10f362278d8",
        "5f684a05bd264b7684400508",
        "5f684953980c2653d22d2d46",
        "5f69e6d86811e903a451a555",
        "5f6849afbd264b76844004c4",
        "5f6849bb980c2653d22d2d63",
        "5f6849ccbd264b76844004e1",
        "5f6849d791cfc10f362278b1",
        "5f6849e6980c2653d22d2d80",
        "5f6849f491cfc10f362278ce",
        "5f684a03bd264b76844004fe",
        "5f684953980c2653d22d2d47",
        "5f69e6d86811e903a451a556",
        "5f6849b0bd264b76844004c5",
        "5f6849bc980c2653d22d2d64",
        "5f6849ccbd264b76844004e2",
        "5f6849d791cfc10f362278b2",
        "5f6849e6980c2653d22d2d81",
        "5f6849f491cfc10f362278cf",
        "5f684a04bd264b76844004ff",
        "5f684953980c2653d22d2d48",
        "5f6849a391cfc10f36227896",
        "5f6849b0bd264b76844004c6",
        "5f6849bc980c2653d22d2d65",
        "5f6849ccbd264b76844004e3",
        "5f6849d791cfc10f362278b3",
        "5f6849e6980c2653d22d2d82",
        "5f6849f491cfc10f362278d0",
        "5f684a04bd264b7684400500",
        "5f684956980c2653d22d2d5e",
        "5f6849a691cfc10f362278ae",
        "5f6849b3bd264b76844004dd",
        "5f6849bf980c2653d22d2d7b",
        "5f6849cfbd264b76844004fa",
        "5f6849da91cfc10f362278c9",
        "5f6849e9980c2653d22d2d98",
        "6308ef7c9429464202c30b93",
        "5f684a07bd264b7684400517",
        "5f684956980c2653d22d2d60",
        "5f6849a691cfc10f362278ac",
        "5f6849b3bd264b76844004de",
        "5f6849bf980c2653d22d2d7d",
        "5f6849cfbd264b76844004f9",
        "5f6849da91cfc10f362278ca",
        "5f6849e9980c2653d22d2d99",
        "5f6849f791cfc10f362278e7",
        "5f684a07bd264b7684400516",
        "5f684956980c2653d22d2d5f",
        "5f6849a691cfc10f362278ad",
        "5f6849b3bd264b76844004dc",
        "5f6849bf980c2653d22d2d7c",
        "5f6849cfbd264b76844004fb",
        "5f6849db91cfc10f362278cb",
        "5f6849e9980c2653d22d2d9a",
        "5f6849f791cfc10f362278e8",
        "5f684a07bd264b7684400518",
        "6308ec4c5ce69d50819ff079",
        "6308ed2bcf1542c52f78b583",
        "6308eda8af33d200283532b9",
        "6308edde8ca283c07f2de18b",
        "6308ee93bfa3323159c376ca",
        "6308ef02980d3ebbe3c76439",
        "6308ef3dc2244ca8d3514aed",
        "5f6849f791cfc10f362278e6",
        "6308ec4c5ce69d50819ff076",
        "6308ed2bcf1542c52f78b580",
        "6308eda8af33d200283532b6",
        "6308edde8ca283c07f2de188"
      ],
      "stripe": "price_1QgnfpEy2I3xqILUlWiDwvf5",
      "children": 4,
      "subject": "math_ela_science",
      "cost": {
        "per_month": 6.384,
        "science_per_month": 7.984000000000001,
        "total": 1920,
        "sale": 1119.9840000000002
      },
      "options": {
        "trial": false,
        "updates": true,
        "money_back": true
      },
      "title": "K12 Premium Math & ELA & Science",
      "description": "One-time payment unlocks lifetime access for all your children. Includes every future update and premium feature - invest once, benefit forever. ",
      "button_text": "TRY"
    },
    {
      "exam": "shsat",
      "featured": false,
      "period": "halfyear",
      "premium_material_id": "6728938edcca0c1ea1dde559",
      "stripe": "price_1QgnpAEy2I3xqILUW9iHAKvg",
      "children": 1,
      "subject": "math_ela",
      "cost": {
        "per_month": 41.66,
        "total": 400,
        "sale": 249.99
      },
      "options": {
        "trial": true,
        "updates": false,
        "money_back": false
      },
      "title": "SHSAT Premium Math & ELA",
      "description": "You will get unlimited access to all our premium video lectures, practice questions, and quizzes.",
      "button_text": "TRY FOR FREE"
    },
    {
      "exam": "shsat",
      "featured": true,
      "period": "year",
      "premium_material_id": "6728938edcca0c1ea1dde559",
      "stripe": "price_1QgnpAEy2I3xqILU7dmt3UHn",
      "children": 1,
      "subject": "math_ela",
      "cost": {
        "per_month": 33.33,
        "total": 600,
        "sale": 399.99
      },
      "options": {
        "trial": true,
        "updates": true,
        "money_back": false
      },
      "title": "SHSAT Premium Math & ELA",
      "description": "You will save 20% by choosing this plan, and get unlimited access to all our premium video lectures, practice questions, and quizzes. This is a great balance between price and access time.",
      "button_text": "TRY FOR FREE"
    },
    {
      "exam": "shsat",
      "featured": false,
      "period": "month",
      "premium_material_id": "6728938edcca0c1ea1dde559",
      "stripe": "price_1QgnpAEy2I3xqILUoY62Au7Q",
      "children": 1,
      "subject": "math_ela",
      "cost": {
        "per_month": 49.99,
        "total": 70,
        "sale": 49.99
      },
      "options": {
        "trial": false,
        "updates": true,
        "money_back": true
      },
      "title": "SHSAT Premium Math & ELA",
      "description": "This plan is for those who love to have access on demand. You will get unlimited access to all our premium video lectures, practice questions, and quizzes. A great option for those who focus on goals and get things done.",
      "button_text": "TRY FOR FREE"
    }
  ]
};

@State<PlansModel>({
  name: 'V12_APO_PLANS',
  defaults: _PlansDefault,
})
@Injectable()
export class PlansState implements NgxsOnInit, NgxsOnChanges {

  constructor() {}

  ngxsOnInit(ctx?: StateContext<any>): any {}
  ngxsOnChanges(change: NgxsSimpleChange<PlansModel>): void {}


  @Selector()
  static selectPlans( state: PlansModel) {
    return state.list;
  }
}
